/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateSignUrlDto {
  key: string;
  bucket: string;
  expiresIn: number;
  /** @default false */
  isVideo: boolean;
}

export interface NotificationResponse {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type:
    | "APPROVED_HOST_PROFILE"
    | "REJECTED_HOST_PROFILE"
    | "CALENDAR_BOOKING_HOST_CANCELED"
    | "CALENDAR_BOOKING_USER_CANCELED"
    | "CALENDAR_BOOKING_REMIND_REPLY"
    | "HOST_PROFILE_APPROVED"
    | "HOST_PROFILE_REJECTED"
    | "HOST_PROFILE_JOIN_ORGANIZATION_APPROVED"
    | "HOST_PROFILE_JOIN_ORGANIZATION_REJECTED"
    | "HOST_PRODUCT_SOLD"
    | "PAYMENT_SUCCESS"
    | "PAYMENT_FAILED"
    | "PAYMENT_SUCCESS_FREE"
    | "PAYMENT_TOKEN_DELETED"
    | "EVENT_APPROVED"
    | "EVENT_REJECTED"
    | "EVENT_STARTED"
    | "EVENT_HOST_REMINDER"
    | "EVENT_TICKET_CHECKED_IN"
    | "CALENDAR_APPROVED"
    | "CALENDAR_REJECTED"
    | "CALENDAR_STARTED"
    | "CALENDAR_BOOKING_APPROVED"
    | "CALENDAR_BOOKING_REJECTED"
    | "CALENDAR_BOOKING_NEW"
    | "CALENDAR_REMINDER"
    | "CALENDAR_REMINDER_APPROVED"
    | "CALENDAR_HOST_SUGGEST_APPROVED"
    | "ONLINE_COURSE_APPROVED"
    | "ONLINE_COURSE_REJECTED"
    | "ONLINE_COURSE_UNLOCK"
    | "BLOG_APPROVED"
    | "BLOG_REJECTED"
    | "PROJECT_APPROVED"
    | "PROJECT_REJECTED"
    | "FOLLOWING_HOST_NEW_EVENT"
    | "FOLLOWING_HOST_NEW_CALENDAR"
    | "FOLLOWING_HOST_NEW_BLOG"
    | "FOLLOWING_HOST_NEW_PROJECT"
    | "NEW_FOLLOWER"
    | "REFUND_SUCCESS"
    | "REFUND_FAILED"
    | "SUBSCRIPTION_RENEWAL"
    | "SUBSCRIPTION_RENEWAL_FAILED"
    | "SUBSCRIPTION_RENEWAL_SUCCESS"
    | "SUBSCRIPTION_FIRST_PAYMENT_SUCCESS"
    | "SUBSCRIPTION_FIRST_PAYMENT_FAILED"
    | "SUBSCRIPTION_CANCELLED"
    | "SUBSCRIPTION_TIMEOUT"
    | "MEMBERSHIP_PLAN_PRICE_CHANGED"
    | "MEMBERSHIP_PLAN_PERIOD_CHANGED"
    | "MEMBERSHIP_PLAN_ALL_CHANGED"
    | "LAYOFF_DISCOUNT_REQUESTED"
    | "LAYOFF_DISCOUNT_APPROVED"
    | "LAYOFF_DISCOUNT_REJECTED"
    | "RESKILL_REMINDER"
    | "RESKILL_EXPIRED";
  role:
    | "SUPER_ADMIN"
    | "ADMIN"
    | "PRODUCT_OWNER"
    | "ACA_PARTNER"
    | "MARKETING"
    | "SALE"
    | "HOST"
    | "USER";
  read: boolean | null;
  icon: string | null;
  title: string;
  description: string | null;
  webUrl: string | null;
}

export interface PaginatedResponseClass {
  /** @example 150 */
  total: number;
  /** @example 10 */
  page: number;
  /** @example 10 */
  limit: number;
  /** @example 10 */
  skip: number;
  /** @example 15 */
  pages: number;
  /** Array of items */
  items: NotificationResponse[];
}

export interface CountNotificationResponse {
  total: number;
  USER: number;
  HOST: number;
}

export interface UnreadNotificationResponse {
  total: number;
}

export interface UpdateNotificationInput {
  read: boolean;
}

export interface MaskReadAllResponse {
  success: boolean;
}

export interface CreateNotificationTokenDto {
  fcmToken: string;
}

export interface BulkDeletedNotificationTokenDto {
  notificationToken: string[];
}

export interface CredentialsDto {
  email: string;
  /**
   * @minLength 6
   * @maxLength 30
   */
  password: string;
}

/** Error code indicating the type of error */
export enum ErrorCode {
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  INVALID_REQUEST = "INVALID_REQUEST",
  INVALID_OTP = "INVALID_OTP",
  OTP_EXPIRED = "OTP_EXPIRED",
  OTP_NOT_FOUND = "OTP_NOT_FOUND",
  OTP_MAX_RETRIES = "OTP_MAX_RETRIES",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  USER_LOCKED = "USER_LOCKED",
  USER_INACTIVATED = "USER_INACTIVATED",
  USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS",
  INVALID_USER = "INVALID_USER",
  INVALID_PASSWORD = "INVALID_PASSWORD",
  PASSWORDS_MATCH = "PASSWORDS_MATCH",
  CONFIRM_PASSWORDS = "CONFIRM_PASSWORDS",
  INVALID_PASSWORD_FORMAT = "INVALID_PASSWORD_FORMAT",
  INVALID = "INVALID",
  INVALID_REFRESH_TOKEN = "INVALID_REFRESH_TOKEN",
  INVALID_EMAIL = "INVALID_EMAIL",
  INVALID_PHONE = "INVALID_PHONE",
  INVALID_NAME = "INVALID_NAME",
  INVALID_ADDRESS = "INVALID_ADDRESS",
  INVALID_CITY = "INVALID_CITY",
  DUPLICATE_RECORD = "DUPLICATE_RECORD",
  INVALID_INPUT_PARAMS = "INVALID_INPUT_PARAMS",
  NO_ITEM_PURCHASED = "NO_ITEM_PURCHASED",
  INVALID_ITEM_PURCHASED = "INVALID_ITEM_PURCHASED",
  TICKET_SOLDE_OUT = "TICKET_SOLDE_OUT",
  TICKET_NOT_FOUND = "TICKET_NOT_FOUND",
  TICKET_INIT_POOL_FAILED = "TICKET_INIT_POOL_FAILED",
  TICKET_ALREADY_HOLD = "TICKET_ALREADY_HOLD",
  INVALID_VOUCHER = "INVALID_VOUCHER",
  VOUCHER_NOT_FOUND = "VOUCHER_NOT_FOUND",
  VOUCHER_CODE_EXISTS = "VOUCHER_CODE_EXISTS",
  VOUCHER_NOT_APPLICABLE = "VOUCHER_NOT_APPLICABLE",
  VOUCHER_INACTIVE = "VOUCHER_INACTIVE",
  VOUCHER_NOT_STARTED = "VOUCHER_NOT_STARTED",
  VOUCHER_EXPIRED = "VOUCHER_EXPIRED",
  VOUCHER_USAGE_LIMIT_REACHED = "VOUCHER_USAGE_LIMIT_REACHED",
  VOUCHER_PRODUCT_DUPLICATED = "VOUCHER_PRODUCT_DUPLICATED",
  VOUCHER_PRODUCT_RESTRICTION = "VOUCHER_PRODUCT_RESTRICTION",
  INVALID_PRODUCT_ITEM = "INVALID_PRODUCT_ITEM",
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  ACCOUNT_NOT_VERIFIED = "ACCOUNT_NOT_VERIFIED",
  EMAIL_ALREADY_IN_USE = "EMAIL_ALREADY_IN_USE",
  ACCOUNT_ALREADY_USER = "ACCOUNT_ALREADY_USER",
  ACCOUNT_ALREADY_HOST = "ACCOUNT_ALREADY_HOST",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ACCOUNT_LOCKED = "ACCOUNT_LOCKED",
  ACCOUNT_VERIFIED = "ACCOUNT_VERIFIED",
  ACCOUNT_VERIFICATION_FAILED = "ACCOUNT_VERIFICATION_FAILED",
  INVALID_LOGIN_METHOD = "INVALID_LOGIN_METHOD",
  EMAIL_IN_USE_DIFFERENT_METHOD = "EMAIL_IN_USE_DIFFERENT_METHOD",
  OLD_PASSWORD_DIFF_NEW_PASSWORD = "OLD_PASSWORD_DIFF_NEW_PASSWORD",
  NEW_PASSWORD_SAME_AS_OLD_PASSWORD = "NEW_PASSWORD_SAME_AS_OLD_PASSWORD",
  CONFIRM_PASSWORD_DIFF = "CONFIRM_PASSWORD_DIFF",
  OLD_PASSWORD_INCORRECT = "OLD_PASSWORD_INCORRECT",
  INSUFFICIENT_PRIVILEGES = "INSUFFICIENT_PRIVILEGES",
  NOT_OWNER = "NOT_OWNER",
  PHONE_NUMBER_NOT_UPDATED = "PHONE_NUMBER_NOT_UPDATED",
  PHONE_NUMBER_ALREADY_IN_USE = "PHONE_NUMBER_ALREADY_IN_USE",
  PASSWORD_ALREADY_CONFIGURED = "PASSWORD_ALREADY_CONFIGURED",
  EVENT_NOT_FOUND = "EVENT_NOT_FOUND",
  EVENT_SESSION_NOT_FOUND = "EVENT_SESSION_NOT_FOUND",
  EVENT_CREATE_FAILED = "EVENT_CREATE_FAILED",
  EVENT_DRAFT_FAILED = "EVENT_DRAFT_FAILED",
  EVENT_UPDATE_FAILED = "EVENT_UPDATE_FAILED",
  PRODUCT_NOT_FOUND = "PRODUCT_NOT_FOUND",
  HOST_PROFILE_NOT_FOUND = "HOST_PROFILE_NOT_FOUND",
  ONLINE_COURSE_NOT_FOUND = "ONLINE_COURSE_NOT_FOUND",
  MEMBERSHIP_NOT_FOUND = "MEMBERSHIP_NOT_FOUND",
  MEMBERSHIP_PRICE_NOT_FOUND = "MEMBERSHIP_PRICE_NOT_FOUND",
  MEMBERSHIP_NO_PRODUCTS = "MEMBERSHIP_NO_PRODUCTS",
  MEMBERSHIP_DEFAULT_CANNOT_INACTIVE = "MEMBERSHIP_DEFAULT_CANNOT_INACTIVE",
  MEMBERSHIP_CANNOT_DELETE = "MEMBERSHIP_CANNOT_DELETE",
  MEMBERSHIP_PRICE_HAS_PAID_CANNOT_DELETE = "MEMBERSHIP_PRICE_HAS_PAID_CANNOT_DELETE",
  MEMBERSHIP_PART_NOT_FOUND = "MEMBERSHIP_PART_NOT_FOUND",
  SUBSCRIPTION_NOT_FOUND = "SUBSCRIPTION_NOT_FOUND",
  SUBSCRIPTION_ALREADY_ACTIVE = "SUBSCRIPTION_ALREADY_ACTIVE",
  SUBSCRIPTION_HAS_PENDING_PAYMENTS = "SUBSCRIPTION_HAS_PENDING_PAYMENTS",
  SUBSCRIPTION_EXPIRED = "SUBSCRIPTION_EXPIRED",
  RECURRING_PAYMENT_FAILED = "RECURRING_PAYMENT_FAILED",
  NO_VALID_PERIOD = "NO_VALID_PERIOD",
  SUBSCRIPTION_PERIOD_NOT_FOUND = "SUBSCRIPTION_PERIOD_NOT_FOUND",
  SUBSCRIPTION_CARD_TOKEN_NOT_FOUND = "SUBSCRIPTION_CARD_TOKEN_NOT_FOUND",
  SUBSCRIPTION_ALREADY_LIFETIME = "SUBSCRIPTION_ALREADY_LIFETIME",
  DISCOUNT_NOT_FOUND = "DISCOUNT_NOT_FOUND",
  DISCOUNT_PRODUCT_DUPLICATED = "DISCOUNT_PRODUCT_DUPLICATED",
  EMAIL_COLLECTION_ALREADY_EXISTS = "EMAIL_COLLECTION_ALREADY_EXISTS",
  RESKILL_NOT_FOUND = "RESKILL_NOT_FOUND",
  RESKILL_HAS_PRODUCTS = "RESKILL_HAS_PRODUCTS",
  PRODUCT_IDS_REQUIRED = "PRODUCT_IDS_REQUIRED",
  RESKILL_HAS_BEEN_PAID = "RESKILL_HAS_BEEN_PAID",
  RESKILL_PRICE_NOT_FOUND = "RESKILL_PRICE_NOT_FOUND",
  SURVEY_NOT_FOUND = "SURVEY_NOT_FOUND",
  SURVEY_HAS_RESPONSES = "SURVEY_HAS_RESPONSES",
  SURVEY_REQUIRED_AUTHORIZATION = "SURVEY_REQUIRED_AUTHORIZATION",
  SURVEY_ALREADY_SUBMITTED = "SURVEY_ALREADY_SUBMITTED",
  SURVEY_VALIDATION_FAILED = "SURVEY_VALIDATION_FAILED",
  SURVEY_LINKED_TO_PRODUCTS = "SURVEY_LINKED_TO_PRODUCTS",
  SURVEY_RESULT_NOT_FOUND = "SURVEY_RESULT_NOT_FOUND",
  SURVEY_EMAIL_REQUIRED = "SURVEY_EMAIL_REQUIRED",
  COURSE_VALIDATION_ERROR = "COURSE_VALIDATION_ERROR",
}

export interface ErrorResponseDto {
  /** Error code indicating the type of error */
  code: ErrorCode;
  /**
   * Error message describing the error
   * @example "Invalid city"
   */
  message?: string;
}

export interface CredentialsSocialDto {
  provider: "CREDENTIALS" | "GOOGLE" | "FACEBOOK" | "TWITTER" | "APPLE";
  token: string;
  email?: string;
  /** @minLength 1 */
  fullName?: string;
}

export interface VerifyRequestDto {
  check: string;
  type: string;
}

export interface VerifyDto {
  check: string;
  otp: string;
  verificationKey: string;
  type: string;
}

export interface UserEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  gender: "MALE" | "FEMALE" | "OTHER";
  /** @default ["EMAIL"] */
  verifiedBy: ("EMAIL" | "PHONE")[];
  /**
   * @format date-time
   * @example "2025-12-30T10:35:22.030Z"
   */
  dateOfBirth: string;
  job?: string;
  avatar?: string;
  coverPhoto?: string;
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  tiktok?: string;
  twitter?: string;
  youtube?: string;
  website?: string;
  knowledge: string[];
  skills: string[];
  intro?: string;
  introPhotos: string[];
  description?: string;
  emailContact?: string;
  fromAddress?: string;
  workAddress?: string;
  /** @format date-time */
  lastLoginAt?: string;
  fullName: string | null;
  email: string;
  username: string;
  phone: string;
  id: string;
}

export interface HostDto {
  id: string;
  username: string;
  fullName: string;
  avatar?: string;
  email?: string;
  phone?: string;
}

export interface UpdateProfileDto {
  gender?: "MALE" | "FEMALE" | "OTHER";
  username?: string;
  fullName?: string;
  avatar?: string;
  coverPhoto?: string;
  /** @format date-time */
  dateOfBirth?: string;
  job?: string;
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  tiktok?: string;
  twitter?: string;
  youtube?: string;
  website?: string;
  knowledge?: string[];
  skills?: string[];
  intro?: string;
  introPhotos?: string[];
  description?: string;
  emailContact?: string;
  fromAddress?: string;
  workAddress?: string;
  experience?: number;
  linkReferences?: string[];
  registrationTopic?: string;
}

export interface UpdatePhoneDto {
  verificationKey?: string;
  /** @minLength 6 */
  otp?: string;
  phone: string;
}

export type ChangePasswordDto = object;

export interface ConfigurePasswordDto {
  /**
   * @minLength 6
   * @maxLength 30
   */
  password: string;
  /**
   * @minLength 6
   * @maxLength 30
   */
  confirmPassword: string;
  /** @minLength 6 */
  otp: string;
  verificationKey: string;
}

export type SetPasswordDto = object;

export interface GetOwnOtpDto {
  type: "EMAIL" | "SMS" | "ZNS";
  action:
    | "VERIFY_EMAIL"
    | "VERIFY_PHONE"
    | "FORGOT_PASSWORD"
    | "TERMINATE_ACCOUNT"
    | "CHANGE_PASSWORD";
}

export interface SignupDto {
  /** @minLength 1 */
  fullName: string;
  email: string;
  /**
   * @minLength 6
   * @maxLength 30
   */
  password: string;
}

export interface SignUpResponseDto {
  success: boolean;
}

export interface ForgotPasswordDto {
  /**
   * The email of the User
   * @format email
   * @minLength 5
   * @maxLength 255
   * @uniqueItems true
   * @example "email@example.com"
   */
  email: string;
}

export interface ResetPasswordDto {
  /**
   * The password of the User
   * @format string
   * @minLength 6
   * @maxLength 30
   * @example "secret password change me!"
   */
  password: string;
  check: string;
  verificationKey: string;
  otp: string;
}

export interface MembershipPriceDTO {
  id: string;
  name?: string | null;
  periodValue: number;
  amount: number;
  order: number;
  isPublic: boolean;
  periodType: string;
  paidCount: number;
  productId: string | null;
}

export enum MembershipStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface MembershipDTO {
  id: string;
  name: string;
  isMain: boolean;
  description: string | null;
  status: MembershipStatus;
  paidCount: number;
}

export interface BaseProgressDTO {
  /**
   * Progress completion percentage (0-100)
   * @min 0
   * @max 100
   */
  completedPercentage: number;
  /**
   * Current position in seconds (for video/audio content)
   * @min 0
   */
  currentPosition?: number;
}

export interface UserSubscriptionDto {
  id: string;
  status:
    | "PENDING"
    | "ACTIVE"
    | "FAILED"
    | "CANCEL"
    | "EXPIRED"
    | "PENDING_RENEWAL";
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  /** @format date-time */
  lastPaymentAt?: string | null;
  /** @format date-time */
  cancelledAt?: string | null;
  membershipPrice: MembershipPriceDTO;
  membership: MembershipDTO;
  isActive: boolean;
  progress: BaseProgressDTO;
}

export interface SubscriptionPlanDTO {
  id: string;
  name?: string | null;
  periodValue: number;
  amount: number;
  order: number;
  isPublic: boolean;
  periodType: string;
  paidCount: number;
  productId: string | null;
  isSelected: boolean;
  isDisabled: boolean;
}

export enum CareerType {
  RESKILL = "RESKILL",
  LAUNCHPAD = "LAUNCHPAD",
}

export interface MyReskillDTO {
  id: string;
  name: string;
  banner: string;
  type: CareerType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  expiredAt: string;
  reskillPriceId: string;
  progress: BaseProgressDTO;
}

export enum ProductType {
  CALENDAR = "CALENDAR",
  CALENDAR_FRAME = "CALENDAR_FRAME",
  COMBO = "COMBO",
  ONLINE_COURSE = "ONLINE_COURSE",
  E_BOOK = "E_BOOK",
  MEMBERSHIP_PRICE = "MEMBERSHIP_PRICE",
  RESKILL_PRICE = "RESKILL_PRICE",
  TICKET_TIER = "TICKET_TIER",
  DOCUMENT = "DOCUMENT",
}

export enum ProductKind {
  DEFAULT = "DEFAULT",
  UPCOMING = "UPCOMING",
}

export interface ProductViewExtraDTO {
  careerType?: CareerType | null;
}

export interface ProductViewDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
}

export interface CourseSummaryDTO {
  lessonCount: number;
  sectionCount: number;
  totalDuration: number;
}

export interface ReskillPriceProductWithProgressDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
  summary: CourseSummaryDTO;
  progress: BaseProgressDTO;
}

export interface PagingDto {
  /** @example 1 */
  offset: number;
  /** @example 10 */
  limit: number;
  /** @example 0 */
  total: number;
  /** @example 0 */
  pageCount: number;
  /** @example false */
  hasPreviousPage: boolean;
  /** @example false */
  hasNextPage: boolean;
  /**
   * The cursor pointing to the next page (cursor-based pagination).
   * @example "eyJpZCI6IjEyMyJ9"
   */
  nextCursor?: string | null;
  /**
   * The cursor pointing to the previous page (cursor-based pagination).
   * @example "eyJpZCI6IjEyMiJ9"
   */
  previousCursor?: string | null;
}

export interface PageDto {
  items: string[];
  paging: PagingDto;
}

export interface SurveyDetailsDTO {
  id: string;
  title: string;
  banner: string;
  description: string | null;
  /** @format date-time */
  createdAt: string;
  createdById: string;
  status: "ACTIVE" | "INACTIVE" | "PREVIEW";
  responseCount: number;
}

export enum OrderByEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export interface UserDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  email: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  username?: string;
  fullName?: string;
  avatar?: string;
  top?: number;
  status: Status;
  isRoot: boolean;
  hostCount: number;
  eventCount: number;
  socials: object;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  userInterest: object[];
  business: BussinessDto[];
  categories: object[];
  isPrivilege?: boolean;
  coverPhoto: string;
}

export interface VoucherDto {
  discountType: "PERCENTAGE" | "FIXED_AMOUNT";
  code: string;
  discountValue: number;
}

export interface Product {
  id: string;
  slug?: string;
  /** @format date-time */
  startSellingDate?: string;
  /** @format date-time */
  endSellingDate?: string;
  /** @format date-time */
  releaseDate?: string;
  availableDays?: number;
  type: ProductType;
  originalPrice?: number;
  price: number;
  pricingPlan?: PricingPlan;
  paidCount: number;
  limitAudiences?: number;
  limitTicketPerUser?: number;
  isAcademy?: boolean;
  isHidden?: boolean;
  isReskill?: boolean;
  isOnair?: boolean;
  isLaunchpad?: boolean;
  isLnD: boolean;
  coverUrl?: string;
  description?: string;
  kind: ProductKind;
  belongsToUpcoming: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  ownerId?: string;
  productCoreId?: string;
  owner?: User;
  calendar?: Calendar;
  calendarFrame?: CalendarFrame;
  event?: Event;
  onlineCourse?: OnlineCourse;
  edoc?: Edoc;
  voucherProducts: VoucherProduct[];
  ticketTier?: TicketTier;
  eventWithPriority?: EventWithPriority;
  combo?: Combo;
  combos: Combo[];
  membershipPartProducts: MembershipPartProduct[];
  affiliates: Affiliate[];
  socialCommunities: SocialCommunity[];
  discountProducts: DiscountProduct[];
  paymentType?: PaymentType;
  membershipPrice?: MembershipPrice;
  reskillPriceProducts: ReskillPriceProduct[];
  reskillPrice?: ReskillPrice;
  userProducts: UserProduct[];
  productSurveys: ProductSurvey[];
  surveyResults: SurveyResult[];
  userLessonProgress: UserLessonProgress[];
  OrderItemV2: OrderItemV2[];
  eventWithPriorityId?: string;
}

export interface DiscountProduct {
  id: string;
  isActive: boolean;
  ticketQuantityLimit?: number;
  isTicketUnlimited: boolean;
  usedCount: number;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  discountId: string;
  productId: string;
  product: Product;
  discount: Discount;
  orderItemsV2: OrderItemV2[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
}

export interface OrderItemDto {
  id: string;
  quantity: number;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  itemType:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  price: number;
  adminPrice: number;
  referenceId: string;
  partner?: string;
  note?: string;
  revisionId: string;
  voucher?: VoucherDto;
  product: Product;
  discountProduct?: DiscountProduct;
}

export interface PaymentTransactionDto {
  status: "PENDING" | "FAILED" | "SUCCESS";
  amount: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminOrderDto {
  id: string;
  status: string;
  note: string;
  user: UserDto;
  /** @format date-time */
  createdAt: string;
  isAdminCreated: boolean;
  totalAmount: number;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  paymentNote: string;
  reason: string;
  createdBy: object;
  OrderItemV2: OrderItemDto[];
  PaymentTransaction: PaymentTransactionDto[];
  _count: {
    OrderItemV2: number;
  };
}

export interface AdminOrderProductOwnerDto {
  fullName: string;
  email: string;
}

export interface AdminOrderProductBaseDto {
  id: string;
  price?: number;
  originalPrice?: number;
}

export interface AdminOrderCalendarFrameDto {
  id: string;
  price?: number;
  originalPrice?: number;
  start: string;
  end: string;
  product: AdminOrderProductBaseDto;
}

export interface AdminOrderCalendarDto {
  id: string;
  price?: number;
  originalPrice?: number;
  title: string;
  banner: string;
  frames: AdminOrderCalendarFrameDto[];
}

export interface AdminOrderEventSessionDto {
  id: string;
  name: string;
  banner: string;
  product: AdminOrderProductBaseDto;
}

export interface AdminOrderEventV2Dto {
  id: string;
  price?: number;
  originalPrice?: number;
  name: string;
  banner: string;
  type: string;
  sessionPriceType: "ALL" | "EACH";
  eventSessions: AdminOrderEventSessionDto[];
  product: AdminOrderProductBaseDto;
}

export interface AdminOrderOnlineCourseDto {
  id: string;
  price?: number;
  originalPrice?: number;
  name: string;
  coverImage: string;
  product: AdminOrderProductBaseDto;
}

export interface AdminOrderComboItemProductDto {
  eventV2?: AdminOrderEventV2Dto;
  onlineCourse?: AdminOrderOnlineCourseDto;
}

export interface AdminOrderComboDto {
  id: string;
  price?: number;
  originalPrice?: number;
  name: string;
  product: AdminOrderProductBaseDto;
  items: AdminOrderComboItemProductDto[];
}

export interface AdminOrderProductItemDto {
  id: string;
  price?: number;
  originalPrice?: number;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  owner?: AdminOrderProductOwnerDto;
  calendar?: AdminOrderCalendarDto;
  eventV2?: AdminOrderEventV2Dto;
  onlineCourse?: AdminOrderOnlineCourseDto;
  combo?: AdminOrderComboDto;
}

export interface AdminCreateOrderInput {
  itemId: string;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  quantity: number;
  voucherCode?: string;
  adminPrice?: string;
  note?: string;
}

export interface AdminCreateOrderStatusInput {
  userId: string;
  status:
    | "PENDING"
    | "FAILED"
    | "SUCCESS"
    | "REFUND"
    | "EXPIRED"
    | "CANCEL"
    | "DELETED";
  items: AdminCreateOrderInput[];
  paymentNote: string;
  totalAmount?: number;
}

export interface PaginatedEntity {
  /** @example 1 */
  total: number;
  /** @example 0 */
  skip: number;
  /** @example 10 */
  take: number;
}

export interface OrderEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: "PENDING" | "SUCCESS" | "CANCELED" | "REJECTED";
  total: number;
  note?: string;
  reason?: string;
  items: string[];
  invoiceCaptures: object;
  paymentInfo: object;
}

export interface CreateOrderRequestDto {
  itemId: string;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  quantity: number;
  voucherCode?: string;
  note?: string;
  partner?: string;
  paymentProvider?: "XENDIT" | "VNPAY" | "GALAXYPAY" | "APPLE_IN_APP";
}

export interface TransactionResponseDto {
  paymentUrl: string;
  transactionId: string;
  /** @format date-time */
  expiredAt: string;
  isRedirect?: boolean;
}

export interface CreateOrderResponseDto {
  orderId: string;
  expiredAt?: string;
  transaction: TransactionResponseDto;
  isFree: boolean;
}

export interface TransactionInfoDto {
  id: string;
  status: string;
  amount: number;
  paymentType: string;
  paymentMethod: string;
  paymentProvider: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface QuotationItemDto {
  id: string;
  orderItemId?: string;
  productId: string;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  type: string;
  name: string;
  slug: string;
  banner?: string;
  host: HostDto;
  quantity: number;
  quota: number;
  voucherId?: string;
  voucherProductId?: string;
  unitPrice: number;
  /** Total price = unitPrice * quantity */
  totalPrice: number;
  /** Discount by amount per total price */
  discount: number;
  /** Discount amount by voucher */
  discountByVoucher?: number;
  /** Discount amount by campaign */
  discountByCampaign?: number;
  /** Final price = (unitPrice - quantity) - discount */
  finalPrice: number;
  sortOrder?: number;
  referenceId?: string;
  parentId?: string;
  eventSessionId?: string;
  locationType?: string;
  /** @default false */
  ignorePrice: boolean;
  socialCommunities?: string[];
  children?: QuotationItemDto[];
  address?: string;
  extra?: object;
  /** @format date-time */
  expiredAt?: string | null;
}

export interface InvoiceInfoDto {
  id: string;
  invoiceInfo: QuotationItemDto[];
  /** @format date-time */
  createdAt: string;
}

export interface OrderInfoResponseDto {
  id: string;
  reason?: string;
  note?: string;
  status: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** Empty with free order */
  paymentTransaction?: TransactionInfoDto;
  /** Export invoice when order status is success */
  invoice?: InvoiceInfoDto;
  orderItems?: QuotationItemDto[];
}

export interface GetOrderByItemResponseDto {
  id: string;
  status: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  user: HostDto;
}

export interface GetOrderItemResponse {
  id: string;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  voucherCode: string | null;
  unitPrice: number;
  discount: number | null;
  totalPrice: number;
  finalPrice: number;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string | null;
  owerEmail?: string | null;
  user: HostDto;
}

export enum LinkedOrderItem {
  Product = "product",
  Voucher = "voucher",
}

export interface PurchasedTicketDto {
  ticketId: string;
  ticketTypeName: string;
  ticketTypeId: string;
  ownerName: string;
  checkedIn: boolean;
  /** @format date-time */
  checkInAt: string | null;
  encryptedData: string | null;
  eventId: string | null;
  ticketType: "EVENT" | "EVENT_SESSION";
  eventSessionId: string | null;
}

export interface GetSuccessOrdersEventOfflineDto {
  id: string;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  voucherCode: string | null;
  unitPrice: number;
  discount: number | null;
  totalPrice: number;
  finalPrice: number;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  partner?: string | null;
  ownerEmail?: string | null;
  user: HostDto;
  purchasedTickets: PurchasedTicketDto[];
}

export enum OrderItemStatus {
  CREATED = "CREATED",
  PAID = "PAID",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum OrderStatusV2 {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  REFUND = "REFUND",
  EXPIRED = "EXPIRED",
  CANCEL = "CANCEL",
  DELETED = "DELETED",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum UserRole {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  PRODUCT_OWNER = "PRODUCT_OWNER",
  ACA_PARTNER = "ACA_PARTNER",
  MARKETING = "MARKETING",
  SALE = "SALE",
  HOST = "HOST",
  USER = "USER",
}

export enum UserVerificationProviders {
  EMAIL = "EMAIL",
  PHONE = "PHONE",
}

export enum UserGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export enum UserLoginTypes {
  CREDENTIALS = "CREDENTIALS",
  GOOGLE = "GOOGLE",
  FACEBOOK = "FACEBOOK",
  TWITTER = "TWITTER",
  APPLE = "APPLE",
}

export enum SubscriptionStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  FAILED = "FAILED",
  CANCEL = "CANCEL",
  EXPIRED = "EXPIRED",
  PENDING_RENEWAL = "PENDING_RENEWAL",
}

export enum PeriodType {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum Currency {
  VND = "VND",
}

export enum SubscriptionPaymentStatus {
  PENDING = "PENDING",
  PENDING_UPGRADE = "PENDING_UPGRADE",
  PAID = "PAID",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
}

export enum SubscriptionRegistrationStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum DiscountType {
  PERCENTAGE = "PERCENTAGE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
}

export enum OrderTypes {
  EVENT = "EVENT",
  CALENDAR = "CALENDAR",
}

export enum BookingCalendarStatus {
  HOLDING = "HOLDING",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
}

export enum CalendarStatus {
  PENDING = "PENDING",
  PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  PUBLISHED = "PUBLISHED",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
}

export enum NotificationTypes {
  APPROVED_HOST_PROFILE = "APPROVED_HOST_PROFILE",
  REJECTED_HOST_PROFILE = "REJECTED_HOST_PROFILE",
  CALENDAR_BOOKING_HOST_CANCELED = "CALENDAR_BOOKING_HOST_CANCELED",
  CALENDAR_BOOKING_USER_CANCELED = "CALENDAR_BOOKING_USER_CANCELED",
  CALENDAR_BOOKING_REMIND_REPLY = "CALENDAR_BOOKING_REMIND_REPLY",
  HOST_PROFILE_APPROVED = "HOST_PROFILE_APPROVED",
  HOST_PROFILE_REJECTED = "HOST_PROFILE_REJECTED",
  HOST_PROFILE_JOIN_ORGANIZATION_APPROVED = "HOST_PROFILE_JOIN_ORGANIZATION_APPROVED",
  HOST_PROFILE_JOIN_ORGANIZATION_REJECTED = "HOST_PROFILE_JOIN_ORGANIZATION_REJECTED",
  HOST_PRODUCT_SOLD = "HOST_PRODUCT_SOLD",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_SUCCESS_FREE = "PAYMENT_SUCCESS_FREE",
  PAYMENT_TOKEN_DELETED = "PAYMENT_TOKEN_DELETED",
  EVENT_APPROVED = "EVENT_APPROVED",
  EVENT_REJECTED = "EVENT_REJECTED",
  EVENT_STARTED = "EVENT_STARTED",
  EVENT_HOST_REMINDER = "EVENT_HOST_REMINDER",
  EVENT_TICKET_CHECKED_IN = "EVENT_TICKET_CHECKED_IN",
  CALENDAR_APPROVED = "CALENDAR_APPROVED",
  CALENDAR_REJECTED = "CALENDAR_REJECTED",
  CALENDAR_STARTED = "CALENDAR_STARTED",
  CALENDAR_BOOKING_APPROVED = "CALENDAR_BOOKING_APPROVED",
  CALENDAR_BOOKING_REJECTED = "CALENDAR_BOOKING_REJECTED",
  CALENDAR_BOOKING_NEW = "CALENDAR_BOOKING_NEW",
  CALENDAR_REMINDER = "CALENDAR_REMINDER",
  CALENDAR_REMINDER_APPROVED = "CALENDAR_REMINDER_APPROVED",
  CALENDAR_HOST_SUGGEST_APPROVED = "CALENDAR_HOST_SUGGEST_APPROVED",
  ONLINE_COURSE_APPROVED = "ONLINE_COURSE_APPROVED",
  ONLINE_COURSE_REJECTED = "ONLINE_COURSE_REJECTED",
  ONLINE_COURSE_UNLOCK = "ONLINE_COURSE_UNLOCK",
  BLOG_APPROVED = "BLOG_APPROVED",
  BLOG_REJECTED = "BLOG_REJECTED",
  PROJECT_APPROVED = "PROJECT_APPROVED",
  PROJECT_REJECTED = "PROJECT_REJECTED",
  FOLLOWING_HOST_NEW_EVENT = "FOLLOWING_HOST_NEW_EVENT",
  FOLLOWING_HOST_NEW_CALENDAR = "FOLLOWING_HOST_NEW_CALENDAR",
  FOLLOWING_HOST_NEW_BLOG = "FOLLOWING_HOST_NEW_BLOG",
  FOLLOWING_HOST_NEW_PROJECT = "FOLLOWING_HOST_NEW_PROJECT",
  NEW_FOLLOWER = "NEW_FOLLOWER",
  REFUND_SUCCESS = "REFUND_SUCCESS",
  REFUND_FAILED = "REFUND_FAILED",
  SUBSCRIPTION_RENEWAL = "SUBSCRIPTION_RENEWAL",
  SUBSCRIPTION_RENEWAL_FAILED = "SUBSCRIPTION_RENEWAL_FAILED",
  SUBSCRIPTION_RENEWAL_SUCCESS = "SUBSCRIPTION_RENEWAL_SUCCESS",
  SUBSCRIPTION_FIRST_PAYMENT_SUCCESS = "SUBSCRIPTION_FIRST_PAYMENT_SUCCESS",
  SUBSCRIPTION_FIRST_PAYMENT_FAILED = "SUBSCRIPTION_FIRST_PAYMENT_FAILED",
  SUBSCRIPTION_CANCELLED = "SUBSCRIPTION_CANCELLED",
  SUBSCRIPTION_TIMEOUT = "SUBSCRIPTION_TIMEOUT",
  MEMBERSHIP_PLAN_PRICE_CHANGED = "MEMBERSHIP_PLAN_PRICE_CHANGED",
  MEMBERSHIP_PLAN_PERIOD_CHANGED = "MEMBERSHIP_PLAN_PERIOD_CHANGED",
  MEMBERSHIP_PLAN_ALL_CHANGED = "MEMBERSHIP_PLAN_ALL_CHANGED",
  LAYOFF_DISCOUNT_REQUESTED = "LAYOFF_DISCOUNT_REQUESTED",
  LAYOFF_DISCOUNT_APPROVED = "LAYOFF_DISCOUNT_APPROVED",
  LAYOFF_DISCOUNT_REJECTED = "LAYOFF_DISCOUNT_REJECTED",
  RESKILL_REMINDER = "RESKILL_REMINDER",
  RESKILL_EXPIRED = "RESKILL_EXPIRED",
}

export enum EventType {
  ONE_TO_ONE = "ONE_TO_ONE",
  ONE_WAY = "ONE_WAY",
  TWO_WAY = "TWO_WAY",
}

export enum EventStatus {
  PENDING = "PENDING",
  PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  PUBLISHED = "PUBLISHED",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
}

export enum DurationType {
  DURATION_IN_DAY = "DURATION_IN_DAY",
  DURATION_OVER_DAY = "DURATION_OVER_DAY",
}

export enum BookingEventStatus {
  HOLDING = "HOLDING",
  SUCCESS = "SUCCESS",
  CANCELED = "CANCELED",
}

export interface BookingEvent {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  note?: string;
  status: BookingEventStatus;
  userId: string;
  eventId: string;
  orderItemId: string;
  event: Event;
  orderItem: OrderItem;
  user: User;
}

export interface CartItem {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: OrderTypes;
  note?: string;
  userId: string;
  eventId?: string;
  calendarFrameId?: string;
  quantity: number;
  calendarFrame?: CalendarFrame;
  event?: Event;
  user: User;
  voucherId?: string;
  voucher?: Voucher;
}

export interface HostOnCategory {
  userId: string;
  categoryId: string;
  label: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  category: HostCategory;
  user: User;
}

export interface HostCategory {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  top?: number;
  businesses: BusinessCategory[];
  users: HostOnCategory[];
}

export interface BusinessCategory {
  categoryId: string;
  businessId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  business: Business;
  category: HostCategory;
}

export enum Status {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
  HIDDEN = "HIDDEN",
}

export enum CategoryType {
  HOST = "HOST",
  EVENT = "EVENT",
  ONLINE_COURSE = "ONLINE_COURSE",
}

export enum LocationType {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}

export enum AddressScope {
  ALL = "ALL",
  EACH = "EACH",
}

export enum TicketScope {
  ALL = "ALL",
  EACH = "EACH",
}

export enum EventTypeV2 {
  SINGLE = "SINGLE",
  SESSION = "SESSION",
}

export enum EventStatusV2 {
  PENDING = "PENDING",
  PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  PUBLISHED = "PUBLISHED",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
}

export enum SessionPriceType {
  ALL = "ALL",
  EACH = "EACH",
}

export enum DurationTypeV2 {
  DURATION_IN_DAY = "DURATION_IN_DAY",
  DURATION_OVER_DAY = "DURATION_OVER_DAY",
}

export enum RoomProvider {
  GOOGLE_MEET = "GOOGLE_MEET",
  ZOOM = "ZOOM",
}

export enum RoomMadeBy {
  HOST = "HOST",
  SYSTEM = "SYSTEM",
}

export enum TicketTierType {
  EVENT = "EVENT",
  EVENT_SESSION = "EVENT_SESSION",
}

export interface TicketTier {
  id: string;
  name?: string;
  description?: string;
  locationType: LocationType;
  type: TicketTierType;
  eventId?: string;
  event?: EventV2;
  eventSessionId?: string;
  eventSession?: EventSession;
  productId: string;
  product: Product;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PaymentRecord {
  id: string;
  amount: number;
  ownerName: string;
  phoneNumber: string;
  email: string;
  eventId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  event: EventV2;
  eventSessions: EventSession[];
}

export interface EventSession {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  slug: string;
  /** @format date-time */
  deletedAt?: string;
  name?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  banner?: string;
  content?: string;
  duration?: number;
  durationType?: DurationTypeV2;
  roomUrl?: string;
  roomProvider?: RoomProvider;
  roomMadeBy?: RoomMadeBy;
  roomInfo?: object;
  order?: number;
  censorshipHistories: object[];
  address?: string;
  radioOptions?: object;
  hostId: string;
  coHostInfo?: object;
  coHostId?: string;
  eventId: string;
  host: User;
  coHost?: User;
  event: EventV2;
  notifications: Notification[];
  ticketTiers: TicketTier[];
  paymentRecords: PaymentRecord[];
}

export interface EventV2 {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  slug: string;
  locationType: LocationType;
  addressScope?: AddressScope;
  ticketScope?: TicketScope;
  type?: EventTypeV2;
  status: EventStatusV2;
  sessionPriceType?: SessionPriceType;
  isHidden: boolean;
  lowestPrice?: number;
  highestPrice?: number;
  totalPrice?: number;
  name?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  banner?: string;
  content?: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  address?: string;
  isPreview?: boolean;
  duration?: number;
  durationType?: DurationTypeV2;
  roomUrl?: string;
  roomProvider?: RoomProvider;
  roomMadeBy?: RoomMadeBy;
  roomInfo?: object;
  qas?: object;
  agendas?: object;
  censorshipHistories: object[];
  radioOptions?: object;
  order?: number;
  host: User;
  eventSessions: EventSession[];
  notifications: Notification[];
  categoriesV2: Category[];
  vouchers: Voucher[];
  ticketTiers: TicketTier[];
  paymentRecords: PaymentRecord[];
}

export enum OnlineCourseStatus {
  DRAFT = "DRAFT",
  UNPUBLISHED = "UNPUBLISHED",
  REVIEWED = "REVIEWED",
  PUBLISHED = "PUBLISHED",
  REJECTED = "REJECTED",
  DELETED = "DELETED",
  PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
}

export enum SectionStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum LessonType {
  VIDEO = "VIDEO",
  PDF = "PDF",
  TEXT = "TEXT",
}

export enum LessonStatus {
  DRAFT = "DRAFT",
  PUBLISH = "PUBLISH",
}

export enum ResourceType {
  FILE = "FILE",
  LINK = "LINK",
}

export interface Library {
  id: string;
  name: string;
  resources: Resource[];
  userId: string;
  user: User;
  parentId?: string;
  parent?: Library;
  child: Library[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export enum EdocStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum SubscriptionEmailType {
  ACADEMY = "ACADEMY",
  LD_EDOC = "LD_EDOC",
  LD_MKT = "LD_MKT",
}

export enum SubscriptionEmailStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  SENDING = "SENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export interface SubscriptionEmail {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: SubscriptionEmailType;
  email: string;
  phone?: string;
  fullName?: string;
  companyName?: string;
  job?: string;
  learningDifficulty?: string;
  status: SubscriptionEmailStatus;
  /** @format date-time */
  processAt?: string;
  history?: object;
  edocId?: string;
  edoc?: Edoc;
  assigneeId?: string;
  assignee?: User;
}

export interface Edoc {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  title: string;
  description: string;
  bannerUrl?: string;
  hashtags: string[];
  status: EdocStatus;
  /** @format date-time */
  publishedAt?: string;
  isHidden: boolean;
  createdById: string;
  createdBy: User;
  productId?: string;
  product?: Product;
  resourceId: string;
  resource: Resource;
  SubscriptionEmail: SubscriptionEmail[];
}

export interface OnlineCourseResource {
  onlineCourseId: string;
  onlineCourse: OnlineCourse;
  resourceId: string;
  resource: Resource;
  isMain: boolean;
}

export interface SectionResource {
  sectionId: string;
  section: Section;
  resourceId: string;
  resource: Resource;
  isMain: boolean;
}

export interface Resource {
  id: string;
  name: string;
  fileName: string;
  fileType?: string;
  duration?: number;
  /** @format int64 */
  capacity: number;
  resourceType: ResourceType;
  linkUrl?: string;
  publicUrl?: string;
  thumbnailUrl?: string;
  content?: string;
  lessonResources: LessonResource[];
  libraryId: string;
  library: Library;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  Edoc: Edoc[];
  OnlineCourseResource: OnlineCourseResource[];
  SectionResource: SectionResource[];
}

export interface LessonResource {
  lessonId: string;
  lesson: Lesson;
  resourceId: string;
  resource: Resource;
  isMain: boolean;
}

export enum LessonProgressStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export interface UserLessonProgress {
  id: string;
  userId: string;
  user: User;
  lessonId: string;
  lesson: Lesson;
  productId: string;
  product: Product;
  status: LessonProgressStatus;
  currentPosition: number;
  /** @format date-time */
  lastAccessedAt?: string;
  /** @format date-time */
  completedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface Lesson {
  id: string;
  title: string;
  content: string;
  description?: string;
  type: LessonType;
  status: LessonStatus;
  thumbnail?: string;
  lessonResources: LessonResource[];
  index: number;
  canPreview: boolean;
  sectionId?: string;
  section?: Section;
  ownerId: string;
  owner: User;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  userLessonProgress: UserLessonProgress[];
}

export interface Section {
  id: string;
  title: string;
  status: SectionStatus;
  thumbnail?: string;
  lessons: Lesson[];
  sectionResources: SectionResource[];
  index: number;
  onlineCourseId?: string;
  onlineCourse?: OnlineCourse;
  ownerId: string;
  owner: User;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
}

export enum OnlineCourseVersionStatus {
  CREATED = "CREATED",
  REVIEWED = "REVIEWED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface OnlineCourseVersion {
  id: string;
  onlineCourseId: string;
  onlineCourse: OnlineCourse;
  version: number;
  status: OnlineCourseVersionStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface OnlineCourse {
  id: string;
  name?: string;
  description?: string;
  coverImage?: string;
  wallpaper?: string;
  videoCompletionRequired: boolean;
  status: OnlineCourseStatus;
  statusReason?: string;
  displayed: boolean;
  sections: Section[];
  currentVersion: number;
  onlineCourseVersions: OnlineCourseVersion[];
  onlineCourseResources: OnlineCourseResource[];
  /** @format date-time */
  startAt?: string;
  categoriesV2: Category[];
  isPublished: boolean;
  productId?: string;
  product?: Product;
  benefit?: string;
  archived?: string;
  questionAndAnswers?: string;
  tags?: string;
  /** @format date-time */
  createdAt: string;
  ownerId: string;
  owner: User;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  censorshipHistories: object[];
  Notification: Notification[];
}

export interface CategoryAncester {
  ancestorId: string;
  descendantId: string;
  ancestor: Category;
  descendant: Category;
}

export interface Category {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  top?: number;
  status: Status;
  isRoot: boolean;
  type: CategoryType[];
  hostCount: number;
  eventCount: number;
  businessCount: number;
  onlineCourseCount: number;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  events: Event[];
  eventsV2: EventV2[];
  hosts: User[];
  business: Business[];
  onlineCourses: OnlineCourse[];
  ancestors: CategoryAncester[];
  descendants: CategoryAncester[];
  interestsByUsers: User[];
}

export interface BusinessUser {
  userId: string;
  businessId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  business: Business;
  user: User;
}

export interface Business {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  categories: BusinessCategory[];
  categoriesV2: Category[];
  users: BusinessUser[];
  usersV2: User[];
  events: EventsOnBusinesses[];
}

export interface EventsOnBusinesses {
  eventId: string;
  businessId: string;
  main: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  business: Business;
  event: Event;
}

export interface UserInterest {
  id: string;
  userId: string;
  categoryId: string;
  category: EventCategory;
  user: User;
}

export interface EventCategory {
  id: string;
  name: string;
  slug: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  thumbnail: string;
  icon?: string;
  description?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  events: EventsOnCategories[];
  userInterest: UserInterest[];
}

export interface EventsOnCategories {
  eventId: string;
  categoryId: string;
  label: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  category: EventCategory;
  event: Event;
}

export interface Event {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  type: EventType;
  status: EventStatus;
  name: string;
  slug: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  farePrice: number;
  isFree: boolean;
  limitAudiences: number;
  duration: number;
  durationType: DurationType;
  roomUrl?: string;
  qas: object;
  outlines: object;
  censorshipHistories: object[];
  top?: number;
  /** @format date-time */
  openingSaleDate: string;
  productId?: string;
  product?: Product;
  bookings: BookingEvent[];
  cartItems: CartItem[];
  host: User;
  businesses: EventsOnBusinesses[];
  categories: EventsOnCategories[];
  categoriesV2: Category[];
  orderItems: OrderItem[];
  vouchers: Voucher[];
  notifications: Notification[];
}

export enum PostType {
  NEWS = "NEWS",
  PROJECT = "PROJECT",
  BLOG = "BLOG",
}

export enum PostStatus {
  PUBLISHED = "PUBLISHED",
  PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  HIDDEN = "HIDDEN",
}

export interface Post {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  publishedAt: string;
  thumbnail: string;
  type: PostType;
  title: string;
  slug: string;
  content: string;
  status: PostStatus;
  tags: string[];
  censorshipHistories: object[];
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  authorId: string;
  author: User;
  notifications: Notification[];
}

export enum ComboDiscountType {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
}

export interface Combo {
  id: string;
  name: string;
  isActive: boolean;
  discountType: ComboDiscountType;
  discountValue: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  hostId: string;
  productId: string;
  product: Product;
  host: User;
  items: Product[];
  Notification: Notification[];
}

export interface Notification {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: NotificationTypes;
  role: UserRole;
  userId: string;
  eventId?: string;
  eventV2Id?: string;
  eventSessionId?: string;
  calendarId?: string;
  onlineCourseId?: string;
  postId?: string;
  comboId?: string;
  interactorId?: string;
  read?: boolean;
  icon?: string;
  title: string;
  description?: string;
  webUrl?: string;
  appUrl?: string;
  extraData?: object;
  isSent?: boolean;
  /** @format date-time */
  sendAt?: string;
  user: User;
  interactor?: User;
  event?: Event;
  eventV2?: EventV2;
  eventSession?: EventSession;
  calendar?: Calendar;
  post?: Post;
  onlineCourse?: OnlineCourse;
  combo?: Combo;
}

export interface Calendar {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  title: string;
  slug: string;
  banner: string;
  description: string;
  /** @format date-time */
  date: string;
  farePrice: number;
  host: User;
  frames: CalendarFrame[];
  censorshipHistories: object[];
  status: CalendarStatus;
  notifications: Notification[];
  productId?: string;
  product?: Product;
}

export interface CalendarFrame {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  calendarId: string;
  farePrice: number;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  roomUrl?: string;
  productId?: string;
  product?: Product;
  bookings: BookingCalendar[];
  calendar: Calendar;
  host: User;
  cartItem: CartItem[];
  orderItem: OrderItem[];
}

export interface BookingCalendar {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: BookingCalendarStatus;
  note?: string;
  reason?: string;
  userId: string;
  calendarFrameId: string;
  orderItemId: string;
  calendarFrame: CalendarFrame;
  orderItem: OrderItem;
  user: User;
}

export enum OrderStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  CANCELED = "CANCELED",
  REJECTED = "REJECTED",
}

export enum PaymentProvider {
  XENDIT = "XENDIT",
  VNPAY = "VNPAY",
  GALAXYPAY = "GALAXYPAY",
  APPLE_IN_APP = "APPLE_IN_APP",
}

export interface Order {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  status: OrderStatus;
  total: number;
  note?: string;
  reason?: string;
  userId: string;
  invoiceCaptures?: object;
  paymentInfo?: object;
  paymentProvider: PaymentProvider;
  user: User;
  items: OrderItem[];
}

export interface OrderItem {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  type: OrderTypes;
  quantity: number;
  price: number;
  orderId: string;
  eventId?: string;
  eventCaptures?: object;
  calendarFrameId?: string;
  calendarFrameCaptures?: object;
  note?: string;
  bookingCalendar?: BookingCalendar;
  bookingEvent?: BookingEvent;
  calendarFrame?: CalendarFrame;
  event?: Event;
  order: Order;
  voucherId?: string;
  voucher?: Voucher;
}

export enum VoucherType {
  SINGLE_USE = "SINGLE_USE",
  MULTI_USE = "MULTI_USE",
}

export interface VoucherProduct {
  id: string;
  isActive: boolean;
  ticketQuantityLimit?: number;
  isTicketUnlimited: boolean;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  productId: string;
  voucherId: string;
  usedCount: number;
  voucherType: VoucherType;
  product: Product;
  voucher: Voucher;
  orderItems: OrderItemV2[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
}

export enum RefundStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum RefundApprovalStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  AWAITING_INFO = "AWAITING_INFO",
}

export enum RefundType {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}

export interface RefundHistory {
  id: string;
  refundId: string;
  status: RefundStatus;
  approvalStatus: RefundApprovalStatus;
  reason?: string;
  refundAccountId?: string;
  /** @format date-time */
  createdAt: string;
  refund: Refund;
  refundAccount?: BankAccount;
}

export interface Refund {
  id: string;
  orderId?: string;
  userId: string;
  amount?: number;
  status: RefundStatus;
  approvalStatus: RefundApprovalStatus;
  type?: RefundType;
  refundAccountId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  order?: OrderV2;
  refundItems: OrderItemToRefund[];
  User: User;
  refundAccount?: BankAccount;
  refundHistory: RefundHistory[];
}

export enum RefundPolicyType {
  CREDIT_CARD = "CREDIT_CARD",
  QR_CODE = "QR_CODE",
  EWALLET = "EWALLET",
  BANK_TRANSFER = "BANK_TRANSFER",
  VNPAY = "VNPAY",
}

export enum FeePayer {
  USER = "USER",
  HOST = "HOST",
  ADMIN = "ADMIN",
}

export interface RefundPolicy {
  id: string;
  refundPolicyType: RefundPolicyType;
  refundFee: number;
  feePayer: FeePayer;
  conditions?: object;
  productCategory: ProductType;
  recipient: UserRole;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  refundItems: OrderItemToRefund[];
}

export interface OrderItemToRefund {
  id: string;
  orderItemId: string;
  refundId: string;
  refundPolicyId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  orderItem: OrderItemV2;
  refund: Refund;
  refundPolicy?: RefundPolicy;
}

export enum UserProductStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum UserProductProgressStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export interface UserProduct {
  id: string;
  /** @format date-time */
  expiredAt?: string;
  orderItemId: string;
  status: UserProductStatus;
  progressStatus: UserProductProgressStatus;
  productId: string;
  userId: string;
  checkedIn: boolean;
  /** @format date-time */
  checkedInAt?: string;
  /** @format date-time */
  lastAccessedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  orderItem: OrderItemV2;
  product: Product;
  user: User;
}

export interface OrderItemV2 {
  id: string;
  orderId: string;
  itemType: ProductType;
  itemId: string;
  productId: string;
  quantity: number;
  voucherId?: string;
  price: number;
  adminPrice?: number;
  status: OrderItemStatus;
  rawData?: object;
  reason?: string;
  note?: string;
  referenceId?: string;
  revisionId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string;
  discountProductId?: string;
  voucherProductId?: string;
  order: OrderV2;
  voucher?: Voucher;
  product: Product;
  discountProduct?: DiscountProduct;
  voucherProduct?: VoucherProduct;
  refundItem?: OrderItemToRefund;
  userProducts: UserProduct[];
}

export interface VoucherUserRestriction {
  id: string;
  voucherId: string;
  email: string;
  voucher: Voucher;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface Quota {
  id: string;
  duration: number;
  durationType: PeriodType;
  voucherId: string;
  voucher: Voucher;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface Voucher {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  code: string;
  description?: string;
  note?: string;
  discountType: DiscountType;
  discountValue: number;
  maxUses?: number;
  usedCount: number;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  isActive: boolean;
  isEnded: boolean;
  hasRestrictedUsers: boolean;
  changeLogs: object[];
  createdById?: string;
  orderItems: OrderItem[];
  cartItems: CartItem[];
  orderItemsV2: OrderItemV2[];
  voucherProducts: VoucherProduct[];
  restrictedUsers: VoucherUserRestriction[];
  quotas: Quota[];
  subscriptions: Subscription[];
  subscriptionPeriods: SubscriptionPeriod[];
  createdBy?: User;
  EventV2?: EventV2;
  eventV2Id?: string;
  Event?: Event;
  eventId?: string;
}

export interface SubscriptionPeriod {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  subscriptionId: string;
  bankAccountId?: string;
  paymentStatus: SubscriptionPaymentStatus;
  /** @format date-time */
  paidAt?: string;
  invoice: object;
  paymentRecurringId?: string;
  paymentReference?: string;
  paymentInfo?: object;
  lastTransactionRef?: string;
  registrationStatus?: SubscriptionRegistrationStatus;
  /** @format date-time */
  registrationStartedAt?: string;
  /** @format date-time */
  registrationExpiresAt?: string;
  statusReason?: string;
  voucherId?: string;
  membershipPriceId?: string;
  subscription: Subscription;
  bankAccount?: BankAccount;
  voucher?: Voucher;
  membershipPrice?: MembershipPrice;
}

export interface MembershipPrice {
  id: string;
  name?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  periodType: PeriodType;
  periodValue: number;
  currency: Currency;
  amount: number;
  order: number;
  paidCount: number;
  isPublic: boolean;
  superiorId?: string;
  membershipId: string;
  membership: Membership;
  subscriptions: Subscription[];
  product?: Product;
  productId?: string;
  SubscriptionPeriod: SubscriptionPeriod[];
}

export interface MembershipPartProduct {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  productId: string;
  product: Product;
  membershipId: string;
  membership: Membership;
  membershipPartId: string;
  membershipPart: MembershipPart;
}

export interface MembershipPart {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  part: number;
  upcomingPartDays: number;
  upcomingPartUnit: PeriodType;
  name: string;
  membershipId: string;
  membership: Membership;
  membershipPartProducts: MembershipPartProduct[];
}

export interface Membership {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  name: string;
  description?: string;
  status: MembershipStatus;
  paidCount: number;
  isMain: boolean;
  subscriptions: Subscription[];
  membershipPrices: MembershipPrice[];
  membershipParts: MembershipPart[];
  membershipPartProducts: MembershipPartProduct[];
}

export interface Subscription {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  lastPaymentAt?: string;
  status: SubscriptionStatus;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  /** @format date-time */
  cancelledAt?: string;
  accumulatedTime: number;
  accumulatedUnit: PeriodType;
  membershipId: string;
  membership: Membership;
  membershipPriceId: string;
  membershipPrice: MembershipPrice;
  bankAccountId?: string;
  bankAccount?: BankAccount;
  userId: string;
  user: User;
  subscriptionPeriods: SubscriptionPeriod[];
  voucherId?: string;
  voucher?: Voucher;
  discountRemainingUse?: number;
  isDeprecated: boolean;
}

export interface BankAccount {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  userId: string;
  default?: boolean;
  accountNumber: string;
  accountHolderName: string;
  bankName: string;
  bankAccountTokenizeId?: string;
  needToUpdate?: boolean;
  user: User;
  subscriptions: Subscription[];
  subscriptionPeriods: SubscriptionPeriod[];
  RefundHistory: RefundHistory[];
  Refund: Refund[];
}

export interface Follows {
  followerId: string;
  followingId: string;
  follower: User;
  following: User;
}

export interface RefreshToken {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  token: string;
  currentToken: string;
  revoked?: boolean;
  /** @format date-time */
  revokedAt?: string;
  clientId?: string;
  requestIp: string;
  useragent: string;
  address?: string;
  location?: string;
  userId: string;
  user: User;
}

export interface SearchHistory {
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  userId: string;
  query: string;
  extraData?: object;
  id: string;
  user: User;
}

export interface UserAchievement {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  title: string;
  description?: string;
  location?: string;
  /** @format date-time */
  date?: string;
  userId: string;
  links: string[];
  medias: string[];
  organizational?: string;
  thumbnail: string;
  user: User;
}

export interface UserCredentials {
  id: string;
  password: string;
  userId: string;
  user: User;
}

export interface UserEducation {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  school: string;
  description?: string;
  degree?: string;
  fieldOfStudy?: string;
  grade?: string;
  location?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  userId: string;
  schoolLogo?: string;
  user: User;
}

export enum UserWorkType {
  FUllTIME = "FUll_TIME",
  REMOTE = "REMOTE",
  PARTTIME = "PARTTIME",
  HYBRID = "HYBRID",
  FREELANCE = "FREELANCE",
  INTERN = "INTERN",
  OTHER = "OTHER",
}

export interface UserWork {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  title: string;
  description?: string;
  companyName?: string;
  location?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  isCurrent: boolean;
  userId: string;
  companyLogo?: string;
  type?: UserWorkType;
  user: User;
}

export enum HostProfileStatus {
  NEW = "NEW",
  RESUBMIT = "RESUBMIT",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface HostProfile {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  invoiceEmail: string[];
  typeOfActivity?: string;
  docs?: string;
  contactAddress?: string;
  organizationName?: string;
  organizationTaxNumber?: string;
  personalTaxNumber?: string;
  contactCity?: string;
  contactDistrict?: string;
  contactWard?: string;
  typeOfId?: string;
  idNumber?: string;
  imageHandheldId?: string;
  imageIdBack?: string;
  imageIdFront?: string;
  nameInId?: string;
  censorshipHistories: object[];
  status: HostProfileStatus;
  userId: string;
  user: User;
}

export enum ModerationVersionReferenceType {
  PROJECT = "PROJECT",
  BLOG = "BLOG",
  EVENT = "EVENT",
  CALENDAR = "CALENDAR",
  ONLINE_COURSE = "ONLINE_COURSE",
}

export enum ModerationMethods {
  OPENAI = "OPENAI",
  USER = "USER",
}

export enum ModerationVersionStatus {
  WAITING_TO_APPROVE = "WAITING_TO_APPROVE",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
  ACCEPTED = "ACCEPTED",
}

export interface ModerationVersion {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  referenceId: string;
  referenceType: ModerationVersionReferenceType;
  moderatedBy: ModerationMethods;
  status: ModerationVersionStatus;
  content?: string;
  extra?: string;
  userId?: string;
  user?: User;
  children: ModerationVersion[];
  parent?: ModerationVersion;
  parentId?: string;
}

export interface ContentModeration {
  id: string;
  slug: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status?: string;
  name?: string;
  title?: string;
  banner?: string;
  thumbnail?: string;
  hostId: string;
  host?: User;
  type?: string;
  farePrice?: number;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  date?: string;
  isAcademy?: string;
  censorshipHistories: object[];
}

export interface UserSocketClient {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  socketId: string;
  userId: string;
  user: User;
}

export interface NotificationToken {
  id: string;
  fcmToken: string;
  userId?: string;
  user?: User;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  lastUsed?: string;
}

export enum TransactionStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export enum PaymentType {
  PAY = "PAY",
  REFUND = "REFUND",
  ONE_TIME = "ONE_TIME",
  RECURRING = "RECURRING",
}

export enum PaymentMethod {
  INVOICE = "INVOICE",
  CREDIT_CARD = "CREDIT_CARD",
  QR_CODE = "QR_CODE",
  EWALLET = "EWALLET",
  BANK_TRANSFER = "BANK_TRANSFER",
  VNPAY = "VNPAY",
}

export interface PaymentTransaction {
  id: string;
  userId: string;
  orderId: string;
  status: TransactionStatus;
  amount: number;
  paymentType: PaymentType;
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProvider;
  paymentUrl?: string;
  paymentInfo?: object;
  callbackInfo?: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  user?: User;
  order: OrderV2;
  Invoice: Invoice[];
}

export interface Invoice {
  id: string;
  orderId: string;
  transactionId?: string;
  userId: string;
  invoiceInfo?: object;
  /** @format date-time */
  createdAt: string;
  order: OrderV2;
  transaction?: PaymentTransaction;
  user: User;
}

export enum UserOnboardingStatus {
  NEW = "NEW",
  USER = "USER",
  NEW_HOST = "NEW_HOST",
  HOST_APPROVED = "HOST_APPROVED",
  HOST_REJECTED = "HOST_REJECTED",
  HOST_RESUBMIT = "HOST_RESUBMIT",
}

export enum HostNotificationMode {
  OFF = "OFF",
  INSTANT = "INSTANT",
  DAILYBATCH1 = "DAILY_BATCH_1",
  DAILYBATCH2 = "DAILY_BATCH_2",
  DAILYBATCH3 = "DAILY_BATCH_3",
  DAILYBATCH4 = "DAILY_BATCH_4",
  DAILYBATCH5 = "DAILY_BATCH_5",
}

export enum UserOrganization {
  HDBANK = "HDBANK",
}

export enum SurveyScope {
  PUBLIC = "PUBLIC",
  AUTHENTICATED = "AUTHENTICATED",
  GRANTED = "GRANTED",
}

export enum SurveyFieldType {
  SELECT = "SELECT",
  RADIO = "RADIO",
  CHECKBOX = "CHECKBOX",
  TEXTAREA = "TEXTAREA",
  RATING = "RATING",
}

export interface SurveyField {
  id: string;
  surveyId: string;
  survey: Survey;
  type: SurveyFieldType;
  label: string;
  placeholder?: string;
  options?: object;
  required: boolean;
  order: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface SurveyResult {
  id: string;
  email: string;
  userId?: string;
  user?: User;
  productId?: string;
  product?: Product;
  surveyId: string;
  survey: Survey;
  data: object;
  fullName?: string;
  phone?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ProductSurvey {
  id: string;
  required: boolean;
  productId: string;
  surveyId: string;
  product: Product;
  survey: Survey;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
}

export enum SurveyStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PREVIEW = "PREVIEW",
}

export interface Survey {
  id: string;
  title: string;
  banner: string;
  description?: string;
  scope: SurveyScope;
  createdById: string;
  createdBy: User;
  fields: SurveyField[];
  results: SurveyResult[];
  productSurveys: ProductSurvey[];
  status: SurveyStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export enum LayoffDiscountRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export interface ReskillPriceProduct {
  id: string;
  order: number;
  reskillPriceId: string;
  reskillId: string;
  productId: string;
  reskill: Reskill;
  reskillPrice: ReskillPrice;
  product: Product;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CareerPlanUpgrade {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  fromPlanId: string;
  toPlanId: string;
  reskillId: string;
  price: number;
  reskill: Reskill;
  fromPlan: ReskillPrice;
  toPlan: ReskillPrice;
}

export interface Reskill {
  id: string;
  name: string;
  banner: string;
  type: CareerType;
  reskillPrices: ReskillPrice[];
  reskillPriceProducts: ReskillPriceProduct[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  CareerPlanUpgrade: CareerPlanUpgrade[];
}

export interface ReskillPrice {
  id: string;
  name: string;
  periodType: PeriodType;
  periodValue: number;
  currency: Currency;
  order: number;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  reskillId: string;
  reskill: Reskill;
  productId: string;
  product: Product;
  reskillPriceProducts: ReskillPriceProduct[];
  careerPlanUpgradesTo: CareerPlanUpgrade[];
  careerPlanUpgradesFrom: CareerPlanUpgrade[];
  LayoffDiscountRequest: LayoffDiscountRequest[];
}

export interface LayoffDiscountRequest {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  layoffReason: string;
  /** @format date-time */
  layoffDate: string;
  note?: string;
  attachments: object;
  status: LayoffDiscountRequestStatus;
  /** @format date-time */
  processedAt?: string;
  adminNote?: string;
  isUsed: boolean;
  userId: string;
  user: User;
  reskillPriceId?: string;
  reskillPrice?: ReskillPrice;
}

export interface Discount {
  id: string;
  name: string;
  discountType: DiscountType;
  discountValue: number;
  isActive: boolean;
  isEnded: boolean;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  discountProducts: DiscountProduct[];
  /** @format date-time */
  latestEndDateProduct?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  createdById: string;
  createdBy: User;
}

export interface EventWithPriority {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  type?: EventTypeV2;
  status: EventStatusV2;
  isHidden: boolean;
  sessionPriceType?: SessionPriceType;
  lowestPrice?: number;
  highestPrice?: number;
  totalPrice?: number;
  name?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  banner?: string;
  content?: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  isPreview?: boolean;
  duration?: number;
  durationType?: DurationTypeV2;
  locationType?: LocationType;
  roomUrl?: string;
  roomProvider?: RoomProvider;
  roomMadeBy?: RoomMadeBy;
  roomInfo?: object;
  qas?: object;
  agendas?: object;
  censorshipHistories: object[];
  radioOptions?: object;
  order?: number;
  host: User;
  priority: number;
  startDateEpoch: number;
  Product: Product[];
}

export enum EnterprisePaymentMethod {
  BANK_TRANSFER = "BANK_TRANSFER",
  CASH = "CASH",
}

export enum EnterprisePaymentStatus {
  PAID = "PAID",
  PENDING = "PENDING",
  OVERDUE = "OVERDUE",
  PARTIALLY_PAID = "PARTIALLY_PAID",
}

export enum EnterprisePeriodCycleStatus {
  CURRENT = "CURRENT",
  NEXT = "NEXT",
  EXPIRED = "EXPIRED",
}

export enum EnterpriseDeploymentType {
  SAAS = "SAAS",
  ON_PREMISE = "ON_PREMISE",
}

export interface EnterprisePlan {
  id: string;
  name: string;
  description?: string;
  periodType: PeriodType;
  periodValue: number;
  employeeLimit?: number;
  price: number;
  currency: Currency;
  isActive: boolean;
  features?: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  enterprises: Enterprise[];
  periods: EnterprisePeriod[];
}

export interface Enterprise {
  id: string;
  name: string;
  businessField: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  logo?: string;
  deploymentType: EnterpriseDeploymentType;
  domain?: string;
  subdomain?: string;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  lmsInfo?: object;
  enterprisePlanId?: string;
  enterprisePlan?: EnterprisePlan;
  periods: EnterprisePeriod[];
}

export interface EnterprisePeriod {
  id: string;
  enterpriseId: string;
  enterprisePlanId: string;
  planSnapshot: object;
  planPrice: number;
  /** @format date-time */
  periodStart: string;
  /** @format date-time */
  periodEnd: string;
  /** @format date-time */
  dueDate: string;
  paidAmount: number;
  /** @format date-time */
  paymentDate?: string;
  paymentMethod: EnterprisePaymentMethod;
  paymentStatus: EnterprisePaymentStatus;
  cycleStatus: EnterprisePeriodCycleStatus;
  confirmedById?: string;
  notes?: string;
  activityLog?: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  enterprise: Enterprise;
  enterprisePlan: EnterprisePlan;
  confirmedBy?: User;
}

export enum MentorRequestStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
}

export interface MentorRequest {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted: boolean;
  /** @format date-time */
  deletedAt?: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  consultationContent: string;
  status: MentorRequestStatus;
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assignee?: User;
  adminNote?: string;
  statusHistory: object;
}

export enum InhouseTrainingRequestStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
}

export interface InhouseTrainingRequest {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted: boolean;
  /** @format date-time */
  deletedAt?: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  trainingTopic: string;
  attachments?: object;
  status: InhouseTrainingRequestStatus;
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assignee?: User;
  adminNote?: string;
  statusHistory: object;
}

export enum ProgramConsultationRequestStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
}

export interface ProgramConsultationRequest {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted: boolean;
  /** @format date-time */
  deletedAt?: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  consultationTopic: string;
  attachments?: object;
  status: ProgramConsultationRequestStatus;
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assignee?: User;
  adminNote?: string;
  statusHistory: object;
}

export interface UserPasswordArchive {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  userId: string;
  user: User;
  createdBy: string;
  creator: User;
  encryptedPassword: string;
}

export enum BusinessChallengeStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  RESOLVED = "RESOLVED",
}

export interface BusinessChallenge {
  id: string;
  companyName: string;
  representative: string;
  phoneNumber: string;
  email: string;
  specialization: string;
  attachments?: object;
  description?: string;
  status: BusinessChallengeStatus;
  activityLog?: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  asigneeId?: string;
  asignee?: User;
}

export enum ExpertRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface ExpertRequest {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  specialization: string;
  profileLinks: string[];
  description: string;
  attachments?: object;
  status: ExpertRequestStatus;
  activityLog?: object;
  /** @format date-time */
  processedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  asigneeId?: string;
  asignee?: User;
}

export interface User {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted?: boolean;
  needChangePassword?: boolean;
  firstLogin?: boolean;
  /** @format date-time */
  deletedAt?: string;
  status: UserStatus;
  email: string;
  username: string;
  fullName?: string;
  avatar?: string;
  coverPhoto?: string;
  phone?: string;
  role: UserRole;
  /** @format date-time */
  dateOfBirth?: string;
  job?: string;
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  tiktok?: string;
  twitter?: string;
  youtube?: string;
  website?: string;
  knowledge: string[];
  skills: string[];
  intro?: string;
  introPhotos: string[];
  description?: string;
  emailContact?: string;
  fromAddress?: string;
  workAddress?: string;
  experience?: number;
  linkReferences: string[];
  registrationTopic?: string;
  /** @format date-time */
  lastLoginAt?: string;
  verifiedBy: UserVerificationProviders[];
  gender?: UserGender;
  loginType: UserLoginTypes;
  top?: number;
  appleId?: string;
  bankAccount: BankAccount[];
  bookingsCalendar: BookingCalendar[];
  bookingsEvent: BookingEvent[];
  businesses: BusinessUser[];
  businessesV2: Business[];
  calendars: Calendar[];
  calendarFrames: CalendarFrame[];
  cart: CartItem[];
  events: Event[];
  eventCount: number;
  followings: Follows[];
  followers: Follows[];
  categories: HostOnCategory[];
  categoriesV2: Category[];
  notifications: Notification[];
  orders: Order[];
  posts: Post[];
  refreshTokens: RefreshToken[];
  refund: Refund[];
  searchHistories: SearchHistory[];
  achievements: UserAchievement[];
  credentials?: UserCredentials;
  educations: UserEducation[];
  interests: UserInterest[];
  interestsV2: Category[];
  works: UserWork[];
  hostProfile?: HostProfile;
  moderationVerions: ModerationVersion[];
  ContentModeration: ContentModeration[];
  userSocketClients: UserSocketClient[];
  interactNotifications: Notification[];
  notificationTokens: NotificationToken[];
  Invoice: Invoice[];
  PaymentTransaction: PaymentTransaction[];
  Libraries: Library[];
  eventsV2: EventV2[];
  coHostEventSessions: EventSession[];
  subscriptions: Subscription[];
  userProducts: UserProduct[];
  onboardingStatus: UserOnboardingStatus;
  isPrivilege?: boolean;
  hostNotificationMode: HostNotificationMode;
  organization?: UserOrganization;
  surveys: Survey[];
  surveyResults: SurveyResult[];
  layoffDiscountRequests: LayoffDiscountRequest[];
  Combo: Combo[];
  Discount: Discount[];
  EventSession: EventSession[];
  EventWithPriority: EventWithPriority[];
  Lesson: Lesson[];
  OnlineCourse: OnlineCourse[];
  OrderV2: OrderV2[];
  Product: Product[];
  Section: Section[];
  Edoc: Edoc[];
  SubscriptionEmail: SubscriptionEmail[];
  EnterprisePeriods: EnterprisePeriod[];
  userLessonProgress: UserLessonProgress[];
  mentorRequestsAssigned: MentorRequest[];
  inhouseTrainingRequestsAssigned: InhouseTrainingRequest[];
  programConsultationRequestsAssigned: ProgramConsultationRequest[];
  passwordArchives: UserPasswordArchive[];
  createdPasswordArchives: UserPasswordArchive[];
  BusinessChallenge: BusinessChallenge[];
  ExpertRequest: ExpertRequest[];
  Voucher: Voucher[];
}

export interface OrderV2 {
  id: string;
  userId: string;
  status: OrderStatusV2;
  reason?: string;
  note?: string;
  isAdminCreated: boolean;
  totalAmount?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  paymentNote?: string;
  createdBy?: object;
  deletedBy?: object;
  /** @format date-time */
  deletedAt?: string;
  user: User;
  Invoice: Invoice[];
  OrderItemV2: OrderItemV2[];
  PaymentTransaction: PaymentTransaction[];
  refunds: Refund[];
}

export interface OrderItemDTO {
  id: string;
  orderId: string;
  itemType: ProductType;
  itemId: string;
  productId: string;
  quantity: number;
  voucherId?: string;
  price: number;
  status: OrderItemStatus;
  rawData?: object;
  reason?: string;
  note?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  order: OrderV2;
  voucher?: Voucher;
  product: Product;
  refundItem?: OrderItemToRefund;
}

export interface QuotationRequestDto {
  itemId: string;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  quantity: number;
  voucherCode?: string;
}

export interface QuotationDetailDto {
  originalPrice: number;
  discount: number;
  totalAmount: number;
}

export interface QuotationValidationDto {
  itemId: string;
  message: string;
  errorCode?: string;
  referenceId?: string;
}

export interface QuotationResponseDto {
  items?: QuotationItemDto[];
  summary?: QuotationDetailDto;
  isValid: boolean;
  validations?: QuotationValidationDto[];
}

export interface TopProductResponseDto {
  id: string;
  name: string;
  banner: string;
  paidCount: number;
  price: number;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  slug: string;
}

export interface QuotaDto {
  /** @min 1 */
  duration?: number | null;
  durationType?: object | null;
}

export interface VoucherProductRequestDTO {
  productId: string;
  isActive: boolean;
  isTicketUnlimited: boolean;
  ticketQuantityLimit?: number | null;
  voucherType?: VoucherType;
}

export interface UpsertVoucherRequestDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  code: string;
  description?: string;
  note?: string;
  discountType: DiscountType;
  /** @min 1 */
  discountValue: number;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  quotas?: QuotaDto[];
  products: VoucherProductRequestDTO[];
  hasRestrictedUsers: boolean;
  restrictedUsers?: string[];
}

export enum VoucherStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  UPCOMING = "UPCOMING",
}

export interface QuotaDTO {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  duration: number;
  durationType: string;
}

export interface VoucherDTO {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  code: string;
  description?: string;
  note?: string;
  status: VoucherStatus;
  discountType: DiscountType;
  discountValue: number;
  maxUses?: number;
  usedCount: number;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  isActive: boolean;
  isEnded: boolean;
  quotas?: QuotaDTO[];
  hasRestrictedUsers: boolean;
  restrictedUsers?: VoucherUserRestriction[];
  usageEmailList?: string[];
  createdById: string | null;
}

export interface VoucherWithProductTypesDTO {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  code: string;
  description?: string;
  note?: string;
  status: VoucherStatus;
  discountType: DiscountType;
  discountValue: number;
  maxUses?: number;
  usedCount: number;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  isActive: boolean;
  isEnded: boolean;
  quotas?: QuotaDTO[];
  hasRestrictedUsers: boolean;
  restrictedUsers?: VoucherUserRestriction[];
  usageEmailList?: string[];
  createdById: string | null;
  productTypes: ProductType[];
}

export interface PartialVoucherRequestDTO {
  isActive?: boolean;
  isEnded?: boolean;
}

export interface ExtraVoucherProductDTO {
  isActive: boolean;
  isTicketUnlimited: boolean;
  ticketQuantityLimit: number | null;
  usedCount: number;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
}

export interface VoucherProductDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
  fullProductId: string;
  extra: ExtraVoucherProductDTO;
}

export interface VoucherRestrictedUsersDTO {
  id: string;
  voucherId: string;
  email: string;
  voucher: VoucherDTO;
}

export interface VoucherOrderItemResponseDto {
  id: string;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  voucherCode: string | null;
  unitPrice: number;
  discount: number | null;
  totalPrice: number;
  finalPrice: number;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string | null;
  owerEmail?: string | null;
  user: HostDto;
  productName: string;
}

export enum UserRoleExternal {
  USER = "USER",
  HOST = "HOST",
}

export interface DataArray {
  value: string;
  label: string;
}

export interface AdminCreateUserDto {
  fullName: string;
  email: string;
  /**
   * @minLength 6
   * @maxLength 30
   */
  password: string;
  typeOfAccount?: UserRoleExternal;
  businesses: DataArray[];
  categories: DataArray[];
  isPrivilege?: boolean;
  phone?: string | null;
  organization?: UserOrganization;
}

export enum UserRoleInternal {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  PRODUCT_OWNER = "PRODUCT_OWNER",
  ACA_PARTNER = "ACA_PARTNER",
  MARKETING = "MARKETING",
  SALE = "SALE",
}

export interface CreateInternalUserDto {
  fullName: string;
  email: string;
  /**
   * @minLength 6
   * @maxLength 30
   */
  password: string;
  typeOfAccount?: "USER" | "HOST" | null;
  businesses: DataArray[];
  categories: DataArray[];
  isPrivilege?: boolean;
  phone?: string | null;
  organization?: UserOrganization;
  role?: UserRoleInternal;
}

export interface UpdateInternalUserDto {
  fullName?: string;
  email?: string;
  typeOfAccount?: UserRoleExternal | null;
  businesses?: DataArray[];
  categories?: DataArray[];
  isPrivilege?: boolean;
  phone?: string | null;
  organization?: UserOrganization;
  role?: UserRoleInternal;
}

export interface InfoData {
  step: string;
  attribute: string;
  note: string;
}

export interface RejectProfile {
  reason: string;
  note?: string;
  infos?: InfoData[];
}

export interface UpdateUserDto {
  fullName?: string;
  email?: string;
  typeOfAccount?: UserRoleExternal;
  businesses?: DataArray[];
  categories?: DataArray[];
  isPrivilege?: boolean;
  phone?: string | null;
  organization?: UserOrganization;
}

export interface AdminUserV2Dto {
  id: string;
  fullName: string;
  email: string;
  avatar: string;
  username: string;
}

export interface GetLibraryResponseDto {
  id: string;
  name: string;
  parentId: string | null;
  userId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateLibraryDto {
  /** Tên */
  name: string;
}

export interface GetResourceResponseDto {
  id: string;
  name: string;
  fileName: string;
  fileType: string | null;
  capacity: string;
  resourceType: "FILE" | "LINK";
  linkUrl: string | null;
  publicUrl: string | null;
  thumbnailUrl: string | null;
  content: string | null;
  libraryId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface GetLibraryAndResourceDto {
  libraries: GetLibraryResponseDto[];
  resources: GetResourceResponseDto[];
}

export interface UpdateLibraryDto {
  name: string;
}

export interface MembershipPriceDetailResponseDto {
  success: boolean;
  data: MembershipPriceDTO;
}

export interface CreateSubscriptionDto {
  bankAccountId?: string;
  voucher?: string;
}

export interface CreateSubscriptionResponseDto {
  success: boolean;
  subscriptionId: string;
  transactionId?: string | null;
  redirectUrl?: string | null;
}

export interface SubscriptionVoucherDto {
  voucher: string;
}

export interface SubscriptionVoucherValidationResponseDto {
  isValid: boolean;
  message?: string;
  messageFormatted?: string;
  data?: VoucherDTO;
}

export interface MyPaidSubscriptionsResponseDto {
  success: boolean;
  data: UserSubscriptionDto[];
}

export interface PaymentMethodDto {
  id: string;
  type: string;
  lastDigits: string;
}

export interface SubscriptionDetailsDto {
  id: string;
  status: string;
  membershipName?: string;
  price?: number;
  /** @format date-time */
  nextBillingDate?: string | null;
  /** @format date-time */
  expiryDate?: string | null;
  /** @format date-time */
  cancelledAt?: string | null;
  /** @format date-time */
  startAt: string;
  membershipPeriodValue?: number;
  membershipPeriodType?: string;
}

export interface PaymentRecordVoucherDto {
  id: string;
  code: string;
  discountType: string;
  discountValue: number;
  totalDiscount: number;
}

export interface PaymentRecordDto {
  id: string;
  date: string;
  time: string;
  originalPrice: number;
  voucher: PaymentRecordVoucherDto | null;
  paymentAmount: number;
  status:
    | "PENDING"
    | "PENDING_UPGRADE"
    | "PAID"
    | "FAILED"
    | "CANCELLED"
    | "REFUNDED";
  membershipName: string;
}

export interface PaymentSummaryResponseDto {
  paymentMethod: PaymentMethodDto;
  subscription: SubscriptionDetailsDto;
  paymentRecords: PaymentRecordDto[];
}

export interface SubscriptionPeriodDetailsDto {
  id: string;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  paymentStatus: string;
  /** @format date-time */
  paidAt: string | null;
  paymentReference: string | null;
  lastTransactionRef: string | null;
  invoiceAmount: number;
  invoiceCurrency: string;
  membershipName: string;
  paymentMethod: string;
  cardNumber?: string | null;
  /** @format date-time */
  nextBillingDate: string | null;
  nextBillingAmount: number | null;
}

export interface SubscriptionPeriodDetailsResponseDto {
  success: boolean;
  periodDetails?: SubscriptionPeriodDetailsDto | null;
  message?: string | null;
}

export interface CancelSubscriptionResponseDto {
  id: string;
  status: object;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  /** @format date-time */
  cancelledAt: string;
  /** @format date-time */
  lastPaymentAt: string | null;
}

export interface UpdateSubscriptionPlanResponseDto {
  success: boolean;
  error?: string;
  subscription?: SubscriptionDetailsDto;
  redirectUrl?: string;
}

export interface UpdateSubscriptionPaymentCardDto {
  /** ID of the bank account to use for payment */
  bankAccountId: string;
}

export interface OrderDto {
  id: string;
  status: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  user: HostDto;
}

export interface RefundByUserResponseDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  orderId: string;
  amount: number;
  order: OrderDto;
  status: "PENDING" | "PROCESSING" | "SUCCESS" | "FAILED";
  approvalStatus:
    | "PENDING"
    | "PROCESSING"
    | "SUCCESS"
    | "FAILED"
    | "AWAITING_INFO";
  type: "MANUAL" | "AUTO";
  refundItems: object[][];
  refundHistory: RefundHistory[];
  refundAccountId: string;
  refundAccount: BankAccount;
}

export interface UpdateRefundBankAccountRequestDto {
  refundAccountId: string;
}

export interface UpdateRefundRequestDto {
  status?: "PENDING" | "PROCESSING" | "SUCCESS" | "FAILED";
  approvalStatus?:
    | "PENDING"
    | "PROCESSING"
    | "SUCCESS"
    | "FAILED"
    | "AWAITING_INFO";
  reason?: string;
}

export enum DiscountStatus {
  HAPPENING = "HAPPENING",
  ENDED = "ENDED",
  UPCOMING = "UPCOMING",
}

export interface DiscountWithProductTypesDTO {
  id: string;
  name: string;
  discountType: DiscountType;
  discountValue: number;
  isTimeUnlimited: boolean;
  isActive: boolean;
  isEnded: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  /** @format date-time */
  createdAt: string;
  status: DiscountStatus;
  createdById: string | null;
  productTypes: ProductType[];
}

export interface DiscountDTO {
  id: string;
  name: string;
  discountType: DiscountType;
  discountValue: number;
  isTimeUnlimited: boolean;
  isActive: boolean;
  isEnded: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  /** @format date-time */
  createdAt: string;
  status: DiscountStatus;
  createdById: string | null;
}

export interface ExtraDiscountProductDTO {
  isActive: boolean;
  isTicketUnlimited: boolean;
  ticketQuantityLimit: number | null;
}

export interface DiscountProductDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
  fullProductId: string;
  extra: ExtraDiscountProductDTO;
}

export interface DiscountProductRequestDTO {
  productId: string;
  isActive: boolean;
  isTicketUnlimited: boolean;
  ticketQuantityLimit?: number | null;
}

export interface UpsertDiscountRequestDTO {
  name: string;
  isTimeUnlimited: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  isActive: boolean;
  discountType: DiscountType;
  discountValue: number;
  products: DiscountProductRequestDTO[];
}

export interface PartialDiscountRequestDTO {
  isEnded?: boolean;
  isActive?: boolean;
}

export interface DiscountOrderItemResponseDto {
  id: string;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  voucherCode: string | null;
  unitPrice: number;
  discount: number | null;
  totalPrice: number;
  finalPrice: number;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string | null;
  owerEmail?: string | null;
  user: HostDto;
  productName: string;
}

export type Object = object;

export interface AppleInAppCallbackDto {
  transactionId: string;
  appleTransactionId?: string;
}

export interface RetryPaymentRequestDto {
  orderId: string;
}

export interface PayoutSupportListResponseDto {
  supportedBanks: object;
}

export interface AddItemDto {
  id: string;
  type: string;
  note?: string;
}

export interface CartItemDetailDto {
  id: string;
  productId: string;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  openingSaleDate?: string;
  quota?: number;
  limitTicketPerUser?: number;
  name: string;
  sortOrder?: number;
  banner?: string;
  slug?: string;
  host: HostDto;
  isFree?: boolean;
  isCombo?: boolean;
  isHidden?: boolean;
  isPublished?: boolean;
  purchasable: boolean;
  originalPrice?: number | null;
  farePrice: number;
  status: string;
  orderCount: number;
  revisionId?: string;
  parentId?: string;
  eventSessionId?: string;
  eventId?: string;
  childrenIds?: string[];
  disabled?: boolean;
  socialCommunities?: object;
  discountProductId?: string | null;
  children?: string[];
  cartItemId?: string;
  quantity?: number;
  note?: string;
  partner?: string;
  discount?: object;
  isSessionGroup?: boolean;
  type?: string;
  extra?: object;
}

export interface PromotionDiscountDTO {
  amount: number;
  type: DiscountType;
  hasEndDate: boolean;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  hasLimitUses: boolean;
  remainingUses: number | null;
  limitUses: number | null;
  usedCount: number | null;
}

export interface CartItemDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  itemId?: string;
  detail?: CartItemDetailDto;
  quantity: number;
  note?: string | null;
  referenceId?: string | null;
  partner?: string | null;
  discount?: PromotionDiscountDTO | null;
}

export interface CountItemDto {
  total: number;
}

export interface AddCartItemDto {
  id: string;
  type: string;
  /** @min 1 */
  quantity?: number;
  note?: string;
  partner?: string;
}

export interface UpdateItemDto {
  /** @min 1 */
  quantity: number;
}

export interface CreateSlugDto {
  source: string;
}

export interface CreateEventDto {
  type: EventType;
  status: EventStatus;
  name: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  farePrice: number;
  isFree: boolean;
  limitAudiences: number;
  qas: object;
  outlines: object;
  categories: string[];
}

export interface EventEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  hostId: string;
  type: EventType;
  status: EventStatus;
  name: string;
  slug: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  farePrice: number;
  duration: number;
  durationType: DurationType;
  isFree: boolean;
  limitAudiences: number;
  qas: object;
  outlines: object;
  roomUrl?: string;
  id: string;
}

export interface UpdateEventDto {
  type?: EventType;
  status?: EventStatus;
  name?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  banner?: string;
  content?: string;
  hashtags?: string[];
  photos?: string[];
  docs?: string[];
  whyChooses?: string[];
  objects?: string[];
  videos?: string[];
  farePrice?: number;
  isFree?: boolean;
  limitAudiences?: number;
  qas?: object;
  outlines?: object;
  categories?: string[];
}

export interface CheckinQrTicketDto {
  encryptedString: string;
  eventId?: string;
}

export interface CheckinQrTicketResponseDto {
  isValid: boolean;
  message: string;
  errorCode?:
    | "INVALID_QR"
    | "ALREADY_CHECKED_IN"
    | "NOT_IN_EVENT"
    | "FAIL_TO_CHECK_IN";
  fullName?: string;
  ticketType?: string;
  ticketId?: string;
}

export interface CreateProductSurveyDTO {
  surveyId: string;
  required: boolean;
}

export enum SocialCommunityType {
  ZALO = "ZALO",
  FACEBOOK = "FACEBOOK",
}

export interface EventSocialCommunityInput {
  socialCommunityType: SocialCommunityType | null;
  socialCommunityName: string | null;
  socialCommunityLink: string | null;
}

export interface TicketTierInputDto {
  id?: string;
  name: string | null;
  description: string | null;
  price: number;
  limitTicketPerUser: number | null;
  limitAudiences: number | null;
}

export interface EventSessionInput {
  order: number;
  roomMadeBy: RoomMadeBy;
  roomProvider: RoomProvider;
  radioOptions: object | null;
  address: string | null;
  id: string;
  name: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  banner: string;
  content: string;
  roomUrl: string;
  coHostId: string;
  coHostInfo: object;
  roomInfo: object;
  ticketTiers: TicketTierInputDto[];
}

export interface CreateEventV2Input {
  type: EventTypeV2;
  locationType: LocationType;
  addressScope?: AddressScope;
  ticketScope?: TicketScope;
  startDate: string | null;
  endDate: string | null;
  roomUrl: string | null;
  productSurveys?: CreateProductSurveyDTO[];
  roomMadeBy: RoomMadeBy | null;
  roomProvider: RoomProvider | null;
  categories: string[];
  roomInfo: object | null;
  radioOptions: object | null;
  sessionPriceType: SessionPriceType | null;
  socialCommunities: EventSocialCommunityInput[] | null;
  address: string | null;
  name: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  qas: object;
  agendas: object;
  /** @default false */
  isPreview: boolean;
  ticketTiers: TicketTierInputDto[];
  eventSessions: EventSessionInput[];
}

export interface EventSocialCommunity {
  socialCommunityType: SocialCommunityType | null;
  socialCommunityName: string | null;
  socialCommunityLink: string | null;
}

export interface Ticket {
  id: string;
  productId: string;
  price: number;
  name: string;
  description: string | null;
  type: TicketTierType;
  paidCount: number;
  limitAudiences: number | null;
  limitTicketPerUser: number | null;
}

export interface EventSessionDTO {
  id: string;
  createdAt: string;
  updatedAt: string;
  slug: string;
  name?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  banner?: string;
  content?: string;
  duration?: number;
  durationType?: DurationTypeV2;
  roomUrl?: string;
  roomProvider?: RoomProvider;
  roomMadeBy?: RoomMadeBy;
  roomInfo?: object;
  order?: number;
  censorshipHistories: object[];
  address?: string;
  radioOptions?: object;
  hostId: string;
  coHostInfo?: object;
  coHostId?: string;
  eventId: string;
  event: EventV2;
  host: User;
  coHost?: User;
  tickets: Ticket[];
  ticketTiers: TicketTier[];
}

export interface EventSessionProduct {
  paidCount: number;
}

export interface UserResponseDto {
  email: string;
  username: string;
  fullName: string;
  avatar: string;
  coverPhoto: string;
  phone: string;
  status: "ACTIVE" | "INACTIVE";
}

export interface ProductSurveyDTO {
  productId: string;
  surveyId: string;
  required: boolean;
}

export interface OrderResponseDto {
  user: OrderResponseDto;
}

export interface EventV2Response {
  id: string;
  slug: string;
  name: string | null;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  banner: string | null;
  content: string | null;
  hashtags: string[];
  photos: string[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  hostId: string;
  host: User;
  type: EventTypeV2;
  locationType: LocationType;
  addressScope: AddressScope;
  address?: string | null;
  status: EventStatusV2;
  sessionPriceType: SessionPriceType | null;
  ticketScope: TicketScope | null;
  lowestPrice: number | null;
  highestPrice: number | null;
  totalPrice: number | null;
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  duration: number | null;
  durationType: DurationTypeV2 | null;
  isPreview: boolean;
  roomUrl: string | null;
  roomProvider: RoomProvider | null;
  roomMadeBy: RoomMadeBy | null;
  roomInfo: object;
  socialCommunities: EventSocialCommunity[];
  qas: object;
  agendas: object;
  censorshipHistories: object;
  radioOptions: object;
  productId: string;
  product: Product;
  eventSessions: EventSessionDTO[];
  tickets: Ticket[];
  categoriesV2: Category[];
  eventSessionProduct?: EventSessionProduct | null;
  user: UserResponseDto;
  productSurveys?: ProductSurveyDTO[] | null;
  discount?: PromotionDiscountDTO | null;
  order: OrderResponseDto;
}

export interface DraftEventV2Input {
  type: EventTypeV2;
  productSurveys?: CreateProductSurveyDTO[];
  locationType: LocationType;
  addressScope: AddressScope;
  ticketScope: TicketScope;
  startDate: string | null;
  endDate: string | null;
  roomUrl: string | null;
  roomMadeBy: RoomMadeBy | null;
  roomProvider: RoomProvider | null;
  categories: string[];
  roomInfo: object | null;
  radioOptions: object | null;
  sessionPriceType: SessionPriceType | null;
  socialCommunities: EventSocialCommunityInput[] | null;
  address: string | null;
  name: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  qas: object;
  agendas: object;
  /** @default false */
  isPreview: boolean;
  eventSessions: EventSessionInput[];
  ticketTiers: TicketTierInputDto[];
}

export enum EventState {
  All = "all",
  Live = "live",
  Today = "today",
  Future = "future",
  Past = "past",
  Draft = "draft",
}

export enum EventDuration {
  Value = "",
  FROM0TO30MINUTES = "FROM_0_TO_30_MINUTES",
  FROM30TO60MINUTES = "FROM_30_TO_60_MINUTES",
  FROM60TO90MINUTES = "FROM_60_TO_90_MINUTES",
  FROM90TO120MINUTES = "FROM_90_TO_120_MINUTES",
  OVER120MINUTES = "OVER_120_MINUTES",
  DURATION_IN_DAY = "DURATION_IN_DAY",
  DURATION_OVER_DAY = "DURATION_OVER_DAY",
}

export interface OrderItemEventCount {
  all: number;
  today: number;
  coming: number;
  going_on: number;
  happened: number;
}

export interface CreateEventCategoryDto {
  id: string;
  name: string;
  slug: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  thumbnail: string;
  icon?: string;
  description?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
}

export interface EventCategoryEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  name: string;
  slug: string;
  thumbnail: string;
  icon?: string;
  description?: string;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  id: string;
}

export interface UpdateEventCategoryDto {
  id?: string;
  name?: string;
  slug?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  thumbnail?: string;
  icon?: string;
  description?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  keywordsKnowledge?: string[];
  keywordsSkill?: string[];
}

export interface VerifyOtpDto {
  /**
   * @minLength 6
   * @maxLength 6
   */
  otp: string;
  verificationKey: string;
  check: string;
}

export interface CategoryDto {
  /** ID of the category */
  id: string;
  /** Slug of the category */
  slug: string;
  /** Name of the category */
  name: string;
  /** Description of the category */
  description: string;
  /** ID of the parent category */
  parentId: string;
  /** ID of the business the category belongs to */
  businessId: string;
  /** ID of the user who created the category */
  createdBy: string;
  /** ID of the user who updated the category */
  updatedBy: string;
  /** Date when the category was created */
  createdAt: string;
  /** @format date-time */
  deletedAt?: string;
  top?: number;
  status: Status;
  isRoot: boolean;
  thumbnail: string;
  hostCount: number;
  eventCount: number;
  type: ("HOST" | "EVENT" | "ONLINE_COURSE")[];
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  eventsOnCategories: EventsOnCategories[];
  userInterest: UserInterest[];
  hosts: User[][];
  events: Event[][];
  subCategories: CategoryDto[][];
  business: BussinessDto[];
}

export interface RegisterDto {
  phone: string;
  code: VerifyOtpDto;
  email: string;
  fullName: string;
  categories: CategoryDto[];
  linkReferences?: string[];
  businesses: string[];
  registrationTopic?: string;
  fromAddress?: string;
  experience?: number;
  workAddress?: string;
  job?: string;
}

export interface RegisterHostProfileDto {
  invoiceEmail: string[];
  typeOfActivity: string;
  docs: string;
  contactAddress: string;
  organizationName: string;
  organizationTaxNumber: string;
  personalTaxNumber: string;
  contactCity: string;
  contactDistrict: string;
  contactWard: string;
  typeOfId: string;
  idNumber: string;
  imageHandheldId: string;
  imageIdBack: string;
  imageIdFront: string;
  nameInId: string;
}

export interface ResubmitHostProfileDto {
  invoiceEmail?: string[];
  typeOfActivity?: string;
  docs?: string;
  contactAddress?: string;
  organizationName?: string;
  organizationTaxNumber?: string;
  personalTaxNumber?: string;
  contactCity?: string;
  contactDistrict?: string;
  contactWard?: string;
  typeOfId?: string;
  idNumber?: string;
  imageHandheldId?: string;
  imageIdBack?: string;
  imageIdFront?: string;
  nameInId?: string;
}

export interface GetOtpDto {
  type: "EMAIL" | "SMS" | "ZNS";
  action:
    | "VERIFY_EMAIL"
    | "VERIFY_PHONE"
    | "FORGOT_PASSWORD"
    | "TERMINATE_ACCOUNT"
    | "CHANGE_PASSWORD";
  check: string;
}

export interface UpdateUserDataDto {
  intro: string;
  introPhotos: string[];
  skills: string[];
  knowledge: string[];
  description: string;
  workAddress: string;
  fromAddress: string;
  emailContact: string;
  website: string;
  twitter: string;
  tiktok: string;
  linkedin: string;
  instagram: string;
  youtube: string;
  facebook: string;
}

export interface UpdateUserWorkDataDto {
  id: string;
  userId: string;
  title: string;
  description: string;
  companyName: string;
  location: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  isCurrent: boolean;
  companyLogo: string;
  type:
    | "FUll_TIME"
    | "REMOTE"
    | "PARTTIME"
    | "HYBRID"
    | "FREELANCE"
    | "INTERN"
    | "OTHER";
}

export interface UpdateUserEduDataDto {
  id: string;
  userId: string;
  school: string;
  description: string;
  degree: string;
  fieldOfStudy: string;
  grade: string;
  location: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  schoolLogo: string;
}

export interface UpdateUserEchDataDto {
  id: string;
  userId: string;
  title: string;
  description: string;
  location: string;
  /** @format date-time */
  date: string;
  links: string[];
  medias: string[];
  organizational: string;
  thumbnail: string;
}

export interface UpsertUserBankAccount {
  id?: string;
  default?: boolean;
  accountNumber: string;
  accountHolderName: string;
  bankName: string;
}

export interface CheckUserPaymentMethodInUse {
  id: string;
}

export interface CategoryData {
  categoryId: string;
}

export interface UpdateUserOnCategoryV2Dto {
  data: CategoryData[];
}

export interface BussinessDto {
  /** ID of the business */
  id: string;
  /** Name of the business */
  name: string;
  /** Thumbnail of the business */
  thumbnail?: string;
  /** Description of the business */
  description?: string;
  /** Slug of the business */
  slug: string;
}

export interface UpdateHostNotificationModeDto {
  /** The host notification mode to set */
  mode:
    | "OFF"
    | "INSTANT"
    | "DAILY_BATCH_1"
    | "DAILY_BATCH_2"
    | "DAILY_BATCH_3"
    | "DAILY_BATCH_4"
    | "DAILY_BATCH_5";
}

export interface GetSectionResponseDto {
  id: string;
  title: string;
  /** @default "DRAFT" */
  status: "DRAFT" | "PUBLISHED";
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface GetOnlineCourseVersionResponseDto {
  id: string;
  onlineCourseId: string;
  version: number;
  status: "CREATED" | "REVIEWED" | "APPROVED" | "REJECTED";
  sections?: GetSectionResponseDto[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export enum PricingPlan {
  Free = "free",
  Paid = "paid",
}

export interface ProductDTO {
  id: string;
  slug?: string;
  /** @format date-time */
  startSellingDate?: string;
  /** @format date-time */
  endSellingDate?: string;
  type: ProductType;
  price: number;
  pricingPlan?: PricingPlan;
  kind?: ProductKind;
  paidCount: number;
  availableDays?: number;
  limitAudiences?: number;
  /** @format date-time */
  releaseDate?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  ownerId?: string;
  owner?: UserDto;
  isAcademy?: boolean;
  isReskill?: boolean;
  isLaunchpad?: boolean;
  isOnair?: boolean;
  isLnD?: boolean;
  coverUrl?: string;
  description?: string;
}

export interface LibraryDTO {
  id: string;
  name: string;
  userId: string;
  parentId?: string;
  path: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ResourceDTO {
  id: string;
  name: string;
  fileName: string;
  fileType?: string;
  duration?: number;
  isMain?: boolean;
  capacity: string;
  resourceType: ResourceType;
  linkUrl?: string;
  publicUrl?: string;
  thumbnailUrl?: string;
  content?: string;
  libraryId: string;
  library: LibraryDTO;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface LessonResourceDTO {
  lessonId: string;
  resourceId: string;
  resource: ResourceDTO;
  isMain: boolean;
}

export interface LessonDTO {
  id: string;
  title: string;
  content: string;
  description?: string;
  index: number;
  type: LessonType;
  status: LessonStatus;
  thumbnail?: string;
  sectionId?: string;
  canPreview: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  lessonResources: LessonResourceDTO[];
}

export interface SectionResourceDto {
  sectionId: string;
  resourceId: string;
  isMain: boolean;
}

export interface SectionDTO {
  id: string;
  title: string;
  status: SectionStatus;
  thumbnail?: string;
  lessons: LessonDTO[];
  /** @format date-time */
  createdAt: string;
  index: number;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  onlineCourseId: string;
  ownerId: string;
  sectionResources: SectionResourceDto[];
}

export interface EventV2BaseDTO {
  id: string;
  slug: string;
  name: string | null;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  banner: string | null;
  content: string | null;
  hashtags: string[];
  photos: string[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  hostId: string;
  host: User;
  type: EventTypeV2;
  locationType: LocationType;
  addressScope: AddressScope;
  address?: string | null;
  status: EventStatusV2;
  sessionPriceType: SessionPriceType | null;
  ticketScope: TicketScope | null;
  lowestPrice: number | null;
  highestPrice: number | null;
  totalPrice: number | null;
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  duration: number | null;
  durationType: DurationTypeV2 | null;
  isPreview: boolean;
  roomUrl: string | null;
  roomProvider: RoomProvider | null;
  roomMadeBy: RoomMadeBy | null;
  roomInfo: object;
  socialCommunities: EventSocialCommunity[];
  qas: object;
  agendas: object;
  censorshipHistories: object;
  radioOptions: object;
  productId: string;
  product: Product;
  eventSessions: EventSessionDTO[];
  tickets: Ticket[];
  categoriesV2: Category[];
  eventSessionProduct?: EventSessionProduct | null;
  user: UserResponseDto;
  productSurveys?: ProductSurveyDTO[] | null;
  order: OrderResponseDto;
}

export interface ProductIncludesDto {
  events?: EventV2BaseDTO[];
  courses?: SectionDTO[];
}

export interface OnlineCourseResourceDto {
  onlineCourseId: string;
  resourceId: string;
  isMain: boolean;
}

export interface OnlineCourseDTO {
  id: string;
  name: string | null;
  description: string | null;
  coverImage: string | null;
  wallpaper: string | null;
  currentVersion: number;
  displayed: boolean;
  status:
    | "DRAFT"
    | "UNPUBLISHED"
    | "REVIEWED"
    | "PUBLISHED"
    | "REJECTED"
    | "DELETED"
    | "PENDING_APPROVAL_WITH_ADMIN";
  statusReason: string | null;
  /** @example false */
  videoCompletionRequired: boolean;
  /** @format date-time */
  startAt: string | null;
  onlineCourseVersions?: GetOnlineCourseVersionResponseDto;
  productId?: string | null;
  product?: ProductDTO;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  benefit?: string | null;
  archived?: string | null;
  tags?: string | null;
  questionAndAnswers?: string | null;
  sections: SectionDTO[];
  ownerId: string;
  censorshipHistories: object[];
  existDraftVersion?: string;
  productIncludes?: ProductIncludesDto;
  onlineCourseResources: OnlineCourseResourceDto[];
  discount?: PromotionDiscountDTO | null;
}

export interface GetRegisterHostProfileResponseDto {
  job: string;
  phone: string;
  linkReferences: string[];
  categoriesV2: object[];
  experience: number;
}

export interface GetUserOnboardingStatusResponseDto {
  status:
    | "NEW"
    | "USER"
    | "NEW_HOST"
    | "HOST_APPROVED"
    | "HOST_REJECTED"
    | "HOST_RESUBMIT"
    | null;
}

export interface RegisterHostProfileV2ResponseDto {
  success: boolean;
}

export interface CategoryRegisterHostDto {
  value: string;
  label: string;
}

export interface RegisterHostProfileV2Dto {
  email: string;
  /** @minLength 1 */
  job: string;
  phone: string;
  categories: CategoryRegisterHostDto[];
  linkReferences: string[];
  /** @min 1 */
  experience: number;
}

export interface OnlineCourseWithProgressDTO {
  id: string;
  name: string | null;
  description: string | null;
  coverImage: string | null;
  wallpaper: string | null;
  currentVersion: number;
  displayed: boolean;
  status:
    | "DRAFT"
    | "UNPUBLISHED"
    | "REVIEWED"
    | "PUBLISHED"
    | "REJECTED"
    | "DELETED"
    | "PENDING_APPROVAL_WITH_ADMIN";
  statusReason: string | null;
  /** @example false */
  videoCompletionRequired: boolean;
  /** @format date-time */
  startAt: string | null;
  onlineCourseVersions?: GetOnlineCourseVersionResponseDto;
  productId?: string | null;
  product?: ProductDTO;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  benefit?: string | null;
  archived?: string | null;
  tags?: string | null;
  questionAndAnswers?: string | null;
  sections: SectionWithProgressDTO[];
  ownerId: string;
  censorshipHistories: object[];
  existDraftVersion?: string;
  productIncludes?: ProductIncludesDto;
  onlineCourseResources: OnlineCourseResourceDto[];
  progress: BaseProgressDTO;
}

export interface GetOnlineCourseRegisteredUsersResponseDto {
  id: string;
  email: string;
  fullName: string;
  phone?: string;
  price: number;
  voucherCode?: string;
  paymentAmount: number;
  status?: string;
  /** @format date-time */
  purchaseDate: string;
  discountByCampaign?: number;
  discountByVoucher?: number;
}

export interface GetOnlineCourseWithSectionResponseDto {
  id: string;
  name: string | null;
  description: string | null;
  coverImage: string | null;
  wallpaper: string | null;
  currentVersion: number;
  displayed: boolean;
  status:
    | "DRAFT"
    | "UNPUBLISHED"
    | "REVIEWED"
    | "PUBLISHED"
    | "REJECTED"
    | "DELETED"
    | "PENDING_APPROVAL_WITH_ADMIN";
  statusReason: string | null;
  /** @example false */
  videoCompletionRequired: boolean;
  onlineCourseVersions?: GetOnlineCourseVersionResponseDto[];
  productId: string | null;
  product?: object;
  owner?: object;
  /** @format date-time */
  startAt: string | null;
  benefit: string | null;
  archived: string | null;
  questionAndAnswers: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface UpsertCourseSocialCommunityDto {
  socialCommunityType: SocialCommunityType | null;
  socialCommunityName: string | null;
  socialCommunityLink: string | null;
}

export interface UpsertCourseDto {
  id: string;
  productId: string;
  name: string;
  description: string;
  coverImage: string;
  wallpaper: string;
  /** @default true */
  videoCompletionRequired: boolean;
  /** @format date-time */
  startAt: string;
  /** @default "UNPUBLISHED" */
  status:
    | "DRAFT"
    | "UNPUBLISHED"
    | "REVIEWED"
    | "PUBLISHED"
    | "REJECTED"
    | "DELETED"
    | "PENDING_APPROVAL_WITH_ADMIN";
  benefit: string;
  archived: string;
  questionAndAnswers: string;
  tags: string;
  price: number;
  pricingPlan: "free" | "paid";
  availableDays: number;
  /** @default false */
  isAcademy: boolean;
  ownerId: string;
  socialCommunities: UpsertCourseSocialCommunityDto[];
  resourceIds: string[];
  productSurveys?: CreateProductSurveyDTO[];
  isReskill: boolean;
  isLaunchpad: boolean;
  isOnair: boolean;
}

export interface UpdateOnlineCourseDisplayDto {
  displayed: boolean;
}

export interface UserLessonProgressDTO {
  id: string;
  userId: string;
  lessonId: string;
  productId: string;
  status: LessonProgressStatus;
  /** @min 0 */
  currentPosition: number;
  /** @format date-time */
  lastAccessedAt?: string;
  /** @format date-time */
  completedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** Priority level for processing the progress update */
export enum LessonProgressPriority {
  High = "high",
  Normal = "normal",
}

export interface UpdateLessonProgressWithPriorityDTO {
  /** @min 0 */
  currentPosition?: number;
  /**
   * Priority level for processing the progress update
   * @example "normal"
   */
  priority?: LessonProgressPriority;
}

export interface LessonWithProgressDTO {
  id: string;
  title: string;
  content: string;
  description?: string;
  index: number;
  type: LessonType;
  status: LessonStatus;
  thumbnail?: string;
  sectionId?: string;
  canPreview: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  lessonResources: LessonResourceDTO[];
  progress: BaseProgressDTO;
}

export interface SectionWithProgressDTO {
  id: string;
  title: string;
  status: SectionStatus;
  thumbnail?: string;
  lessons: LessonWithProgressDTO[];
  /** @format date-time */
  createdAt: string;
  index: number;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  onlineCourseId: string;
  ownerId: string;
  sectionResources: SectionResourceDto[];
  progress: BaseProgressDTO;
}

export interface UpsertSectionDto {
  title: string;
  status?: "DRAFT" | "PUBLISHED";
  thumbnail?: string;
  index: number;
  resourceIds?: string[];
  courseId: string;
  id?: string;
}

export interface UpsertLessonResourceDTO {
  id: string;
  isMain: boolean;
}

export interface UpsertLessonDTO {
  title: string;
  content: string;
  description: string;
  /** @default "TEXT" */
  type: "VIDEO" | "PDF" | "TEXT";
  /** @default "DRAFT" */
  status: "DRAFT" | "PUBLISH";
  index: number;
  thumbnail?: string;
  sectionId: string;
  id: string;
  courseId: string;
  canPreview: boolean;
  resources?: UpsertLessonResourceDTO[];
}

export interface CreateResourceDto {
  /** Generate Name */
  name: string;
  /** Current Filename */
  fileName: string;
  fileType: string;
  /** @default "FILE" */
  resourceType: "FILE" | "LINK";
  duration?: number | null;
  capacity: number;
  linkUrl?: string;
  publicUrl?: string;
  thumbnailUrl?: string;
  content?: string;
  libraryId: string;
}

export interface UpdateResourceDto {
  /** Generate Name */
  name?: string;
  /** Filename */
  fileName?: string;
  linkUrl?: string;
  publicUrl?: string;
  thumbnailUrl?: string;
  libraryId?: string;
}

export interface SurveyUserDetailsDTO {
  id: string;
  title: string;
  banner: string;
  description: string | null;
  /** @format date-time */
  createdAt: string;
  createdById: string;
  status: "ACTIVE" | "INACTIVE" | "PREVIEW";
  required: boolean;
  submitted?: boolean;
  productId: string;
}

export interface ProductHomePageDTO {
  name: string;
  slug: string | null;
  paidCount: number;
  type: ProductType;
  banner: string;
  host: HostDto;
  originalPrice: number | null;
  price: number;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  discountValue?: string | null;
  discountType?: "PERCENTAGE" | "FIXED_AMOUNT" | null;
  totalLesson?: number | null;
}

export interface OrderProductDTO {
  id: string;
  status: OrderStatusV2;
  orderItemId: string;
  orderItemStatus: OrderItemStatus;
}

export interface ProductAccessibleDTO {
  isAccessible: boolean;
  order: OrderProductDTO | null;
}

export interface ProductRequestDto {
  isAcademy?: boolean;
  isReskill?: boolean;
  isLaunchpad?: boolean;
  isOnair?: boolean;
}

export interface GetContentAndProductsDto {
  id: string;
  name: string;
  status: string;
  slug?: string | null;
  content?: string | null;
  isActive?: boolean | null;
  originalPrice?: number | null;
  ownerId: string;
  /** @format date-time */
  updatedAt: string | null;
  banner: string;
  /** @format date-time */
  createdAt: string | null;
  paidCount?: number | null;
  price?: number | null;
  type: string;
  productId?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  startDate?: string | null;
  isDeleted?: boolean | null;
  isHidden?: boolean | null;
  highestPrice?: number | null;
  lowestPrice?: number | null;
  discountType?: "PERCENTAGE" | "AMOUNT" | null;
  discountValue?: number | null;
  /** @format date-time */
  endSellingDate?: string | null;
  /** @format date-time */
  startSellingDate?: string | null;
  kind?: "DEFAULT" | "UPCOMING" | null;
}

export interface MembershipPartProductDTO {
  productId: string;
  productType:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  banner: string;
  name: string;
  price: number;
}

export interface MembershipPartDTO {
  name: string;
  part: number;
  upcomingPartDays: number;
  upcomingPartUnit: string;
  products: MembershipPartProductDTO[];
}

export interface MembershipWithRelationsDTO {
  id: string;
  name: string;
  isMain: boolean;
  description: string | null;
  status: MembershipStatus;
  paidCount: number;
  prices: MembershipPriceDTO[];
  parts: MembershipPartDTO[];
}

export interface ProductItemDetailDto {
  id: string;
  name: string;
  banner: string;
  slug: string;
  /** @format date-time */
  type: string;
  productId: string;
  farePrice: string;
  paidCount: number;
  limitAudiences: number;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  /** @format date-time */
  openingSaleDate?: string;
  status: string;
  hostId: string;
  isActive?: boolean;
}

export interface ProductOwnerDto {
  /** @format date-time */
  startSellingDate?: string;
  /** @format date-time */
  endSellingDate?: string;
  type: ProductType;
  ownerId?: string;
  owner?: UserDto;
  coverUrl?: string;
  description?: string;
}

export interface ComboResponseDto {
  id: string;
  slug: string;
  name: string;
  discountType: "PERCENTAGE" | "AMOUNT";
  discountValue: number;
  originalPrice: number;
  price: number;
  paidCount: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  hostId?: string;
  hostUserName?: string;
  isActive: boolean;
  items: ProductItemDetailDto[];
  product?: ProductOwnerDto;
  productId?: string;
}

export interface AvailableProductComboResponse {
  id: string;
  slug?: string;
  type: ProductType;
  paidCount: number;
  limitAudiences?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  ownerId?: string;
  detail: ProductItemDetailDto;
}

export interface ComboBuyerResponseDto {
  /** Order item id */
  id: string;
  fullName?: string;
  email?: string;
  phone?: string;
  discountType?: "PERCENTAGE" | "AMOUNT";
  discountValue: number;
  voucherCode?: string;
  price: number;
  /** @format date-time */
  createdAt: string;
}

export interface ComboRequestDto {
  /** @maxLength 200 */
  name: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  coverUrl: string;
  description: string;
  productIds: string[];
  discountType: "PERCENTAGE" | "AMOUNT";
  discountValue: number;
}

export interface ReskillPriceUpgradeDTO {
  toPlanId: string;
  price: number;
  discountPrice?: number | null;
}

export interface ReskillPriceRequestDTO {
  id?: string;
  name: string;
  periodValue: number;
  price: number;
  isActive: boolean;
  productIds: string[];
  upgrades: ReskillPriceUpgradeDTO[];
}

export interface UpsertReskillRequestDTO {
  name: string;
  banner: string;
  type: CareerType;
  prices: ReskillPriceRequestDTO[];
}

export interface ReskillDTO {
  id: string;
  name: string;
  banner: string;
  type: CareerType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ReskillWithProductCountDTO {
  id: string;
  name: string;
  banner: string;
  type: CareerType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  productCount: number;
  paidCount: number;
}

export interface ProductReskillPriceDTO {
  paidCount: number;
}

export interface ReskillPriceProductDTO {
  id: string;
  order: number;
}

export interface ReskillPriceWithPromotionDTO {
  id: string;
  name: string;
  periodValue: number;
  periodType: string;
  price: number;
  currency: string;
  order: number;
  isActive: boolean;
  reskillId: string;
  productId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  product?: ProductReskillPriceDTO;
  products?: ReskillPriceProductDTO[];
  upgrades?: ReskillPriceUpgradeDTO[];
  discount?: PromotionDiscountDTO | null;
  discountPrice?: number;
}

export interface ReskillWithRelationsDTO {
  id: string;
  name: string;
  banner: string;
  type: CareerType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  reskillPrices: ReskillPriceWithPromotionDTO[];
}

export interface ReskillPriceProductViewDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
  summary: CourseSummaryDTO;
}

export enum ReskillOrderItemStatus {
  ACTIVATED = "ACTIVATED",
  DEACTIVATED = "DEACTIVATED",
}

export interface ReskillOrderItemResponseDto {
  id: string;
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  voucherCode: string | null;
  unitPrice: number;
  discount: number | null;
  totalPrice: number;
  finalPrice: number;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string | null;
  owerEmail?: string | null;
  user: HostDto;
  productName: string;
  packageStatus: ReskillOrderItemStatus;
}

export enum SurveyFieldOptionType {
  DEFAULT = "DEFAULT",
  OTHER = "OTHER",
}

export interface SurveyOptionDTO {
  id: string;
  label: string;
  type: SurveyFieldOptionType;
}

export interface SurveyFieldDTO {
  id: string;
  type: SurveyFieldType;
  label: string;
  placeholder: string | null;
  options: SurveyOptionDTO[] | null;
  /** @format date-time */
  createdAt: string;
  required: boolean;
}

export interface SurveyWithRelationsDTO {
  id: string;
  title: string;
  banner: string;
  description: string | null;
  /** @format date-time */
  createdAt: string;
  createdById: string;
  status: "ACTIVE" | "INACTIVE" | "PREVIEW";
  fields: SurveyFieldDTO[];
  responseCount: number;
}

export interface SurveyFieldResultDTO {
  id: string;
  type: SurveyFieldType;
  label: string;
  placeholder: string | null;
  options: SurveyOptionDTO[] | null;
  /** @format date-time */
  createdAt: string;
  required: boolean;
  answer:
    | TextareaAnswerDTO
    | RadioAnswerDTO
    | SelectAnswerDTO
    | CheckboxAnswerDTO
    | RatingAnswerDTO;
}

export interface SurveyResultDataDTO {
  id: string;
  title: string;
  banner: string;
  description: string | null;
  fields: SurveyFieldResultDTO[];
}

export interface SurveyResultDTO {
  id: string;
  data: SurveyResultDataDTO;
  /** @format date-time */
  createdAt: string;
}

export interface SurveyAnswerDTO {
  questionId: string;
  answer:
    | TextareaAnswerDTO
    | RadioAnswerDTO
    | SelectAnswerDTO
    | CheckboxAnswerDTO
    | RatingAnswerDTO;
}

export interface SurveySubmitDTO {
  answers: SurveyAnswerDTO[];
  email?: string | null;
  phone?: string | null;
  fullName?: string | null;
  productId?: string | null;
  shouldCreateAccount?: boolean;
}

export interface SurveyDTO {
  id: string;
  title: string;
  banner: string;
  description: string | null;
  /** @format date-time */
  createdAt: string;
  createdById: string;
  status: "ACTIVE" | "INACTIVE" | "PREVIEW";
}

export interface CreateSurveyOptionDTO {
  id?: string;
  label: string;
  type: SurveyFieldOptionType;
}

export interface CreateSurveyFieldDTO {
  id?: string;
  type: SurveyFieldType;
  label: string;
  placeholder?: string;
  required: boolean;
  options?: CreateSurveyOptionDTO[];
}

export interface CreateSurveyDTO {
  title: string;
  description?: string;
  banner: string;
  fields: CreateSurveyFieldDTO[];
}

export interface CreateSurveyOptionPreviewDTO {
  label?: string;
  type?: SurveyFieldOptionType;
}

export interface CreateSurveyFieldPreviewDTO {
  type?: SurveyFieldType;
  label?: string;
  placeholder?: string;
  required?: boolean;
  options?: CreateSurveyOptionPreviewDTO[];
}

export interface CreateSurveyPreviewDTO {
  title?: string;
  description?: string;
  banner?: string;
  fields?: CreateSurveyFieldPreviewDTO[];
}

export interface UpdateSurveyDTO {
  title: string;
  description?: string;
  banner: string;
  fields: CreateSurveyFieldDTO[];
}

export interface SimpleUserDTO {
  id: string;
  username: string;
  fullName: string;
  avatar: string;
  email: string;
  phone: string;
}

export interface SurveySubmissionDTO {
  id: string;
  productName: string | null;
  user: SimpleUserDTO;
  /** @format date-time */
  createdAt: string;
}

export interface CheckboxOptionDTO {
  id: string;
  note?: string;
}

export interface CheckboxAnswerDTO {
  values: CheckboxOptionDTO[];
}

export interface RadioAnswerDTO {
  value: string;
  note?: string;
}

export interface RatingAnswerDTO {
  /**
   * @min 1
   * @max 5
   */
  value: number;
}

export interface SelectAnswerDTO {
  value: string;
}

export interface TextareaAnswerDTO {
  value: string;
}

export interface OrderItemV2Dto {
  id: string;
  orderId: string;
  itemType: ProductType;
  itemId: string;
  productId: string;
  quantity: number;
  voucherId?: string;
  price: number;
  status: OrderItemStatus;
  rawData?: object;
  discountByCampaign?: number;
  discountByVoucher?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  order?: OrderDto;
}

export interface CalendarFrameDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  calendarId: string;
  farePrice: number;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  roomUrl?: string;
  productId?: string;
  discountByCampaign?: number;
  discountByVoucher?: number;
  host: HostDto;
  orderItems: OrderItemV2Dto[];
}

export interface CalendarByUserResponseDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  host: HostDto;
  title: string;
  slug: string;
  banner: string;
  description: string;
  /** @format date-time */
  date: string;
  farePrice: number;
  frames: CalendarFrameDto[];
  censorshipHistories: object[];
  /** @default "DRAFT" */
  status:
    | "PENDING"
    | "PENDING_APPROVAL_WITH_ADMIN"
    | "DRAFT"
    | "ARCHIVED"
    | "PUBLISHED"
    | "REJECTED"
    | "REMOVED";
}

export interface GetUserResponseDto {
  email: boolean;
  username: boolean;
  fullName: boolean;
  phone: boolean;
  coverPhoto: boolean;
  status: boolean;
  avatar: boolean;
}

export interface GetOrderItemV2ResponseDto {
  id: string;
  itemId: string;
  /** @default "CALENDAR_FRAME" */
  itemType:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  productId: string;
  quantity: number;
  price: number;
  /** @default "APPROVED" */
  status: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
  rawData: object;
  reason: string;
  note: string;
  user: GetUserResponseDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
}

export interface GetProductResponseDto {
  availableDays: number | null;
  /** @default "CALENDAR_FRAME" */
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  originalPrice: number | null;
  price: number;
  paidCount: number;
  limitAudiences: number;
  orderItemV2: GetOrderItemV2ResponseDto[];
  /** @format date-time */
  startSellingDate: string | null;
  /** @format date-time */
  endSellingDate: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  /** @format date-time */
  deletedAt: string | null;
}

export interface GetCalendarFrameResponseDto {
  id: string;
  roomUrl: string;
  farePrice: number;
  product: GetProductResponseDto;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  /** @format date-time */
  deletedAt: string | null;
}

export interface GetCalendarByIdResponseDto {
  id: string;
  title: string;
  slug: string;
  banner: string;
  hostId: string;
  description: string;
  farePrice: number;
  /** @default "PUBLISHED" */
  status:
    | "PENDING"
    | "PENDING_APPROVAL_WITH_ADMIN"
    | "DRAFT"
    | "ARCHIVED"
    | "PUBLISHED"
    | "REJECTED"
    | "REMOVED";
  frames: GetCalendarFrameResponseDto[];
  /** @format date-time */
  date: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string | null;
  /** @format date-time */
  deletedAt: string | null;
}

export interface CalendarEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: "EVENT" | "CALENDAR";
  eventId?: string;
  event?: Event;
  quantity: number;
}

export interface CreateDto {
  rejectReason: string[];
  otherRejectReason: string;
  question: string[];
  otherQuestion: string;
  email: string;
  fullName: string;
  type: object;
}

export interface UpdateCalendarFrameDto {
  id?: string;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
}

export interface UpdateCalendarDto {
  title?: string;
  banner?: string;
  description?: string;
  /** @format date-time */
  date?: string;
  farePrice?: number;
  frames?: UpdateCalendarFrameDto[];
}

export interface SearchHistoryEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  query: string;
  extraData?: object;
  userId: string;
  id: string;
}

export interface BookingEventEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: "HOLDING" | "SUCCESS" | "CANCELED";
  eventId?: string;
  event?: Event;
  orderItemId?: string;
  orderId?: string;
}

export interface BookingCalendarEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: "HOLDING" | "PENDING" | "REJECTED" | "APPROVED" | "CANCELED";
  calendarFrameId?: string;
  orderItemId?: string;
  orderId?: string;
}

export interface ChangeStatusDto {
  status: "HOLDING" | "PENDING" | "REJECTED" | "APPROVED" | "CANCELED";
  reason: string;
}

export interface CreatePostDto {
  status:
    | "PUBLISHED"
    | "PENDING_APPROVAL_WITH_ADMIN"
    | "REJECTED"
    | "REMOVED"
    | "DRAFT"
    | "ARCHIVED"
    | "HIDDEN";
  type: "NEWS" | "PROJECT" | "BLOG";
  thumbnail: string;
  title: string;
  tags: string[];
  content: string;
  /** @format date-time */
  publishedAt: string;
}

export interface PostEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  authorId: string;
  thumbnail: string;
  title: string;
  slug: string;
  content: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:22.172Z"
   */
  publishedAt: string;
  status:
    | "PUBLISHED"
    | "PENDING_APPROVAL_WITH_ADMIN"
    | "REJECTED"
    | "REMOVED"
    | "DRAFT"
    | "ARCHIVED"
    | "HIDDEN";
  type: "NEWS" | "PROJECT" | "BLOG";
  id: string;
}

export interface UpdatePostDto {
  status?:
    | "PUBLISHED"
    | "PENDING_APPROVAL_WITH_ADMIN"
    | "REJECTED"
    | "REMOVED"
    | "DRAFT"
    | "ARCHIVED"
    | "HIDDEN";
  type?: "NEWS" | "PROJECT" | "BLOG";
  thumbnail?: string;
  title?: string;
  tags?: string[];
  content?: string;
  /** @format date-time */
  publishedAt?: string;
}

export interface BusinessEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  id: string;
}

export interface UpdateDto {
  rejectReason?: string[];
  otherRejectReason?: string;
  question?: string[];
  otherQuestion?: string;
  email?: string;
  fullName?: string;
  type?: object;
}

export interface HostCategoryEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  name: string;
  slug: string;
  description?: string;
  thumbnail?: string;
  id: string;
}

export interface EmailCollectionEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  otherRejectReason: string;
  rejectReason: string[];
  type?: "REJECTED" | "CONTACT";
  email: string;
  fullName: string;
  id: string;
}

export interface GetGraphDto {
  url: string;
}

export interface OpenGraphEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  image: string;
  type: string;
  url: string;
  title: string;
  description: string;
  siteName: string;
  favicon: string;
  /** @format date-time */
  articlePublishedTime: string;
  articleAuthor: string;
}

export interface FollowDto {
  userId: string;
  hostId: string;
}

export interface AddViolationKeywordDto {
  /** @minLength 1 */
  keyword: string;
  note?: string;
}

export interface UpdateViolationKeywordDto {
  id: string;
  /** @minLength 1 */
  keyword: string;
  note?: string;
}

export interface RejectContentDto {
  reason: string[];
  note?: string;
}

export interface ApplicationSummary {
  /**
   * Number of accesses
   * @example 100
   */
  soLuongTruyCap: number;
  /**
   * Number of sellers
   * @example 50
   */
  soNguoiBan: number;
  /**
   * Number of new sellers
   * @example 10
   */
  soNguoiBanMoi: number;
  /**
   * Total number of products
   * @example 500
   */
  tongSoSanPham: number;
  /**
   * Number of new products
   * @example 30
   */
  soSanPhamMoi: number;
  /**
   * Number of transactions
   * @example 200
   */
  soLuongGiaoDich: number;
  /**
   * Total number of successful orders
   * @example 180
   */
  tongsoDonHangThanhCong: number;
  /**
   * Total number of unsuccessful orders
   * @example 20
   */
  tongSoDonHangKhongThanhCong: number;
  /**
   * Total transaction value
   * @example 1000000
   */
  tongGiaTriGiaoDich: number;
}

export interface CreateCategoryEntity {
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  createdAt: string;
  /**
   * @format date-time
   * @example "2025-12-30T10:35:19.197Z"
   */
  updatedAt?: string | null;
  name: string;
  slug: string;
  description: string;
  thumbnail: string;
  icon: string;
  top: number;
  status: "ACTIVE" | "DISABLED" | "HIDDEN";
  isRoot: boolean;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  id: string;
}

export interface CateRelation {
  ancestorId?: string;
  descendantId?: string;
  ancestor?: CreateCategoryEntity;
  descendant?: CreateCategoryEntity;
}

export interface GetAllCategoryEntity {
  id: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  description: string;
  icon: string;
  thumbnail: string;
  status: "ACTIVE" | "DISABLED" | "HIDDEN";
  isRoot: boolean;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt: string;
  eventCount: number;
  hostCount: number;
  businessCount: number;
  onlineCourseCount: number;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  slug: string;
  top: number;
  /** @format date-time */
  updatedAt: string;
  ancestors?: CateRelation[];
  descendants?: CateRelation[];
  business?: Business[];
  type: string[];
  hosts?: User[];
}

export interface BusinessE {
  name: string;
  slug: string;
  thumbnail: string;
  description: string;
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  deletedAt: string;
  isDeleted: boolean;
  /** @format date-time */
  updatedAt: string;
}

export interface Host {
  id: string;
  email: string;
  username: string;
  fullName: string;
  avatar: string;
  role:
    | "SUPER_ADMIN"
    | "ADMIN"
    | "PRODUCT_OWNER"
    | "ACA_PARTNER"
    | "MARKETING"
    | "SALE"
    | "HOST"
    | "USER";
}

export interface Count {
  /**
   * Number of businesses
   * @example 10
   */
  business: number;
  /**
   * Number of events
   * @example 20
   */
  events: number;
  /**
   * Number of hosts
   * @example 5
   */
  hosts: number;
}

export interface GetCategoryByIdEntity {
  id: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  description: string;
  icon: string;
  thumbnail: string;
  status: "ACTIVE" | "DISABLED" | "HIDDEN";
  isRoot: boolean;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt: string;
  eventCount: number;
  hostCount: number;
  businessCount: number;
  onlineCourseCount: number;
  keywordsKnowledge: string[];
  keywordsSkill: string[];
  slug: string;
  top: number;
  /** @format date-time */
  updatedAt: string;
  business: BusinessE[];
  hosts: Host[];
  onlineCourses: OnlineCourse[];
  type: string[];
  _count: Count;
  descendants: CateRelation[];
}

export interface EventReminderInput {
  /**
   * The reminder time
   * @example 10
   */
  reminderTime: number;
  /**
   * The unique identifier for the event
   * @example "event123"
   */
  eventId: string;
  /**
   * The unique identifier for the reminder
   * @example "reminder123"
   */
  reminderId: string;
  /**
   * A list of user roles that define the scope of this reminder.
   * @example ["HOST","USER"]
   */
  scopes: any[][];
  /**
   * A list of methods that define how the reminder will be sent.
   * @example ["EMAIL","NOTIFICATION"]
   */
  methods: any[][];
  /**
   * The timing of the reminder
   * @example "START_TIME"
   */
  timing: string;
  /**
   * The time when the reminder will be sent
   * @example "BEFORE"
   */
  when: string;
  /**
   * The type of the reminder event
   * @example "EVENT"
   */
  type: string;
}

export interface CalendarReminderInput {
  /**
   * The reminder time
   * @example 10
   */
  reminderTime: number;
  /**
   * The unique identifier for the event
   * @example "event456"
   */
  calendarFrameId: string;
  /**
   * The unique identifier for the reminder
   * @example "reminder456"
   */
  reminderId: string;
  /**
   * A list of user roles that define the scope of this reminder.
   * @example ["HOST","USER"]
   */
  scopes: any[][];
  /**
   * A list of methods that define how the reminder will be sent.
   * @example ["EMAIL","NOTIFICATION"]
   */
  methods: any[][];
  /**
   * The timing of the reminder
   * @example "START_TIME"
   */
  timing: string;
  /**
   * The time when the reminder will be sent
   * @example "BEFORE"
   */
  when: string;
  /**
   * The type of the reminder event
   * @example "CALENDAR"
   */
  type: string;
}

export interface CreateRootCategoryDto {
  name: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  isDeleted?: boolean;
  top?: number;
  status?: "ACTIVE" | "DISABLED" | "HIDDEN";
  keywordsKnowledge?: string[];
  keywordsSkill?: string[];
  type: ("HOST" | "EVENT" | "ONLINE_COURSE")[];
}

export interface CreateSubCategoryDto {
  name: string;
  description?: string;
  thumbnail?: string;
  icon?: string;
  top?: number;
  keywordsKnowledge?: string[];
  keywordsSkill?: string[];
  /** ID of the ancestor category */
  ancestorId: string;
  /** ID of the business the user belongs to */
  businessId: string;
  type: string;
}

export interface UpdateCategoryDto {
  type: ("HOST" | "EVENT" | "ONLINE_COURSE")[];
  name: string;
  thumbnail?: string;
  icon?: string;
  rootCategoryId?: string;
  businessId?: string;
}

export interface PurchasedTicketResponseDto {
  ticketId: string;
  ticketTypeName: string;
  ticketTypeId: string;
  ownerName: string;
  checkedIn: boolean;
  /** @format date-time */
  checkInAt: string | null;
  encryptedData: string;
  orderItemId?: string;
  quantity?: number;
  unitPrice?: number;
  totalPrice?: number;
  finalPrice?: number;
  eventId: string | null;
  ticketType: "EVENT" | "EVENT_SESSION";
  eventSessionId: string | null;
}

export interface EventV2WithTicketsResponse {
  id: string;
  slug: string;
  name: string | null;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  banner: string | null;
  content: string | null;
  hashtags: string[];
  photos: string[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  hostId: string;
  host: User;
  type: EventTypeV2;
  locationType: LocationType;
  addressScope: AddressScope;
  address?: string | null;
  status: EventStatusV2;
  sessionPriceType: SessionPriceType | null;
  ticketScope: TicketScope | null;
  lowestPrice: number | null;
  highestPrice: number | null;
  totalPrice: number | null;
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  duration: number | null;
  durationType: DurationTypeV2 | null;
  isPreview: boolean;
  roomUrl: string | null;
  roomProvider: RoomProvider | null;
  roomMadeBy: RoomMadeBy | null;
  roomInfo: object;
  socialCommunities: EventSocialCommunity[];
  qas: object;
  agendas: object;
  censorshipHistories: object;
  radioOptions: object;
  productId: string;
  product: Product;
  eventSessions: EventSessionDTO[];
  tickets: Ticket[];
  categoriesV2: Category[];
  eventSessionProduct?: EventSessionProduct | null;
  user: UserResponseDto;
  productSurveys?: ProductSurveyDTO[] | null;
  discount?: PromotionDiscountDTO | null;
  purchasedTickets?: PurchasedTicketResponseDto[];
  order: OrderResponseDto;
}

export interface ProductResponseDto {
  id: string;
  type:
    | "CALENDAR"
    | "CALENDAR_FRAME"
    | "COMBO"
    | "ONLINE_COURSE"
    | "E_BOOK"
    | "MEMBERSHIP_PRICE"
    | "RESKILL_PRICE"
    | "TICKET_TIER"
    | "DOCUMENT";
  price: number;
  paidCount: number;
  limitAudiences?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface OrderItemEventResponse {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  type: EventType;
  status: EventStatus;
  name: string;
  slug: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  banner: string;
  content: string;
  hashtags: string[];
  photos: string[];
  docs: string[];
  whyChooses: string[];
  objects: string[];
  videos: string[];
  farePrice: number;
  isFree: boolean;
  limitAudiences: number;
  duration: number;
  durationType: DurationType;
  roomUrl?: string;
  qas: object;
  outlines: object;
  censorshipHistories: object[];
  top?: number;
  /** @format date-time */
  openingSaleDate: string;
  productId?: string;
  product?: ProductResponseDto;
  host: HostDto;
}

export interface CalendarDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  title: string;
  slug: string;
  banner: string;
  description: string;
  /** @format date-time */
  date: string;
  farePrice: number;
  host: HostDto;
  status: CalendarStatus;
}

export interface OrderItemCalendarFrameDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string;
  hostId: string;
  calendarId: string;
  farePrice: number;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  roomUrl?: string;
  productId?: string;
  product?: ProductResponseDto;
  host: HostDto;
  calendar: CalendarDto;
}

export interface OrderItemCalendarFrameDetailResponse {
  id: string;
  orderId: string;
  itemType: ProductType;
  itemId: string;
  productId: string;
  quantity: number;
  voucherId?: string;
  price: number;
  status: OrderItemStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  reason?: string;
  note?: string;
  calendarFrame: OrderItemCalendarFrameDto;
}

export interface ChangeStatusOrderItemRequest {
  status: string;
  reason?: string;
}

export interface OwnerDto {
  fullName: string;
  email: string;
}

export interface AdminEventDTO {
  id: string;
  banner: string;
  locationType: LocationType;
  name: string;
  slug: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  /** @format date-time */
  createdAt: string;
  type: EventTypeV2;
  status: EventStatusV2;
  paidCount: number;
  isHidden: boolean;
  owner: OwnerDto;
}

export interface OwnProductDTO {
  id: string;
  banner: string;
  name: string;
  type: ProductType;
  price: number;
  paidCount: number;
  /** @format date-time */
  createdAt: string;
}

export interface OwnProductWithStatisticsDTO {
  id: string;
  itemId: string;
  banner: string;
  url: string;
  name: string;
  label?: string;
  ignoreStatistics: boolean;
  type: ProductType;
  price: number;
  totalRevenue: number;
  totalPaidCount: number;
  /** @format date-time */
  createdAt: string;
  children: OwnProductWithStatisticsDTO[];
}

export interface HostProductOverviewDTO {
  revenue: number;
  paidCount: number;
}

export interface StatisticByDateDTO {
  date: string;
  revenue: number;
  paidCount: number;
}

export enum AgeGroupLabel {
  Value1322 = "13-22",
  Value2332 = "23-32",
  Value3342 = "33-42",
  Value43 = ">43",
  Unknown = "Unknown",
}

export interface StatisticByAgeDTO {
  age: AgeGroupLabel;
  revenue: number;
  paidCount: number;
}

export enum GenderLabel {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
  UNKNOWN = "UNKNOWN",
}

export interface StatisticByGenderDTO {
  gender: GenderLabel;
  revenue: number;
  paidCount: number;
}

export interface ProductStatisticDTO {
  date: StatisticByDateDTO[];
  age: StatisticByAgeDTO[];
  gender: StatisticByGenderDTO[];
}

export interface EventSessionDto {
  id: string;
  name: string;
  banner: string;
  /** @format date-time */
  createdAt: string;
  order: number;
  productId: string;
  hostFullName: string;
  productType: object;
  productPrice: number;
}

export interface EventV2Dto {
  id: string;
  name: string;
  banner: string;
  type: string;
  sessionPriceType: "ALL" | "EACH";
  eventSessions: EventSessionDto[];
}

export interface OnlineCourseDto {
  id: string;
  name: string;
  coverImage: string;
}

export interface AdminProductDto {
  id: string;
  type: object;
  price: number;
  /** @format date-time */
  createdAt: string;
  ownerId: string;
  owner: OwnerDto;
  eventV2?: EventV2Dto;
  onlineCourse?: OnlineCourseDto;
}

export interface MembershipWithProductCountDTO {
  id: string;
  name: string;
  isMain: boolean;
  description: string | null;
  status: MembershipStatus;
  paidCount: number;
  productCount: number;
}

export interface MembershipPriceRequestDTO {
  id?: string | null;
  name?: string | null;
  periodValue: number;
  amount: number;
  order: number;
  isPublic: boolean;
  isDeleted?: boolean;
}

export interface MembershipPartRequestDTO {
  part: number;
  name: string;
  upcomingPartDays: number;
  upcomingPartUnit: string;
  productIds: string[];
}

export interface UpsertMembershipRequestDTO {
  name: string;
  description: string | null;
  isMain: boolean | null;
  prices: MembershipPriceRequestDTO[];
  parts: MembershipPartRequestDTO[];
}

export interface SwitchStatusMembershipRequestDTO {
  status: "ACTIVE" | "INACTIVE";
}

export interface SubscriptionUserDTO {
  id: string;
  email: string;
  fullName?: string;
  phone: string;
}

export interface SubscriptionMembershipPriceDTO {
  id: string;
  name?: string | null;
  amount: number;
  currency: string;
}

export interface SubscriptionPeriodItem {
  id?: string;
  /** @format date-time */
  paidAt?: string | null;
  membershipPriceName?: string | null;
}

export interface MembershipRegisteredSubscriptionDTO {
  id: string;
  email: string;
  fullName: string;
  phone?: string | null;
  /** @format date-time */
  cancelledAt?: string | null;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  lastPaymentAt?: string;
  isActive: boolean;
  status:
    | "PENDING"
    | "ACTIVE"
    | "FAILED"
    | "CANCEL"
    | "EXPIRED"
    | "PENDING_RENEWAL";
  user: SubscriptionUserDTO;
  membershipPrice: SubscriptionMembershipPriceDTO;
  subscriptionPeriods: SubscriptionPeriodItem[];
}

export interface AcademyPartDTO {
  id: string;
  name: string;
  canAccess: boolean;
  /** Indicates if the user can start this part based on sequential completion (previous part must be 100% complete) */
  canStart: boolean;
  nextUnlockCycleCount: number;
  /** @format date-time */
  createdAt: string;
  /** Progress tracking for this academy part */
  progress: BaseProgressDTO;
}

export interface AcademyLessonDTO {
  id: string;
  banner: string;
  title: string;
  type: LessonType;
  duration: number | null;
}

export interface AcademySectionDTO {
  id: string;
  banner: string;
  name: string;
  totalDuration: number;
  lessons: AcademyLessonDTO[];
}

export interface AcademyProductDTO {
  id: string;
  name: string;
  status: string;
  slug: string | null;
  banner: string;
  itemId: string;
  type: ProductType;
  price: number;
  paidCount: number;
  owner: HostDto;
  purchasable: boolean;
  limitAudiences: number | null;
  label?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isExpired?: boolean;
  createdAt: string;
  children?: ProductViewDTO[];
  kind: ProductKind;
  /** @format date-time */
  releaseDate?: string | null;
  more?: ProductViewExtraDTO | null;
  sections: AcademySectionDTO[];
  lessonCount: number;
  totalDuration: number;
}

export interface AcademyPartWithRelationsDTO {
  id: string;
  name: string;
  canAccess: boolean;
  /** Indicates if the user can start this part based on sequential completion (previous part must be 100% complete) */
  canStart: boolean;
  nextUnlockCycleCount: number;
  /** @format date-time */
  createdAt: string;
  /** Progress tracking for this academy part */
  progress: BaseProgressDTO;
  products: AcademyProductDTO[];
}

export interface AdminEmailDto {
  id: string;
  messageId: string;
  email: string;
  status: string;
  subject: string;
  reason?: string;
  /** @format date-time */
  createdAt: string;
}

export interface TrackingAffiliateInput {
  productId: string;
  userName: string;
}

export interface AdminUpsertCourseDto {
  id: string;
  productId: string;
  name: string;
  description: string;
  coverImage: string;
  wallpaper: string;
  /** @default true */
  videoCompletionRequired: boolean;
  /** @format date-time */
  startAt: string;
  /** @default "UNPUBLISHED" */
  status:
    | "DRAFT"
    | "UNPUBLISHED"
    | "REVIEWED"
    | "PUBLISHED"
    | "REJECTED"
    | "DELETED"
    | "PENDING_APPROVAL_WITH_ADMIN";
  benefit: string;
  archived: string;
  questionAndAnswers: string;
  tags: string;
  price: number;
  pricingPlan: "free" | "paid";
  availableDays: number;
  /** @default false */
  isAcademy: boolean;
  socialCommunities: UpsertCourseSocialCommunityDto[];
  resourceIds: string[];
  productSurveys?: CreateProductSurveyDTO[];
  ownerId: string;
  isReskill: boolean;
  isLaunchpad: boolean;
  isOnair: boolean;
}

export interface CreateUpcomingOnlineCourseDto {
  name: string;
  description?: string;
  coverImage?: string;
  pricingPlan?: PricingPlan;
  price?: number;
  releaseDate?: string | null;
  careerType: CareerType;
  ownerId: string;
}

export interface OnlineCourseOwnerDTO {
  id: string;
  fullName: string;
  email: string;
  username: string;
  avatar: string;
}

export interface OnlineCourseSummarySessionDTO {
  sectionCount: number;
  lessonCount: number;
  totalDuration: number;
}

export interface OnlineCourseTagDTO {
  label: string;
  value: string;
}

export interface OnlineCourseCategoryDTO {
  id: string;
  name: string;
  slug: string;
}

export interface OnlineCourseV2SimplifiedDTO {
  id: string;
  name?: string | null;
  description?: string | null;
  coverImage?: string | null;
  status: OnlineCourseStatus;
  /** @default true */
  displayed: boolean;
  /** @format date-time */
  startAt?: string | null;
  ownerId: string;
  productId?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  product?: ProductDTO;
  owner?: OnlineCourseOwnerDTO;
  summary: OnlineCourseSummarySessionDTO;
  tags: OnlineCourseTagDTO[];
  categoriesV2: OnlineCourseCategoryDTO[];
}

export interface OnlineCourseV2DTO {
  id: string;
  name?: string | null;
  description?: string | null;
  coverImage?: string | null;
  wallpaper?: string | null;
  /** @default false */
  videoCompletionRequired: boolean;
  status: OnlineCourseStatus;
  statusReason?: string | null;
  /** @default true */
  displayed: boolean;
  /** @format date-time */
  startAt?: string | null;
  benefit?: string | null;
  archived?: string | null;
  questionAndAnswers?: string | null;
  tags?: string | null;
  ownerId: string;
  productId?: string | null;
  product?: ProductDTO;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string | null;
  censorshipHistories: object[];
  sections?: SectionDTO[];
  onlineCourseResources?: OnlineCourseResourceDto[];
}

export interface OwnerDetailedDTO {
  id: string;
  fullName: string;
  email: string;
  username?: string | null;
  role?: string;
}

export interface SocialCommunityDetailedDTO {
  id: string;
  name: string;
  type: string;
  url: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ProductSurveyDetailedDTO {
  id: string;
  surveyId: string;
  required: boolean;
  survey?: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ProductDetailedDTO {
  id: string;
  slug: string;
  type: string;
  price: number;
  pricingPlan?: string | null;
  availableDays?: number | null;
  isAcademy: boolean;
  isReskill: boolean;
  isLaunchpad: boolean;
  isOnair: boolean;
  isLnD: boolean;
  socialCommunities: SocialCommunityDetailedDTO[];
  productSurveys: ProductSurveyDetailedDTO[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
}

export interface ResourceDetailedDTO {
  id: string;
  name: string;
  fileName: string;
  fileType?: string | null;
  duration?: number | null;
  capacity: string;
  resourceType: string;
  linkUrl?: string | null;
  publicUrl?: string | null;
  thumbnailUrl?: string | null;
  content?: string | null;
  isMain: boolean;
}

export interface LessonDetailedDTO {
  id: string;
  title: string;
  content: string;
  description?: string | null;
  type: LessonType;
  thumbnail?: string | null;
  index: number;
  canPreview: boolean;
  mainResource?: ResourceDetailedDTO | null;
  resources: ResourceDetailedDTO[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string | null;
}

export interface SectionDetailedDTO {
  id: string;
  title: string;
  status: SectionStatus;
  thumbnail?: object | null;
  index: number;
  lessons: LessonDetailedDTO[];
  sectionResources: ResourceDetailedDTO[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string | null;
}

export interface OnlineCourseV2DetailedDTO {
  id: string;
  name?: string | null;
  description?: string | null;
  coverImage?: string | null;
  wallpaper?: string | null;
  videoCompletionRequired: boolean;
  status: OnlineCourseStatus;
  statusReason?: string | null;
  displayed: boolean;
  /** @format date-time */
  startAt?: string | null;
  benefit?: string | null;
  archived?: string | null;
  questionAndAnswers?: string | null;
  tags?: string | null;
  ownerId: string;
  owner: OwnerDetailedDTO;
  productId?: string | null;
  product?: ProductDetailedDTO | null;
  sections: SectionDetailedDTO[];
  onlineCourseResources: ResourceDetailedDTO[];
  isPublished: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt?: string | null;
  censorshipHistories: object[];
  currentVersion: number;
}

export interface CreateLessonV2DTO {
  id?: string;
  title: string;
  content?: string;
  description?: string;
  thumbnail?: string;
  index: number;
  type: LessonType;
  resources?: string[];
  mainResource?: string;
  /** @default false */
  canPreview: boolean;
}

export interface CreateSectionV2DTO {
  id?: string;
  title: string;
  thumbnail?: object;
  lessons?: CreateLessonV2DTO[];
  index: number;
  resourceIds?: string[];
}

export interface SocialCommunityV2DTO {
  name: string;
  type: string;
  url: string;
}

export interface ProductSurveyV2DTO {
  surveyId: string;
  /** @default false */
  required?: boolean;
}

export interface ProductDataV2DTO {
  /** @default false */
  isAcademy: boolean;
  /** @default false */
  isReskill: boolean;
  /** @default false */
  isLaunchpad: boolean;
  /** @default true */
  isOnair: boolean;
  /** @default false */
  isLnD: boolean;
  ownerId: string;
  socialCommunities?: SocialCommunityV2DTO[];
  productSurveys?: ProductSurveyV2DTO[];
  pricingPlan?: string;
  price?: number;
  availableDays?: number;
}

export interface CreateOnlineCourseV2DTO {
  id?: string;
  name: string;
  description?: string;
  coverImage?: string;
  wallpaper?: string;
  /** @default false */
  videoCompletionRequired?: boolean;
  status?: OnlineCourseStatus;
  statusReason?: string;
  /** @default true */
  displayed?: boolean;
  /** @format date-time */
  startAt?: string;
  benefit?: string;
  archived?: string;
  questionAndAnswers?: string;
  tags?: string[];
  ownerId: string;
  sections?: CreateSectionV2DTO[];
  product?: ProductDataV2DTO;
  resourceIds?: string[];
}

export interface UpdateOnlineCourseV2DTO {
  name?: string;
  description?: string;
  coverImage?: string;
  wallpaper?: string;
  videoCompletionRequired?: boolean;
  status?: OnlineCourseStatus;
  statusReason?: string;
  displayed?: boolean;
  /** @format date-time */
  startAt?: string;
  benefit?: string;
  archived?: string;
  questionAndAnswers?: string;
  tags?: string[];
  ownerId?: string;
  sections?: CreateSectionV2DTO[];
  product?: ProductDataV2DTO;
  resourceIds?: string[];
}

export interface DraftLessonV2DTO {
  id?: string;
  title?: string;
  content?: string;
  description?: string;
  thumbnail?: string;
  index?: number;
  type?: LessonType;
  resources?: string[];
  mainResource?: string;
  /** @default false */
  canPreview?: boolean;
  resourceIds?: string[];
}

export interface DraftSectionV2DTO {
  id?: string;
  title?: string;
  thumbnail?: object;
  lessons?: DraftLessonV2DTO[];
  index?: number;
  resourceIds?: string[];
}

export interface SaveDraftOnlineCourseDTO {
  id?: string;
  name?: string;
  description?: string;
  coverImage?: string;
  wallpaper?: string;
  videoCompletionRequired?: boolean;
  status?: OnlineCourseStatus;
  statusReason?: string;
  displayed?: boolean;
  /** @format date-time */
  startAt?: string;
  benefit?: string;
  archived?: string;
  questionAndAnswers?: string;
  tags?: string;
  ownerId?: string;
  sections?: DraftSectionV2DTO[];
  product?: ProductDataV2DTO;
  resourceIds?: string[];
}

export interface AttachmentDto {
  /** @example "layoff_notice.pdf" */
  fileName: string;
  /** @example "https://example.com/layoff_notice.pdf" */
  url: string;
}

export interface LayoffDiscountRequestDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  layoffReason: string;
  /** @format date-time */
  layoffDate: string;
  note?: string;
  attachments: AttachmentDto[];
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  /** @format date-time */
  processedAt?: string;
  adminNote?: string;
  userId: string;
  reskillPriceId?: string;
}

export interface UpdateLayoffDiscountRequestDto {
  /**
   * The new status for the request
   * @example "APPROVED"
   */
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  /** Admin note or reason for the status change */
  adminNote?: string;
}

export interface LayoffDiscountTimelineItemDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  processedAt?: string;
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  adminNote?: string;
}

export interface LayoffDiscountRequestWithTimelineDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  layoffReason: string;
  /** @format date-time */
  layoffDate: string;
  note?: string;
  attachments: AttachmentDto[];
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  /** @format date-time */
  processedAt?: string;
  adminNote?: string;
  userId: string;
  reskillPriceId?: string;
  /** Timeline of all layoff discount requests for this user */
  timeline: LayoffDiscountTimelineItemDto[];
  user: {
    id: string;
    fullName: string | null;
    email: string;
    avatar: string | null;
    job: string | null;
  };
  reskillPrice: {
    id: string;
    name: string;
  };
}

export interface CreateLayoffDiscountRequestDto {
  /**
   * Name of the person requesting the layoff discount
   * @example "John Doe"
   */
  name: string;
  /**
   * Phone number of the person requesting the layoff discount
   * @example "+1234567890"
   */
  phoneNumber: string;
  /**
   * Company name of the person requesting the layoff discount
   * @example "Tech Corp"
   */
  companyName: string;
  /**
   * Reason for the layoff discount request
   * @example "Company downsizing"
   */
  layoffReason: string;
  /**
   * Date of the layoff
   * @example "2025-12-30T10:35:22.410Z"
   */
  layoffDate: string;
  /**
   * ID of the reskill price associated with the layoff discount request
   * @example "reskill-price-id-123"
   */
  reskillPriceId?: string;
  /**
   * Additional notes or comments regarding the layoff discount request
   * @example "Looking forward to your response."
   */
  note?: string;
  /** Attachments related to the layoff discount request (at least one required) */
  attachments: AttachmentDto[];
}

export interface CreateLayoffDiscountRequestResponseDto {
  success: boolean;
  message: string;
  form_status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  /** @format date-time */
  submitted_at: string;
}

export interface GetLatestLayoffRequestResponseDto {
  /**
   * ID of the latest layoff discount request
   * @example "layoff-request-id-123"
   */
  id: string;
  /**
   * Name of the user who submitted the layoff discount request
   * @example "John Doe"
   */
  name: string;
  /**
   * Email of the user who submitted the layoff discount request
   * @example "johndoe@gmail.com"
   */
  email: string;
  /**
   * Phone number of the user who submitted the layoff discount request
   * @example "+1234567890"
   */
  phoneNumber: string;
  /**
   * Company name of the user who submitted the layoff discount request
   * @example "Tech Corp"
   */
  companyName: string;
  /**
   * Reason for the layoff discount request
   * @example "Company downsizing"
   */
  layoffReason: string;
  /**
   * Date of the layoff
   * @format date-time
   * @example "2025-12-30T10:35:22.426Z"
   */
  layoffDate: string;
  /**
   * Status of the layoff discount request
   * @example "PENDING"
   */
  status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
  /**
   * Date when the layoff discount request was created
   * @format date-time
   * @example "2025-12-30T10:35:22.426Z"
   */
  createdAt: string;
  /**
   * Date when the layoff discount request was last updated
   * @format date-time
   * @example "2025-12-30T10:35:22.426Z"
   */
  updatedAt: string;
  /**
   * ID of the reskill price associated with the layoff discount request
   * @example "reskill-price-id-123"
   */
  reskillPriceId?: string;
  /**
   * Additional notes or comments regarding the layoff discount request
   * @example "Looking forward to your response."
   */
  note?: string;
  /**
   * Attachments related to the layoff discount request
   * @example [{"fileName":"layoff_notice.pdf","url":"https://example.com/layoff_notice.pdf"}]
   */
  attachments: AttachmentDto[];
  /**
   * Admin note for the layoff discount request
   * @example "Reviewed and approved."
   */
  adminNote?: string;
  /**
   * Date when the layoff discount request was processed
   * @format date-time
   * @example "2025-12-30T10:35:22.426Z"
   */
  processedAt?: string;
  /**
   * Indicates whether the layoff discount request has been used
   * @example false
   */
  isUsed: boolean;
}

export interface AdminCreateLibraryDto {
  /** Tên */
  name: string;
  /** owner */
  ownerId: string;
}

export interface RevenueItemDto {
  id: string;
  orderId: string;
  itemType: string;
  locationType?: object | null;
  name: string;
  quantity: number;
  status: string;
  host?: User | null;
  user?: User | null;
  originalPrice: number;
  discount?: Discount | null;
  voucher?: Voucher | null;
  price: number;
  dueAmount: number;
  adminPrice: number;
  isAdminCreated: boolean;
  affiliateSource: string;
  createdBy: string;
  /** @format date-time */
  createdAt: string;
}

/** Action verb of the policy */
export enum AuthActionVerb {
  Create = "create",
  Update = "update",
  Delete = "delete",
  Read = "read",
}

export interface PermissionDto {
  /**
   * Unique identifier for the policy
   * @example "12345"
   */
  id: string;
  /** @example "ADMIN" */
  role: UserRole;
  /**
   * Resource of the policy
   * @example "/endpoint"
   */
  resource: string;
  /**
   * Action verb of the policy
   * @example "read"
   */
  action: AuthActionVerb;
}

export interface CreatePermissionDto {
  /** @example "ADMIN" */
  role: UserRole;
  /**
   * Resource of the policy
   * @example "/endpoint"
   */
  resource: string;
  /**
   * Action verb of the policy
   * @example "read"
   */
  action: AuthActionVerb;
}

export interface MentorRequestResponseDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  consultationContent: string;
  status: "NEW" | "PROCESSING" | "COMPLETED";
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assigneeName?: string;
  adminNote?: string;
  statusHistory: object[];
}

export interface CreateMentorRequestDto {
  /** Representative name */
  representativeName: string;
  /** Email address */
  email: string;
  /** Phone number */
  phoneNumber: string;
  /** Consultation content */
  consultationContent: string;
}

export interface UpdateMentorRequestDto {
  /** Representative name */
  representativeName?: string;
  /** Email address */
  email?: string;
  /** Phone number */
  phoneNumber?: string;
  /** Consultation content */
  consultationContent?: string;
  /** Request status */
  status?: "NEW" | "PROCESSING" | "COMPLETED";
  /** Assignee user ID */
  assigneeId?: string;
  /** Admin note */
  adminNote?: string;
}

export interface UpdateStatusDto {
  /** New status for the request */
  status: string;
  /** Assignee user ID */
  assigneeId?: string;
  /** Admin note for the status change */
  note?: string;
}

export interface InhouseTrainingRequestResponseDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  trainingTopic: string;
  attachments?: object[];
  status: "NEW" | "PROCESSING" | "COMPLETED";
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assigneeName?: string;
  adminNote?: string;
  statusHistory: object[];
}

export interface CreateInhouseTrainingRequestDto {
  /** Representative name */
  representativeName: string;
  /** Email address */
  email: string;
  /** Phone number */
  phoneNumber: string;
  /** Training topic */
  trainingTopic: string;
  /** Attached files */
  attachments?: object[];
}

export interface UpdateInhouseTrainingRequestDto {
  /** Representative name */
  representativeName?: string;
  /** Email address */
  email?: string;
  /** Phone number */
  phoneNumber?: string;
  /** Training topic */
  trainingTopic?: string;
  /** Attached files */
  attachments?: object[];
  /** Request status */
  status?: "NEW" | "PROCESSING" | "COMPLETED";
  /** Assignee user ID */
  assigneeId?: string;
  /** Admin note */
  adminNote?: string;
}

export interface ProgramConsultationRequestResponseDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  representativeName: string;
  email: string;
  phoneNumber: string;
  consultationTopic: string;
  attachments?: object[];
  status: "NEW" | "PROCESSING" | "COMPLETED";
  /** @format date-time */
  processedAt?: string;
  assigneeId?: string;
  assigneeName?: string;
  adminNote?: string;
  statusHistory: object[];
}

export interface CreateProgramConsultationRequestDto {
  /** Representative name */
  representativeName: string;
  /** Email address */
  email: string;
  /** Phone number */
  phoneNumber: string;
  /** Consultation topic */
  consultationTopic: string;
  /** Attached files */
  attachments?: object[];
}

export interface UpdateProgramConsultationRequestDto {
  /** Representative name */
  representativeName?: string;
  /** Email address */
  email?: string;
  /** Phone number */
  phoneNumber?: string;
  /** Consultation topic */
  consultationTopic?: string;
  /** Attached files */
  attachments?: object[];
  /** Request status */
  status?: "NEW" | "PROCESSING" | "COMPLETED";
  /** Assignee user ID */
  assigneeId?: string;
  /** Admin note */
  adminNote?: string;
}

export interface SubscriptionEmailDto {
  /**
   * Email address to subscribe
   * @example "johndoe@gmail.com"
   */
  email: string;
  type?: SubscriptionEmailType;
}

export interface EDocSubscriptionEmailDto {
  /**
   * Email address to subscribe
   * @example "johndoe@gmail.com"
   */
  email: string;
  /**
   * ID for Edoc
   * @example "edoc123"
   */
  edocId: string;
  /**
   * Full name of subscriber
   * @example "John Doe"
   */
  fullName?: string;
  /**
   * Phone number of subscriber
   * @example "0123456789"
   */
  phone?: string;
  /**
   * Company name of subscriber
   * @example "Tech Company"
   */
  company?: string;
  /**
   * Job name of subscriber
   * @example "Job"
   */
  job?: string;
  /**
   * Learning difficulty of subscriber
   * @example "learningDifficulty"
   */
  learningDifficulty?: string;
  /**
   * Whether to subscribe to marketing emails
   * @example true
   */
  isSubscribeEmailMKT?: boolean;
}

export interface GetEdocsDto {
  /**
   * Unique identifier of the subscription email
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  id: string;
  /**
   * Title of the document
   * @example "Annual Report 2023"
   */
  title: string;
  /**
   * URL of the banner image
   * @example "https://example.com/banner.jpg"
   */
  bannerUrl: string;
  /**
   * Description of the document
   * @example "Detailed financial and operational overview for the fiscal year 2023"
   */
  description: string;
  /**
   * List of hashtags associated with the document
   * @example ["report","finance","annual"]
   */
  hashtags: string[];
  /**
   * Number of times the document has been downloaded
   * @example 42
   */
  downloadCount: number;
  /**
   * Date when the document was published
   * @format date-time
   * @example "2023-12-31T23:59:59Z"
   */
  publishedAt: string;
  /**
   * Size of the document in human readable format
   * @example "2.5 MB"
   */
  size: string;
}

export interface CreateEdocDto {
  /** @maxLength 255 */
  title: string;
  /** @maxLength 500 */
  description: string;
  bannerUrl?: string;
  hashtags?: string[];
  /** ID of the attached resource in Library */
  resourceId: string;
  isHidden?: boolean;
  /** Edoc publish status */
  publish?: boolean;
}

export interface UpdateEdocDto {
  /** @maxLength 255 */
  title?: string;
  /** @maxLength 500 */
  description?: string;
  bannerUrl?: string;
  hashtags?: string[];
  /** Replace attached resource */
  resourceId?: string;
  isHidden?: boolean;
  /** Edoc publish status */
  publish?: boolean;
}

export interface GetSubscriptionEmailsDto {
  /**
   * Unique identifier of the subscription email
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  id: string;
  /**
   * Email address
   * @example "user@example.com"
   */
  email: string;
  /**
   * Creation date of the subscription email
   * @format date-time
   * @example "2023-10-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Phone number
   * @example "+1234567890"
   */
  phone?: string | null;
  /**
   * Full name of the subscriber
   * @example "John Doe"
   */
  fullName?: string | null;
  /**
   * Job name of the subscriber
   * @example "Dev"
   */
  job?: string | null;
  /**
   * Learning Difficulty of the subscriber
   * @example "John Doe"
   */
  learningDifficulty?: string | null;
  /**
   * Company name
   * @example "Acme Inc."
   */
  companyName?: string | null;
  /**
   * Electronic document ID
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  edocId?: string | null;
  /**
   * Electronic document title
   * @example "Contract Agreement"
   */
  edocTitle?: string | null;
  status: SubscriptionEmailStatus;
  /**
   * ID of the assignee
   * @example "usr_12345"
   */
  assigneeId?: string | null;
  /**
   * Full name of the assignee
   * @example "Jane Smith"
   */
  assigneeFullName?: string | null;
  /**
   * Processing date
   * @format date-time
   */
  processAt?: string | null;
}

export interface SendEdocDto {
  /** @example ["uuid1","uuid2"] */
  subscriptionEmailIds: string[];
}

export interface UpdateSubscriptionEmailStatusDto {
  /**
   * The status of the subscription email
   * @example "COMPLETED"
   */
  status: "NEW" | "IN_PROGRESS" | "SENDING" | "COMPLETED" | "FAILED";
}

export interface BizAttachmentDto {
  /** @example "fileName.pdf" */
  fileName: string;
  /** @example "https://example.com/fileName.pdf" */
  url: string;
}

export interface GetBizChallengesDto {
  /** id of the business challenge */
  id: string;
  /** company name of the business challenge */
  companyName: string;
  /** representative of the business challenge */
  representative: string;
  /** phone number of the business challenge */
  phoneNumber: string;
  /** email of the business challenge */
  email: string;
  /** specialization of the business challenge */
  specialization: string;
  /** attachments of the business challenge */
  attachments: BizAttachmentDto[];
  /** The assignee responsible for this business challenge */
  assignee: {
    /** @example "user-123" */
    id?: string;
    /** @example "user@gm.com" */
    email?: string;
    /** @example "John Doe" */
    fullName?: string | null;
    /** @example "https://example.com/avatar.jpg" */
    avatar?: string | null;
  };
  /** note */
  note?: string;
  status: BusinessChallengeStatus;
  /** description of the business challenge */
  description?: string | null;
  /**
   * created at timestamp
   * @format date-time
   */
  createdAt: string;
}

/** The type of activity logged */
export enum BizActivityLogType {
  STATUS_CHANGE = "STATUS_CHANGE",
  UPDATE_NOTE = "UPDATE_NOTE",
}

export interface BizActivityLog {
  /** The type of activity logged */
  type: BizActivityLogType;
  /**
   * The time when the activity occurred
   * @format date-time
   */
  timestamp: string;
  /** The status value after the change */
  status: string | null;
  /** Optional additional information about this activity */
  note: string | null;
  /** Optional identifier of the person or system that handled this activity */
  handler: {
    id?: string;
    fullName?: string | null;
    email?: string;
    role?:
      | "SUPER_ADMIN"
      | "ADMIN"
      | "PRODUCT_OWNER"
      | "ACA_PARTNER"
      | "MARKETING"
      | "SALE"
      | "HOST"
      | "USER";
  };
}

export interface GetBizChallengeDetailsDto {
  /** id of the business challenge */
  id: string;
  /** company name of the business challenge */
  companyName: string;
  /** representative of the business challenge */
  representative: string;
  /** phone number of the business challenge */
  phoneNumber: string;
  /** email of the business challenge */
  email: string;
  /** specialization of the business challenge */
  specialization: string;
  /** attachments of the business challenge */
  attachments: BizAttachmentDto[];
  /** The assignee responsible for this business challenge */
  assignee: {
    /** @example "user-123" */
    id?: string;
    /** @example "user@gm.com" */
    email?: string;
    /** @example "John Doe" */
    fullName?: string | null;
    /** @example "https://example.com/avatar.jpg" */
    avatar?: string | null;
  };
  /** note */
  note?: string;
  status: BusinessChallengeStatus;
  /** description of the business challenge */
  description?: string | null;
  /**
   * created at timestamp
   * @format date-time
   */
  createdAt: string;
  /** Activity logs for update operations */
  updateNoteLogs: BizActivityLog[];
  /** Activity logs for status changes */
  statusChangeLogs: BizActivityLog[];
}

export interface UpdateBizChallengeDto {
  status?: BusinessChallengeStatus;
  /** note description of the business challenge */
  note?: string | null;
  /** description of the business challenge */
  description?: string | null;
  /** id of the assignee user */
  assigneeId?: string | null;
  /** list of attachment objects */
  attachments?: BizAttachmentDto[] | null;
}

export interface GetExpertRequestsDto {
  /** id of the expert request */
  id: string;
  /** name of the expert request */
  name: string;
  /** email of the expert request */
  email: string;
  /** phone number of the expert request */
  phoneNumber: string;
  /** specialization of the expert request */
  specialization: string;
  /** profile links of the expert request */
  profileLinks: string[];
  /** attachments of the expert request */
  attachments: BizAttachmentDto[];
  /** The assignee responsible for this expert request */
  assignee: {
    /** @example "user-123" */
    id?: string;
    /** @example "user@gm.com" */
    email?: string;
    /** @example "John Doe" */
    fullName?: string | null;
    /** @example "https://example.com/avatar.jpg" */
    avatar?: string | null;
  };
  /** note */
  note?: string;
  status: ExpertRequestStatus;
  /** description of the expert request */
  description?: string | null;
  /**
   * process at timestamp
   * @format date-time
   */
  processedAt: string | null;
  /**
   * created at timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface GetExpertRequestDetailDto {
  /** id of the expert request */
  id: string;
  /** name of the expert request */
  name: string;
  /** email of the expert request */
  email: string;
  /** phone number of the expert request */
  phoneNumber: string;
  /** specialization of the expert request */
  specialization: string;
  /** profile links of the expert request */
  profileLinks: string[];
  /** attachments of the expert request */
  attachments: BizAttachmentDto[];
  /** The assignee responsible for this expert request */
  assignee: {
    /** @example "user-123" */
    id?: string;
    /** @example "user@gm.com" */
    email?: string;
    /** @example "John Doe" */
    fullName?: string | null;
    /** @example "https://example.com/avatar.jpg" */
    avatar?: string | null;
  };
  /** note */
  note?: string;
  status: ExpertRequestStatus;
  /** description of the expert request */
  description?: string | null;
  /**
   * process at timestamp
   * @format date-time
   */
  processedAt: string | null;
  /**
   * created at timestamp
   * @format date-time
   */
  createdAt: string;
  /** Activity logs for update operations */
  updateNoteLogs: BizActivityLog[];
  /** Activity logs for status changes */
  statusChangeLogs: BizActivityLog[];
}

export interface UpdateExpertRequestStatusDto {
  /** note description of the expert request */
  note?: string | null;
}

export interface UpdateExpertRequestDto {
  /** note description of the expert request */
  note?: string | null;
  /** description of the expert request */
  description?: string | null;
  /** id of the assignee user */
  assigneeId?: string | null;
  /** list of profile links */
  profileLinks?: string[] | null;
  /** list of attachment objects */
  attachments?: BizAttachmentDto[] | null;
}

export interface CreateExpertRequestInput {
  /** @example "Nguyễn Văn A" */
  name: string;
  /** @example "user@example.com" */
  email: string;
  /** @example "0912345678" */
  phoneNumber: string;
  /** @example "AI/ML, Growth, Finance" */
  specialization?: string;
  /** @example "Mô tả ngắn về kinh nghiệm/nhu cầu..." */
  description: string;
  /** @example ["https://linkedin.com/in/foo","https://github.com/bar"] */
  profileLinks?: string[];
  /** list of attachment objects */
  attachments?: BizAttachmentDto[] | null;
}

export interface CreateBusinessChallengeInput {
  /** @example "Onair" */
  companyName: string;
  /** @example "onair@example.com" */
  email: string;
  /** @example "0912345678" */
  phoneNumber: string;
  /** @example "Nguyen Van A" */
  representative: string;
  /** @example "AI/ML, Growth, Finance" */
  specialization: string;
  /** @example "Mô tả ngắn về kinh nghiệm/nhu cầu..." */
  description: string;
  /** list of attachment objects */
  attachments?: BizAttachmentDto[] | null;
}

export interface CreateEnterprisePlanDto {
  /**
   * Tên gói
   * @maxLength 200
   * @example "Gói Standard"
   */
  name: string;
  /**
   * Mô tả gói
   * @example "Gói dành cho doanh nghiệp nhỏ"
   */
  description?: string;
  /**
   * Loại chu kỳ (DAY, WEEK, MONTH, YEAR)
   * @example "MONTH"
   */
  periodType: "DAY" | "WEEK" | "MONTH" | "YEAR";
  /**
   * Giá trị chu kỳ
   * @min 1
   * @example 12
   */
  periodValue: number;
  /**
   * Số lượng nhân viên tối đa
   * @min 1
   * @example 100
   */
  employeeLimit?: number;
  /**
   * Giá tiền
   * @min 0
   * @example 5000000
   */
  price: number;
  /**
   * Trạng thái hoạt động
   * @default true
   */
  isActive?: boolean;
}

export interface GetEnterprisePlanDto {
  /** ID của gói */
  id: string;
  /** Tên gói */
  name: string;
  /** Mô tả gói */
  description?: string;
  /** Loại chu kỳ */
  periodType: string;
  /** Giá trị chu kỳ */
  periodValue: number;
  /** Số lượng nhân viên tối đa */
  employeeLimit?: number;
  /** Giá tiền */
  price: number;
  /** Đơn vị tiền tệ */
  currency: string;
  /** Trạng thái hoạt động */
  isActive: boolean;
  /**
   * Ngày tạo
   * @format date-time
   */
  createdAt: string;
  /**
   * Ngày cập nhật
   * @format date-time
   */
  updatedAt: string;
  /** Số lượng doanh nghiệp đang sử dụng gói */
  enterpriseCount?: number;
}

export interface UpdateEnterprisePlanDto {
  /**
   * Tên gói
   * @maxLength 200
   * @example "Gói Premium"
   */
  name?: string;
  /**
   * Mô tả gói
   * @example "Gói dành cho doanh nghiệp lớn"
   */
  description?: string;
  /**
   * Loại chu kỳ (DAY, WEEK, MONTH, YEAR)
   * @example "MONTH"
   */
  periodType?: "DAY" | "WEEK" | "MONTH" | "YEAR";
  /**
   * Giá trị chu kỳ
   * @min 1
   * @example 6
   */
  periodValue?: number;
  /**
   * Số lượng nhân viên tối đa
   * @min 1
   * @example 200
   */
  employeeLimit?: number;
  /**
   * Giá tiền
   * @min 0
   * @example 10000000
   */
  price?: number;
  /**
   * Trạng thái hoạt động
   * @example true
   */
  isActive?: boolean;
}

export interface EnterprisePaymentWarningDto {
  /**
   * Ngày bắt đầu kỳ thanh toán gần nhất bị cảnh báo
   * @format date-time
   */
  periodStart: string | null;
  /**
   * Ngày kết thúc kỳ thanh toán gần nhất bị cảnh báo
   * @format date-time
   */
  periodEnd: string | null;
  /**
   * Ngày đến hạn của kỳ thanh toán gần nhất bị cảnh báo
   * @format date-time
   */
  dueDate: string | null;
  /** Trạng thái thanh toán của kỳ gần nhất bị cảnh báo */
  paymentStatus: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID" | null;
}

export interface EnterprisePaymentListItemDto {
  id: string;
  enterpriseId: string;
  /** Trạng thái chu kỳ */
  cycleStatus: "CURRENT" | "NEXT" | "EXPIRED";
  /** Tên doanh nghiệp */
  companyName: string;
  /** Tên gói đang áp dụng */
  planName: string;
  /**
   * Chu kỳ hiện tại hiển thị dạng văn bản
   * @example "1 Tháng"
   */
  cycleLabel: string;
  /**
   * Giá gói hiện tại
   * @example 10000000
   */
  planPrice: number;
  /**
   * Ngày bắt đầu chu kỳ
   * @format date-time
   */
  periodStart: string;
  /**
   * Ngày kết thúc chu kỳ
   * @format date-time
   */
  periodEnd: string;
  /**
   * Ngày đến hạn thanh toán
   * @format date-time
   */
  dueDate: string;
  /**
   * Ngày thực tế thanh toán
   * @format date-time
   */
  paymentDate: string | null;
  /**
   * Ngày cập nhật gần nhất
   * @format date-time
   */
  updatedAt: string;
  /**
   * Số tiền đã thanh toán
   * @example 0
   */
  paidAmount: number;
  /** Trạng thái thanh toán */
  paymentStatus: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID";
  /** Phương thức thanh toán */
  paymentMethod: "BANK_TRANSFER" | "CASH";
  /**
   * Có cảnh báo hay không
   * @example false
   */
  hasWarning: boolean;
  /** Thông tin kỳ bị cảnh báo gần nhất */
  warning: EnterprisePaymentWarningDto | null;
}

export interface EnterprisePaymentPlanDto {
  /** ID gốc của gói đăng ký tại thời điểm snapshot */
  id: string;
  /** Tên gói đăng ký */
  name: string;
  /** Mô tả gói nếu có */
  description?: string | null;
  /** Loại chu kỳ */
  periodType: "DAY" | "WEEK" | "MONTH" | "YEAR";
  /**
   * Giá trị chu kỳ
   * @example 1
   */
  periodValue: number;
  /** Hạn mức nhân sự nếu có */
  employeeLimit?: number | null;
  /** Đơn vị tiền tệ */
  currency: "VND";
  /**
   * Giá gói
   * @example 10000000
   */
  price: number;
  /**
   * Chu kỳ ở dạng văn bản
   * @example "1 Tháng"
   */
  cycleLabel: string;
}

export interface EnterprisePaymentPeriodDto {
  /**
   * Ngày bắt đầu chu kỳ
   * @format date-time
   */
  periodStart: string;
  /**
   * Ngày kết thúc chu kỳ
   * @format date-time
   */
  periodEnd: string;
  /**
   * Ngày đến hạn thanh toán
   * @format date-time
   */
  dueDate: string;
}

export interface EnterprisePaymentConfirmedByDto {
  /** ID người xác nhận */
  id: string;
  /** Tên hiển thị của người xác nhận */
  fullName?: string | null;
  /** Email người xác nhận */
  email?: string | null;
}

export interface EnterprisePaymentInfoDto {
  /** Trạng thái thanh toán */
  paymentStatus: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID";
  /**
   * Ngày thanh toán
   * @format date-time
   */
  paymentDate: string | null;
  /** Phương thức thanh toán */
  paymentMethod: "BANK_TRANSFER" | "CASH";
  /**
   * Số tiền đã thanh toán
   * @example 0
   */
  paidAmount: number;
  /** Ghi chú của kỳ thanh toán */
  notes?: string | null;
  /** Thông tin người xác nhận */
  confirmedBy?: EnterprisePaymentConfirmedByDto | null;
  /** Log hoạt động */
  activityLog?: object | null;
}

export interface EnterprisePaymentHistoryItemDto {
  id: string;
  enterpriseId: string;
  /** Trạng thái chu kỳ */
  cycleStatus: "CURRENT" | "NEXT" | "EXPIRED";
  /** Tên gói */
  planName: string;
  /** Chu kỳ dạng văn bản */
  cycleLabel: string;
  /**
   * Giá gói
   * @example 10000000
   */
  planPrice: number;
  /**
   * Ngày bắt đầu chu kỳ
   * @format date-time
   */
  periodStart: string;
  /**
   * Ngày kết thúc chu kỳ
   * @format date-time
   */
  periodEnd: string;
  /**
   * Ngày đến hạn
   * @format date-time
   */
  dueDate: string;
  /**
   * Ngày thanh toán
   * @format date-time
   */
  paymentDate: string | null;
  /**
   * Ngày cập nhật gần nhất
   * @format date-time
   */
  updatedAt: string;
  /** Trạng thái thanh toán */
  paymentStatus: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID";
  /**
   * Số tiền đã thanh toán
   * @example 0
   */
  paidAmount: number;
}

export interface EnterprisePaymentDetailDto {
  id: string;
  enterpriseId: string;
  /** Trạng thái chu kỳ hiện tại */
  cycleStatus: "CURRENT" | "NEXT" | "EXPIRED";
  /** Tên doanh nghiệp */
  companyName: string;
  /** Thông tin gói đăng ký */
  plan: EnterprisePaymentPlanDto;
  /** Thông tin chu kỳ */
  period: EnterprisePaymentPeriodDto;
  /** Thông tin thanh toán */
  payment: EnterprisePaymentInfoDto;
  /**
   * Ngày tạo
   * @format date-time
   */
  createdAt: string;
  /**
   * Ngày cập nhật gần nhất
   * @format date-time
   */
  updatedAt: string;
  /** Thông tin cảnh báo nếu có */
  warning: EnterprisePaymentWarningDto | null;
  /** Lịch sử các kỳ thanh toán */
  history: EnterprisePaymentHistoryItemDto[];
}

export interface UpdateEnterprisePaymentDto {
  paymentStatus: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID";
  /** @format date-time */
  paymentDate?: string;
  paymentMethod?: "BANK_TRANSFER" | "CASH";
  /**
   * Số tiền thanh toán. Bắt buộc khi thanh toán một phần.
   * @min 0
   * @example 5000000
   */
  paidAmount?: number;
  /** ID người xác nhận */
  confirmedById?: string;
  /**
   * Ghi chú bổ sung
   * @maxLength 2000
   */
  notes?: string;
  /**
   * Mô tả cho log hoạt động
   * @maxLength 500
   */
  activityNote?: string;
  /**
   * Có xoá thông tin người xác nhận hay không
   * @default false
   */
  clearConfirmation?: boolean;
  /**
   * Có xoá thông tin thanh toán (ngày, số tiền, phương thức) khi chuyển về trạng thái Chờ hoặc Quá hạn
   * @default false
   */
  resetPaymentFields?: boolean;
}

export interface CreateEnterpriseDto {
  /**
   * Name of the enterprise
   * @example "Tech Corp"
   */
  name: string;
  /**
   * Business field of the enterprise
   * @example "Information Technology"
   */
  businessField: string;
  /**
   * Contact name for the enterprise
   * @example "John Doe"
   */
  contactName: string;
  /**
   * Email address of the enterprise
   * @example "techcorp@gmail.com"
   */
  contactEmail: string;
  /**
   * Phone number of the enterprise
   * @example "+1234567890"
   */
  contactPhone?: string;
  /**
   * Logo URL of the enterprise
   * @example "https://example.com/logo.png"
   */
  logo: string;
  /** @example "SAAS" */
  deploymentType?: EnterpriseDeploymentType;
  /**
   * Domain for LMS access
   * @example "techcorp-lms.onair.today"
   */
  domain?: string;
  /**
   * Subdomain of LMS for the enterprise
   * @example "techcorp-lms"
   */
  subdomain?: string;
  /**
   * Is the enterprise active?
   * @default true
   * @example true
   */
  isActive?: boolean;
  /**
   * Enterprise plan ID
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  enterprisePlanId: string;
  /**
   * Start date of the enterprise plan
   * @format date-time
   * @example "2023-01-01T00:00:00Z"
   */
  planStartDate: string;
}

export interface GetEnterpriseResponse {
  /**
   * Unique identifier for the enterprise
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  id: string;
  /**
   * Name of the enterprise
   * @example "Tech Corp"
   */
  name: string;
  /**
   * Business field of the enterprise
   * @example "Information Technology"
   */
  businessField: string;
  /**
   * Contact name for the enterprise
   * @example "John Doe"
   */
  contactName: string;
  /**
   * Email address of the enterprise
   * @example "techcorp@gmail.com"
   */
  contactEmail: string;
  /**
   * Phone number of the enterprise
   * @example "+1234567890"
   */
  contactPhone: string;
  /**
   * Logo URL of the enterprise
   * @example "https://example.com/logo.png"
   */
  logo?: string | null;
  /**
   * Domain for LMS access
   * @example "techcorp.com"
   */
  domain: string | null;
  /**
   * Subdomain of LMS for the enterprise
   * @example "techcorp"
   */
  subdomain: string | null;
  /**
   * Is the enterprise active?
   * @example true
   */
  isActive: boolean;
  /**
   * Creation date of the enterprise
   * @format date-time
   * @example "2023-10-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Last update date of the enterprise
   * @format date-time
   * @example "2023-10-10T12:00:00Z"
   */
  updatedAt: string;
  /**
   * ID of the current plan
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  currentPlanId: string | null;
  /**
   * Name of the current plan
   * @example "Enterprise Pro"
   */
  currentPlanName: string | null;
  /**
   * Due date for the current plan
   * @format date-time
   * @example "2024-05-15T12:00:00Z"
   */
  currentPlanDueDate: string | null;
  /**
   * Payment status of the current plan
   * @example "PAID"
   */
  currentPlanPaymentStatus: string | null;
  /**
   * Maximum number of employees allowed
   * @example 500
   */
  employeeLimit: number | null;
  /**
   * Start date of the current subscription period
   * @format date-time
   * @example "2024-01-01T00:00:00Z"
   */
  currentPeriodStart: string | null;
  /**
   * End date of the current subscription period
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  currentPeriodEnd: string | null;
}

export interface UpdateEnterpriseDto {
  /**
   * Name of the enterprise
   * @example "Tech Corp"
   */
  name?: string;
  /**
   * Business field of the enterprise
   * @example "Information Technology"
   */
  businessField?: string;
  /**
   * Contact name for the enterprise
   * @example "John Doe"
   */
  contactName?: string;
  /**
   * Email address of the enterprise
   * @example "techcorp@gmail.com"
   */
  contactEmail?: string;
  /**
   * Phone number of the enterprise
   * @example "+1234567890"
   */
  contactPhone?: string;
  /**
   * Logo URL of the enterprise
   * @example "https://example.com/logo.png"
   */
  logo?: string;
  /** @example "SAAS" */
  deploymentType?: EnterpriseDeploymentType;
  /**
   * Domain for LMS access
   * @example "techcorp-lms.onair.today"
   */
  domain?: string;
  /**
   * Subdomain of LMS for the enterprise
   * @example "techcorp-lms"
   */
  subdomain?: string;
  /**
   * Is the enterprise active?
   * @default true
   * @example true
   */
  isActive?: boolean;
  /**
   * Enterprise plan ID
   * @example "cmei1yf080000iiqcm1acwy6w"
   */
  enterprisePlanId?: string;
  /**
   * Start date of the enterprise plan
   * @format date-time
   * @example "2023-01-01T00:00:00Z"
   */
  planStartDate?: string;
}

export interface CreatePaymentRecordDTO {
  /**
   * Payment amount
   * @min 0
   */
  amount: number;
  /** Owner name */
  ownerName: string;
  /** Phone number */
  phoneNumber: string;
  /** Email address */
  email: string;
  /** Array of event session IDs */
  eventSessionIds: string[];
}

export interface PaymentRecordDTO {
  id: string;
  amount: number;
  ownerName: string;
  phoneNumber: string;
  email: string;
  eventId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PaymentRecordCountDTO {
  count: number;
}

export interface EventSessionBasicDTO {
  id: string;
  slug: string;
  name: string | null;
  /** @format date-time */
  startDate: string | null;
  /** @format date-time */
  endDate: string | null;
  banner: string | null;
}

export interface PaymentRecordWithEventSessionsDTO {
  id: string;
  amount: number;
  ownerName: string;
  phoneNumber: string;
  email: string;
  eventId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  eventSessions: EventSessionBasicDTO[];
}

export interface Affiliate {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  count: number;
  partner: string;
  productId: string;
  product: Product;
}

export interface ApplicationReport {
  id: string;
  userAccessCount: number;
  sellerCount: number;
  newSellerCount: number;
  productCount: number;
  newProductCount: number;
  orderCount: number;
  failedOrderCount: number;
  successOrderCount: number;
  revenue: number;
  year: number;
}

export interface BankAccountTokenize {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  tokenizeId: string;
}

export interface Bank {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  bankCode: string;
  bankName: string;
  logoLink?: string;
  isActive: boolean;
}

export interface BehaviorLog {
  id: string;
  apiUrl: string;
  method: string;
  createdBy: string;
  status: number;
  dataId?: string;
  data: object;
  /** @format date-time */
  createdAt: string;
}

export interface CartItemV2 {
  id: string;
  cartId: string;
  itemType: ProductType;
  itemId: string;
  quantity: number;
  note?: string;
  referenceId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  partner?: string;
  cart: Cart;
}

export interface Cart {
  id: string;
  userId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  cartItems: CartItemV2[];
}

export interface CasbinPolicy {
  id: string;
  ptype: string;
  v0?: string;
  v1?: string;
  v2?: string;
  v3?: string;
  v4?: string;
  v5?: string;
}

export interface DeletedResource {
  id: string;
  name: string;
  fileName: string;
  fileType?: string;
  duration?: number;
  /** @format int64 */
  capacity: number;
  linkUrl?: string;
  publicUrl?: string;
  thumbnailUrl?: string;
  content?: string;
  rootLibraryId: string;
  deletedBy?: string;
  /** @format date-time */
  deletedAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  restoredAt?: string;
}

export enum EmailCollectionType {
  REJECTED = "REJECTED",
  CONTACT = "CONTACT",
}

export interface EmailCollection {
  id: string;
  /** @format date-time */
  createdAt: string;
  email: string;
  fullName?: string;
  type: EmailCollectionType;
  rejectReason: string[];
  otherRejectReason?: string;
  question: string[];
  otherQuestion?: string;
  isDeleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  updatedAt: string;
}

export interface GraphUrl {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  image?: string;
  type?: string;
  url: string;
  title: string;
  description: string;
  siteName?: string;
  favicon?: string;
  /** @format date-time */
  articlePublishedTime?: string;
  articleAuthor?: string;
}

export interface IpnHostTemporary {
  id: number;
  url: string;
}

export enum OnlineCourseHistoryChangeModel {
  ONLINE_COURSE = "ONLINE_COURSE",
  SESSION = "SESSION",
  LESSON = "LESSON",
}

export interface OnlineCourseHistoryChange {
  id: string;
  model: OnlineCourseHistoryChangeModel;
  editId: string;
  versionId: string;
  revisionId: string;
  data: object;
  oldData: object;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export enum OtpMethods {
  EMAIL = "EMAIL",
  SMS = "SMS",
  ZNS = "ZNS",
}

export enum OtpActions {
  VERIFY_EMAIL = "VERIFY_EMAIL",
  VERIFY_PHONE = "VERIFY_PHONE",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  TERMINATE_ACCOUNT = "TERMINATE_ACCOUNT",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
}

export interface Otp {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  code: string;
  ttl: string;
  method: OtpMethods;
  action: OtpActions;
  used: boolean;
}

export interface SocialCommunity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: SocialCommunityType;
  url: string;
  name: string;
  products: Product[];
}

export interface SendEmailLog {
  id: string;
  messageId: string;
  email: string;
  status: string;
  subject: string;
  reason?: string;
  /** @format date-time */
  createdAt: string;
}

export interface SubscriptionVoucher {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  subscriptionId: string;
  voucherId: string;
  isActive: boolean;
  discountType: DiscountType;
  discountValue: number;
  duration?: number;
  durationType?: PeriodType;
  remainingUse?: number;
}

export enum VersionStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export interface VersionHistoryChangeV2 {
  id: string;
  editedId: string;
  model: string;
  revisionId: string;
  downRevisionId?: string;
  oldData?: object;
  data?: object;
  /** @format date-time */
  createdAt: string;
  status: VersionStatus;
  scope?: string;
}

export interface VersionHistoryChange {
  id: string;
  editedId: string;
  model: string;
  revisionId: string;
  downRevisionId?: string;
  oldData?: object;
  data?: object;
  /** @format date-time */
  createdAt: string;
}

export interface ViolationKeyword {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  keyword: string;
  isDeleted: boolean;
  note?: string;
}

export interface ContentAndProducts {
  id: string;
  name: string;
  type: string;
  status?: string;
  isActive?: boolean;
  isHidden?: boolean;
  isDeleted?: boolean;
  ownerId: string;
  productId?: string;
  slug: string;
  banner?: string;
  content?: string;
  originalPrice?: number;
  price?: number;
  lowestPrice?: number;
  highestPrice?: number;
  discountValue?: number;
  discountType?: ComboDiscountType;
  /** @format date-time */
  startSellingDate?: string;
  /** @format date-time */
  endSellingDate?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  paidCount?: number;
  kind?: ProductKind;
}

export interface ProductWithPriority {
  id: string;
  productId?: string;
  paidCount?: number;
  /** @format date-time */
  startSellingDate?: string;
  /** @format date-time */
  endSellingDate?: string;
  price?: number;
  name?: string;
  slug?: string;
  categoriesV2: string[];
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  originalPrice?: number;
  productType: ProductType;
  locationTypes: string[];
  contentType?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  startDateFilter?: string;
  /** @format date-time */
  endDateFilter?: string;
  duration?: number;
  durationType?: string;
  ownerFullName: string;
  ownerAvatar?: string;
  ownerJob?: string;
  ownerId?: string;
  ownerUserName?: string;
  status?: string;
  isPublished?: boolean;
  isActive?: boolean;
  isHidden?: boolean;
  isOnair?: boolean;
  discountType?: ComboDiscountType;
  discountValue?: number;
  banner?: string;
  sessionPriceType?: SessionPriceType;
  lowestPrice?: number;
  highestPrice?: number;
  comboContentType?: string;
  priority: number;
  prices?: object;
}

export interface Revenues {
  orderId?: string;
  id: string;
  itemType: string;
  locationType?: string;
  name?: string;
  quantity?: number;
  status?: string;
  userId?: string;
  ownerId?: string;
  originalPrice?: number;
  price?: number;
  adminPrice?: number;
  isAdminCreated: boolean;
  discountProductId?: string;
  voucherId?: string;
  partner?: string;
  note?: string;
  /** @format date-time */
  createdAt: string;
  purpose?: string;
  orderStatus?: OrderStatusV2;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OnAir Project
 * @version 1.0
 * @contact
 *
 * ## The API description
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name AppControllerRoot
     * @request GET:/api/v1
     */
    appControllerRoot: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name AppControllerGetError
     * @request GET:/api/v1/debug-sentry
     */
    appControllerGetError: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/debug-sentry`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadControllerCreateSignUrl
     * @request POST:/api/v1/upload/sign-url
     */
    uploadControllerCreateSignUrl: (
      data: CreateSignUrlDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/upload/sign-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadControllerGetSignUrl
     * @request GET:/api/v1/upload/sign-url/{key}
     */
    uploadControllerGetSignUrl: (key: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/upload/sign-url/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload V2
     * @name UploadV2ControllerCreateSignUrlV2
     * @request POST:/api/v2/upload/sign-url
     */
    uploadV2ControllerCreateSignUrlV2: (
      data: CreateSignUrlDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v2/upload/sign-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload V2
     * @name UploadV2ControllerGetSignUrlV2
     * @request GET:/api/v2/upload/sign-url
     */
    uploadV2ControllerGetSignUrlV2: (
      query: {
        key: string;
        bucket?: string;
        expiresIn?: number;
        keepParameters?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v2/upload/sign-url`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Notification by ID
     *
     * @tags Notifications
     * @name GetNotificationById
     * @summary Get Notification by ID
     * @request GET:/api/v1/notifications/{id}
     * @secure
     */
    getNotificationById: (id: string, params: RequestParams = {}) =>
      this.request<NotificationResponse, any>({
        path: `/api/v1/notifications/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to update Notification
     *
     * @tags Notifications
     * @name UpdateNotification
     * @summary Update Notification
     * @request PATCH:/api/v1/notifications/{id}
     * @secure
     */
    updateNotification: (
      id: string,
      data: UpdateNotificationInput,
      params: RequestParams = {},
    ) =>
      this.request<NotificationResponse, any>({
        path: `/api/v1/notifications/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get all Notifications
     *
     * @tags Notifications
     * @name GetAllNotifications
     * @summary Get all Notifications
     * @request GET:/api/v1/notifications
     * @secure
     */
    getAllNotifications: (
      query?: {
        /** Filter by role, leave empty for all */
        role?:
          | "SUPER_ADMIN"
          | "ADMIN"
          | "PRODUCT_OWNER"
          | "ACA_PARTNER"
          | "MARKETING"
          | "SALE"
          | "HOST"
          | "USER";
        /**
         * The number of items to return.
         * @min 1
         * @default 10
         * @example 10
         */
        limit?: number;
        /**
         * The current page number.
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseClass, any>({
        path: `/api/v1/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to mask all Notifications as read
     *
     * @tags Notifications
     * @name MaskAsReadAllNotifications
     * @summary Mask all Notifications as read
     * @request PATCH:/api/v1/notifications
     * @secure
     */
    maskAsReadAllNotifications: (params: RequestParams = {}) =>
      this.request<MaskReadAllResponse, any>({
        path: `/api/v1/notifications`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to count all Notifications
     *
     * @tags Notifications
     * @name CountNotifications
     * @summary Count all Notifications
     * @request GET:/api/v1/notifications/count
     * @secure
     */
    countNotifications: (params: RequestParams = {}) =>
      this.request<CountNotificationResponse, any>({
        path: `/api/v1/notifications/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to count all unread Notifications
     *
     * @tags Notifications
     * @name CountUnreadNotifications
     * @summary Count all unread Notifications
     * @request GET:/api/v1/notifications/unread
     * @secure
     */
    countUnreadNotifications: (params: RequestParams = {}) =>
      this.request<UnreadNotificationResponse, any>({
        path: `/api/v1/notifications/unread`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to create Notification token
     *
     * @tags Notifications
     * @name NotificationTokenCreate
     * @summary Create Notifications Token
     * @request POST:/api/v1/notifications/mobile
     * @secure
     */
    notificationTokenCreate: (
      data: CreateNotificationTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/mobile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description API to Bulk Delete notification token
     *
     * @tags Notifications
     * @name NotificationTokenBulkDelete
     * @summary Bulk Delete Notifications token
     * @request DELETE:/api/v1/notifications/mobile
     * @secure
     */
    notificationTokenBulkDelete: (
      data: BulkDeletedNotificationTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/mobile`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description API to mask all Notifications as read
     *
     * @tags Notifications
     * @name NotificationTokenTest
     * @summary Mask all Notifications as read
     * @request POST:/api/v1/notifications/mobile/test
     * @secure
     */
    notificationTokenTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/notifications/mobile/test`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogin
     * @summary Login User
     * @request POST:/api/v1/auth/login
     */
    authControllerLogin: (data: CredentialsDto, params: RequestParams = {}) =>
      this.request<ChangePasswordDto, ErrorResponseDto>({
        path: `/api/v1/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLoginSocial
     * @summary Login User by social
     * @request POST:/api/v1/auth/login-social
     */
    authControllerLoginSocial: (
      data: CredentialsSocialDto,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/auth/login-social`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerRequestVerification
     * @summary Request verification via Email or Phone number
     * @request POST:/api/v1/auth/request-verification
     */
    authControllerRequestVerification: (
      data: VerifyRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/request-verification`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerVerify
     * @summary Verify the Email or Phone number
     * @request POST:/api/v1/auth/verify
     */
    authControllerVerify: (data: VerifyDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/auth/verify`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerGetProfile
     * @summary Get current user profile
     * @request GET:/api/v1/auth/me
     * @secure
     */
    authControllerGetProfile: (params: RequestParams = {}) =>
      this.request<UserEntity, any>({
        path: `/api/v1/auth/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name GetFollowings
     * @summary Get users that the current user is followings
     * @request GET:/api/v1/auth/followings
     * @secure
     */
    getFollowings: (
      query?: {
        followingIds?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HostDto[], any>({
        path: `/api/v1/auth/followings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerUpdateProfile
     * @summary Update current user profile
     * @request PATCH:/api/v1/auth/update-profile
     * @secure
     */
    authControllerUpdateProfile: (
      data: UpdateProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/auth/update-profile`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerUpdateInterests
     * @summary Update current user profile
     * @request PATCH:/api/v1/auth/update-interests
     * @secure
     */
    authControllerUpdateInterests: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/auth/update-interests`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerFirstLogin
     * @summary Update lại cờ để hiểu là user đã ligin và gửi email chào mừng
     * @request PATCH:/api/v1/auth/first-login
     * @secure
     */
    authControllerFirstLogin: (params: RequestParams = {}) =>
      this.request<UserEntity, any>({
        path: `/api/v1/auth/first-login`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerUpdatePhone
     * @summary Update phone number
     * @request PATCH:/api/v1/auth/update-phone
     * @secure
     */
    authControllerUpdatePhone: (
      data: UpdatePhoneDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/update-phone`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerChangePassword
     * @summary Change password
     * @request PATCH:/api/v1/auth/change-password
     * @secure
     */
    authControllerChangePassword: (
      data: ChangePasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/change-password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name ConfigurePassword
     * @summary Configure password
     * @request PATCH:/api/v1/auth/configure-password
     * @secure
     */
    configurePassword: (
      data: ConfigurePasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/configure-password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerSetPassword
     * @summary Set password for first-time login
     * @request PATCH:/api/v1/auth/set-password
     * @secure
     */
    authControllerSetPassword: (
      data: SetPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/set-password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerGetOwnOtp
     * @summary Lấy OTP dành cho user đã đăng nhập
     * @request POST:/api/v1/auth/get-own-otp
     * @secure
     */
    authControllerGetOwnOtp: (data: GetOwnOtpDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/auth/get-own-otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSignup
     * @summary User signup
     * @request POST:/api/v1/auth/signup
     */
    authSignup: (data: SignupDto, params: RequestParams = {}) =>
      this.request<SignUpResponseDto, any>({
        path: `/api/v1/auth/signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerForgotPassword
     * @summary Forgot password
     * @request POST:/api/v1/auth/forgot-password
     */
    authControllerForgotPassword: (
      data: ForgotPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/forgot-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerResetPassword
     * @summary Reset password
     * @request PATCH:/api/v1/auth/reset-password
     */
    authControllerResetPassword: (
      data: ResetPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/reset-password`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerRefreshToken
     * @summary Refresh the access token by refresh token
     * @request POST:/api/v1/auth/refresh
     */
    authControllerRefreshToken: (params: RequestParams = {}) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/auth/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogout
     * @summary Logout
     * @request POST:/api/v1/auth/logout
     */
    authControllerLogout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/auth/logout`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTerminateRequest
     * @summary Request deletion of the user account and all related data
     * @request POST:/api/v1/auth/terminate-request
     * @secure
     */
    authControllerTerminateRequest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/auth/terminate-request`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerTerminate
     * @summary Confirm deletion of the user account and all related data
     * @request DELETE:/api/v1/auth/terminate
     * @secure
     */
    authControllerTerminate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/auth/terminate`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get my subscriptions
     *
     * @tags Auth
     * @name GetMySubscriptions
     * @summary Get my subscriptions
     * @request GET:/api/v1/auth/subscriptions
     */
    getMySubscriptions: (
      query?: {
        statuses?: string;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSubscriptionDto[], any>({
        path: `/api/v1/auth/subscriptions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get my subscription plans
     *
     * @tags Auth
     * @name GetMySubscriptionPlans
     * @summary Get my subscription plans
     * @request GET:/api/v1/auth/subscriptions/{subscriptionId}/plans
     */
    getMySubscriptionPlans: (
      subscriptionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanDTO[], any>({
        path: `/api/v1/auth/subscriptions/${subscriptionId}/plans`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get my reskills
     *
     * @tags Auth
     * @name GetMyReskills
     * @summary Get my reskills
     * @request GET:/api/v1/auth/reskills
     */
    getMyReskills: (
      query?: {
        search?: string;
        withExpired?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MyReskillDTO[], any>({
        path: `/api/v1/auth/reskills`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get my reskill
     *
     * @tags Auth
     * @name GetMyReskill
     * @summary Get my reskill
     * @request GET:/api/v1/auth/reskills/{id}
     */
    getMyReskill: (
      id: string,
      query?: {
        search?: string;
        withExpired?: boolean;
        /** @default "RESKILL" */
        type?: "RESKILL" | "LAUNCHPAD";
      },
      params: RequestParams = {},
    ) =>
      this.request<MyReskillDTO, any>({
        path: `/api/v1/auth/reskills/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get products of the reskill price
     *
     * @tags Auth
     * @name GetMyReskillPriceProducts
     * @summary Get authenticated reskill price products
     * @request GET:/api/v1/auth/reskills/prices/{priceId}/products
     */
    getMyReskillPriceProducts: (priceId: string, params: RequestParams = {}) =>
      this.request<ReskillPriceProductWithProgressDTO[], any>({
        path: `/api/v1/auth/reskills/prices/${priceId}/products`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name GetMySurveys
     * @summary Get my surveys
     * @request GET:/api/v1/auth/surveys
     */
    getMySurveys: (
      query?: {
        /** @format date-time */
        createdAt?: string;
        search?: string;
        ids?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: SurveyDetailsDTO[];
        },
        any
      >({
        path: `/api/v1/auth/surveys`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Queue
     * @name CheckJobStatus
     * @summary Job status
     * @request GET:/api/v1/queue/{queueType}/{jobId}/status
     * @secure
     */
    checkJobStatus: (
      jobId: string,
      queueType: string,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/queue/${queueType}/${jobId}/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminGetAllOrder
     * @summary Admin get all order data
     * @request GET:/api/v1/admin/order
     * @secure
     */
    adminGetAllOrder: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        orderBy?: string;
        status?:
          | "PENDING"
          | "FAILED"
          | "SUCCESS"
          | "REFUND"
          | "EXPIRED"
          | "CANCEL"
          | "DELETED";
        fromDate?: string;
        toDate?: string;
        affiliateSource?: string;
        partner?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminOrderDto[];
        },
        any
      >({
        path: `/api/v1/admin/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminCreateOrder
     * @summary Admin create order
     * @request POST:/api/v1/admin/order
     * @secure
     */
    adminCreateOrder: (
      data: AdminCreateOrderStatusInput,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminGetAllOrderProductItem
     * @summary Admin get all order product item
     * @request GET:/api/v1/admin/order/product-items
     * @secure
     */
    adminGetAllOrderProductItem: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminOrderProductItemDto[];
        },
        any
      >({
        path: `/api/v1/admin/order/product-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminUpdateOrder
     * @summary Admin update order
     * @request PATCH:/api/v1/admin/order/{id}
     * @secure
     */
    adminUpdateOrder: (
      id: string,
      data: AdminCreateOrderStatusInput,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/order/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminDeleteOrder
     * @summary Admin delete order
     * @request DELETE:/api/v1/admin/order/{id}
     * @secure
     */
    adminDeleteOrder: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/order/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminGetOrderDetailById
     * @summary Admin get order detail data
     * @request GET:/api/v1/admin/order/{id}
     * @secure
     */
    adminGetOrderDetailById: (id: string, params: RequestParams = {}) =>
      this.request<AdminOrderDto, any>({
        path: `/api/v1/admin/order/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Management - Internal
     * @name AdminUploadAndCreateOrder
     * @summary Admin upload and create order
     * @request POST:/api/v1/admin/order/upload
     * @secure
     */
    adminUploadAndCreateOrder: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/order/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name GetOrders
     * @summary Gets all orders
     * @request GET:/api/v1/orders
     * @secure
     */
    getOrders: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: OrderEntity[];
        },
        any
      >({
        path: `/api/v1/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrderControllerFindById
     * @summary Gets order data in details
     * @request GET:/api/v1/orders/{id}
     * @secure
     */
    orderControllerFindById: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<OrderEntity, any>({
        path: `/api/v1/orders/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name OrderV2ControllerCreateOrder
     * @summary Create order
     * @request POST:/api/v2/orders
     * @secure
     */
    orderV2ControllerCreateOrder: (
      data: CreateOrderRequestDto[],
      params: RequestParams = {},
    ) =>
      this.request<CreateOrderResponseDto, any>({
        path: `/api/v2/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name GetOrdersV2
     * @summary Get all order
     * @request GET:/api/v2/orders
     * @secure
     */
    getOrdersV2: (
      query?: {
        searchValue?: string;
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: OrderInfoResponseDto[];
        },
        any
      >({
        path: `/api/v2/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name OrderV2ControllerGetOrderInfo
     * @summary Get order info
     * @request GET:/api/v2/orders/{orderId}/info
     * @secure
     */
    orderV2ControllerGetOrderInfo: (
      orderId: string,
      query?: {
        transactionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderInfoResponseDto, any>({
        path: `/api/v2/orders/${orderId}/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name OrderV2ControllerGetOrdersByItem
     * @summary Get orders by order item
     * @request GET:/api/v2/orders/order-item/{itemId}
     * @secure
     */
    orderV2ControllerGetOrdersByItem: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetOrderByItemResponseDto[], any>({
        path: `/api/v2/orders/order-item/${itemId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name GetSuccessOrderItems
     * @summary Get success order items
     * @request GET:/api/v2/orders/{itemId}/order-items
     * @secure
     */
    getSuccessOrderItems: (
      itemId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        linkedType?: LinkedOrderItem;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetOrderItemResponse[];
        },
        any
      >({
        path: `/api/v2/orders/${itemId}/order-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get success order items for event offline by event Id
     *
     * @tags Orders V2
     * @name GetSuccessOrdersEventOffline
     * @summary Get success orders event offline
     * @request GET:/api/v2/orders/event-offline/{itemId}
     * @secure
     */
    getSuccessOrdersEventOffline: (
      itemId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetSuccessOrdersEventOfflineDto[];
        },
        any
      >({
        path: `/api/v2/orders/event-offline/${itemId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user success order items for event offline by event Id
     *
     * @tags Orders V2
     * @name GetUserSuccessOrderItemEventOffline
     * @summary Get user success order item event offline
     * @request GET:/api/v2/orders/event-offline/user/{orderId}/{itemId}
     * @secure
     */
    getUserSuccessOrderItemEventOffline: (
      itemId: string,
      orderId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetSuccessOrdersEventOfflineDto, any>({
        path: `/api/v2/orders/event-offline/user/${orderId}/${itemId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders V2
     * @name OrderV2GetByProductSlug
     * @summary Get order item by product slug of current user
     * @request GET:/api/v2/orders/product/{type}/{slug}
     * @secure
     */
    orderV2GetByProductSlug: (
      type: string,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<OrderItemDTO, any>({
        path: `/api/v2/orders/product/${type}/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quotation
     * @name QuotationControllerGetQuotation
     * @summary Quotation order
     * @request POST:/api/v1/quotation
     * @secure
     */
    quotationControllerGetQuotation: (
      data: QuotationRequestDto[],
      params: RequestParams = {},
    ) =>
      this.request<QuotationResponseDto, any>({
        path: `/api/v1/quotation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get top products by paidCount
     *
     * @tags Product Items
     * @name GetTopProducts
     * @summary Get top paid products
     * @request GET:/api/v1/products/top
     */
    getTopProducts: (
      query?: {
        limit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TopProductResponseDto[], TopProductResponseDto[]>({
        path: `/api/v1/products/top`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name CreateVoucher
     * @summary Create a new voucher
     * @request POST:/api/v1/vouchers
     * @secure
     */
    createVoucher: (
      data: UpsertVoucherRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<VoucherDTO, any>({
        path: `/api/v1/vouchers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name GetMyVouchers
     * @summary Get all/my vouchers
     * @request GET:/api/v1/vouchers
     * @secure
     */
    getMyVouchers: (
      query?: {
        search?: string | null;
        status?: VoucherStatus;
        /** @format date-time */
        startDate?: string | null;
        /** @format date-time */
        endDate?: string | null;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: VoucherWithProductTypesDTO[];
        },
        any
      >({
        path: `/api/v1/vouchers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name GetVoucherById
     * @summary Get voucher by id
     * @request GET:/api/v1/vouchers/{id}
     * @secure
     */
    getVoucherById: (id: string, params: RequestParams = {}) =>
      this.request<VoucherDTO, any>({
        path: `/api/v1/vouchers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name UpdateVoucher
     * @summary Update voucher
     * @request PUT:/api/v1/vouchers/{id}
     * @secure
     */
    updateVoucher: (
      id: string,
      data: UpsertVoucherRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<VoucherDTO, any>({
        path: `/api/v1/vouchers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name DeleteVoucher
     * @summary Delete voucher
     * @request DELETE:/api/v1/vouchers/{id}
     * @secure
     */
    deleteVoucher: (id: string, params: RequestParams = {}) =>
      this.request<VoucherDTO, any>({
        path: `/api/v1/vouchers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name PartialUpdateVoucher
     * @summary Partial update voucher
     * @request PATCH:/api/v1/vouchers/{id}
     * @secure
     */
    partialUpdateVoucher: (
      id: string,
      data: PartialVoucherRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<VoucherDTO, any>({
        path: `/api/v1/vouchers/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name GetVoucherProducts
     * @summary Get voucher products
     * @request GET:/api/v1/vouchers/{id}/products
     * @secure
     */
    getVoucherProducts: (id: string, params: RequestParams = {}) =>
      this.request<VoucherProductDTO[], any>({
        path: `/api/v1/vouchers/${id}/products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name GetRestrictedUsersByVoucherId
     * @summary Get restricted users by voucherId
     * @request GET:/api/v1/vouchers/{voucherId}/restricted-users
     * @secure
     */
    getRestrictedUsersByVoucherId: (
      voucherId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: VoucherRestrictedUsersDTO[];
        },
        any
      >({
        path: `/api/v1/vouchers/${voucherId}/restricted-users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voucher Management, Admin Voucher Management - Internal
     * @name GetVoucherOrderItems
     * @summary Get all order items for a specific voucher
     * @request GET:/api/v1/vouchers/{voucherId}/order-items
     * @secure
     */
    getVoucherOrderItems: (
      voucherId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: VoucherOrderItemResponseDto[];
        },
        any
      >({
        path: `/api/v1/vouchers/${voucherId}/order-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API * Admin create user and give some specific information
     *
     * @tags Admin Users Management - Internal
     * @name AdminCreateUser
     * @summary Admin create new user
     * @request POST:/api/v1/admin/users
     * @secure
     */
    adminCreateUser: (data: AdminCreateUserDto, params: RequestParams = {}) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminGetAllUsers
     * @summary Admin gets all users
     * @request GET:/api/v1/admin/users
     * @secure
     */
    adminGetAllUsers: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /**
         * Filter Query object
         * @example {"skip":1,"take":10,"where":{"email":{"startsWith":"condition"}},"include":{"blogs":{"where":{"status":"PUBLISHED"}}}}
         */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: UserEntity[];
        },
        any
      >({
        path: `/api/v1/admin/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users Management - Internal
     * @name AdminCreateInternalUser
     * @summary Admin create internal user
     * @request POST:/api/v1/admin/users/internal
     * @secure
     */
    adminCreateInternalUser: (
      data: CreateInternalUserDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/internal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users Management - Internal
     * @name AdminUpdateInternalUser
     * @summary Admin update internal user
     * @request PATCH:/api/v1/admin/users/internal/{id}
     * @secure
     */
    adminUpdateInternalUser: (
      id: string,
      data: UpdateInternalUserDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/internal/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminUserControllerFindAllHostProfile
     * @summary Admin gets all host profile
     * @request GET:/api/v1/admin/users/host-profiles
     * @secure
     */
    adminUserControllerFindAllHostProfile: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: UserEntity[];
        },
        any
      >({
        path: `/api/v1/admin/users/host-profiles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminGetHostProfile
     * @summary Admin gets host profile data in details
     * @request GET:/api/v1/admin/users/host-profiles/{id}
     * @secure
     */
    adminGetHostProfile: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/host-profiles/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminUserControllerApproveHostProfile
     * @summary Approve host profile
     * @request PATCH:/api/v1/admin/users/host-profiles/{id}/approve
     * @secure
     */
    adminUserControllerApproveHostProfile: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/host-profiles/${id}/approve`,
        method: "PATCH",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminUserControllerRejectHostProfile
     * @summary Reject host profile
     * @request PATCH:/api/v1/admin/users/host-profiles/{id}/reject
     * @secure
     */
    adminUserControllerRejectHostProfile: (
      id: string,
      data: RejectProfile,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/host-profiles/${id}/reject`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminGetUserById
     * @summary Admin gets user data in details
     * @request GET:/api/v1/admin/users/{id}
     * @secure
     */
    adminGetUserById: (id: string, params: RequestParams = {}, query: object) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminUpdateUser
     * @summary Admin updates the user data
     * @request PATCH:/api/v1/admin/users/{id}
     * @secure
     */
    adminUpdateUser: (
      id: string,
      data: UpdateUserDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/admin/users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminDeleteUser
     * @summary Admin deletes the user data
     * @request DELETE:/api/v1/admin/users/{id}
     * @secure
     */
    adminDeleteUser: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/users/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Users Management - Internal
     * @name AdminChangeStatus
     * @summary Admin deactive or active the user
     * @request PATCH:/api/v1/admin/users/change-status/{id}
     * @secure
     */
    adminChangeStatus: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/users/change-status/${id}`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users Management - Internal
     * @name AdminGetAllUserV2
     * @summary Admin get all user v2
     * @request GET:/api/v1/admin/users/v2
     * @secure
     */
    adminGetAllUserV2: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminUserV2Dto[];
        },
        any
      >({
        path: `/api/v1/admin/users/v2`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users Management - Internal
     * @name AdminCountUserByRole
     * @summary Count user by role
     * @request GET:/api/v1/admin/users/count-by-role
     * @secure
     */
    adminCountUserByRole: (params: RequestParams = {}) =>
      this.request<
        {
          SUPER_ADMIN: number;
          ADMIN: number;
          PRODUCT_OWNER: number;
          ACA_PARTNER: number;
          MARKETING: number;
          SALE: number;
          HOST: number;
          USER: number;
        },
        any
      >({
        path: `/api/v1/admin/users/count-by-role`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users Management - Internal
     * @name AdminUploadAndCreateUser
     * @summary Admin upload and create user
     * @request POST:/api/v1/admin/users/upload
     * @secure
     */
    adminUploadAndCreateUser: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/users/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description * Export users to Excel file with optional filters * Filters: status, role (USER/HOST), organization, createdAtFrom, createdAtTo * Date format: YYYY-MM-DD (e.g., 2024-01-01) * If organization filter is applied and current user created those users, passwords will be decrypted and included
     *
     * @tags Admin Users Management - Internal
     * @name AdminExportUsers
     * @summary Admin export users to Excel
     * @request GET:/api/v1/admin/users/export
     * @secure
     */
    adminExportUsers: (
      query?: {
        status?: UserStatus;
        role?: UserRoleExternal;
        organization?: UserOrganization;
        /**
         * Filter users created from this date (ISO 8601 format)
         * @example "2024-01-01"
         */
        createdAtFrom?: string;
        /**
         * Filter users created until this date (ISO 8601 format)
         * @example "2024-12-31"
         */
        createdAtTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/users/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint creates a new sub-library under an existing library.
     *
     * @tags Library
     * @name LibraryCreateSub
     * @summary Create a new sub-library
     * @request POST:/api/v1/libraries/{id}/sub
     * @secure
     */
    libraryCreateSub: (
      id: string,
      data: CreateLibraryDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/libraries/${id}/sub`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a sub-library and its direct child libraries.
     *
     * @tags Library
     * @name LibraryGetByIdWithDirectChild
     * @summary Retrieve a sub-library by ID with direct children
     * @request GET:/api/v1/libraries/{id}/sub
     * @secure
     */
    libraryGetByIdWithDirectChild: (id: string, params: RequestParams = {}) =>
      this.request<GetLibraryResponseDto[], void>({
        path: `/api/v1/libraries/${id}/sub`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a root library.
     *
     * @tags Library
     * @name LibraryGetRoot
     * @summary Retrieve a root library
     * @request GET:/api/v1/libraries/root
     * @secure
     */
    libraryGetRoot: (params: RequestParams = {}) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/libraries/root`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a paginated list of libraries.
     *
     * @tags Library
     * @name LibraryGetList
     * @summary Retrieve a list of libraries
     * @request GET:/api/v1/libraries
     * @secure
     */
    libraryGetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetLibraryResponseDto[];
        },
        void
      >({
        path: `/api/v1/libraries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a root library and its direct child libraries.
     *
     * @tags Library
     * @name LibraryGetRootWithDirectChildById
     * @summary Retrieve a root library by ID with direct children
     * @request GET:/api/v1/libraries/{id}
     * @secure
     */
    libraryGetRootWithDirectChildById: (
      id: string,
      query: {
        /**
         * @min 1
         * @max 5
         * @default 1
         */
        level: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/libraries/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint updates a library with the specified ID.
     *
     * @tags Library
     * @name LibraryUpdateById
     * @summary Update a library by ID
     * @request PUT:/api/v1/libraries/{id}
     * @secure
     */
    libraryUpdateById: (
      id: string,
      data: UpdateLibraryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/libraries/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint deletes a library with the specified ID.
     *
     * @tags Library
     * @name LibraryDeleteById
     * @summary Delete a library by ID
     * @request DELETE:/api/v1/libraries/{id}
     * @secure
     */
    libraryDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/libraries/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint retrieves sub-libraries and resources content
     *
     * @tags Library
     * @name LibraryGetLibraryAndResourceByLibraryId
     * @summary Retrieve libraries and resources by ID
     * @request GET:/api/v1/libraries/{id}/resources
     * @secure
     */
    libraryGetLibraryAndResourceByLibraryId: (
      id: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryAndResourceDto;
        },
        void
      >({
        path: `/api/v1/libraries/${id}/resources`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Search resource by keyword.
     *
     * @tags Library
     * @name ResourceSearchLibraryAndResourceByKeyword
     * @summary Search libraries and resource by keyword
     * @request GET:/api/v1/libraries/search/resources
     * @secure
     */
    resourceSearchLibraryAndResourceByKeyword: (
      query: {
        keyword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryAndResourceDto;
        },
        void
      >({
        path: `/api/v1/libraries/search/resources`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks if any resources in the library are used in online courses.
     *
     * @tags Library
     * @name LibraryCheckUsageInCourses
     * @summary Check if a library is being used in any online course
     * @request GET:/api/v1/libraries/{id}/usage
     * @secure
     */
    libraryCheckUsageInCourses: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/libraries/${id}/usage`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetMembershipPriceDetail
     * @summary Get membership price detail
     * @request GET:/api/v1/subscriptions/{membershipPriceId}
     * @secure
     */
    subscriptionControllerGetMembershipPriceDetail: (
      membershipPriceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MembershipPriceDetailResponseDto, any>({
        path: `/api/v1/subscriptions/${membershipPriceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerCreateSubscription
     * @summary Subscribe to a membership with recurring payment
     * @request POST:/api/v1/subscriptions/{membershipPriceId}/subscribe
     * @secure
     */
    subscriptionControllerCreateSubscription: (
      membershipPriceId: string,
      data: CreateSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateSubscriptionResponseDto, any>({
        path: `/api/v1/subscriptions/${membershipPriceId}/subscribe`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerValidateVoucher
     * @summary Validate a voucher
     * @request POST:/api/v1/subscriptions/{membershipPriceId}/voucher
     * @secure
     */
    subscriptionControllerValidateVoucher: (
      membershipPriceId: string,
      data: SubscriptionVoucherDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionVoucherValidationResponseDto, any>({
        path: `/api/v1/subscriptions/${membershipPriceId}/voucher`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetMyPaidSubscriptions
     * @summary Get all paid subscriptions for the current user
     * @request GET:/api/v1/subscriptions/me
     * @secure
     */
    subscriptionControllerGetMyPaidSubscriptions: (
      params: RequestParams = {},
    ) =>
      this.request<MyPaidSubscriptionsResponseDto, any>({
        path: `/api/v1/subscriptions/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetSubscriptionPaymentSummary
     * @summary Get comprehensive subscription payment summary.
     * @request GET:/api/v1/subscriptions/{id}/payment-summary
     * @secure
     */
    subscriptionControllerGetSubscriptionPaymentSummary: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PaymentSummaryResponseDto, any>({
        path: `/api/v1/subscriptions/${id}/payment-summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetSubscriptionPeriodDetails
     * @summary Get details for a specific subscription period
     * @request GET:/api/v1/subscriptions/period/{id}
     * @secure
     */
    subscriptionControllerGetSubscriptionPeriodDetails: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPeriodDetailsResponseDto, any>({
        path: `/api/v1/subscriptions/period/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerCancelSubscription
     * @summary Cancel a subscription
     * @request POST:/api/v1/subscriptions/{id}/cancel
     * @secure
     */
    subscriptionControllerCancelSubscription: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CancelSubscriptionResponseDto, any>({
        path: `/api/v1/subscriptions/${id}/cancel`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerCancelNonPaidSubscription
     * @summary Cancel a subscription that has not been paid yet
     * @request POST:/api/v1/subscriptions/{id}/cancel-pending
     * @secure
     */
    subscriptionControllerCancelNonPaidSubscription: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CancelSubscriptionResponseDto, any>({
        path: `/api/v1/subscriptions/${id}/cancel-pending`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerUpdateSubscriptionPlan
     * @summary Change subscription to a different plan
     * @request POST:/api/v1/subscriptions/{id}/change-plan/{membershipPriceId}
     * @secure
     */
    subscriptionControllerUpdateSubscriptionPlan: (
      id: string,
      membershipPriceId: string,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionPlanResponseDto, any>({
        path: `/api/v1/subscriptions/${id}/change-plan/${membershipPriceId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetPaymentRecords
     * @summary Get paginated payment records for a subscription
     * @request GET:/api/v1/subscriptions/{id}/payment-records
     * @secure
     */
    subscriptionControllerGetPaymentRecords: (
      id: string,
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: PaymentRecordDto[];
        },
        any
      >({
        path: `/api/v1/subscriptions/${id}/payment-records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerAddNewPaymentMethod
     * @summary Add a new payment method for the user
     * @request POST:/api/v1/subscriptions/card
     * @secure
     */
    subscriptionControllerAddNewPaymentMethod: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/subscriptions/card`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerGetPaymentCards
     * @summary Get all payment card for the user
     * @request GET:/api/v1/subscriptions/card
     * @secure
     */
    subscriptionControllerGetPaymentCards: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/subscriptions/card`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name SubscriptionControllerUpdateSubscriptionPaymentCard
     * @summary Update payment method for the user
     * @request PUT:/api/v1/subscriptions/{id}/card
     * @secure
     */
    subscriptionControllerUpdateSubscriptionPaymentCard: (
      id: string,
      data: UpdateSubscriptionPaymentCardDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/subscriptions/${id}/card`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name RefundControllerFindAllByUser
     * @summary Gets refunds by user
     * @request GET:/api/v1/refunds
     * @secure
     */
    refundControllerFindAllByUser: (
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        status?: "PENDING" | "PROCESSING" | "SUCCESS" | "FAILED";
        id?: string;
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: RefundByUserResponseDto[];
        },
        any
      >({
        path: `/api/v1/refunds`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name RefundControllerUpdateRefundBankAccount
     * @summary Update refund bank account
     * @request PUT:/api/v1/refunds/{id}/account
     * @secure
     */
    refundControllerUpdateRefundBankAccount: (
      id: string,
      data: UpdateRefundBankAccountRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/refunds/${id}/account`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name RefundControllerCountRefundByStatus
     * @summary Gets count refund by status
     * @request GET:/api/v1/refunds/status/count
     * @secure
     */
    refundControllerCountRefundByStatus: (
      query?: {
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/refunds/status/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund, Admin Refunds Management - Internal
     * @name RefundControllerFindAll
     * @summary Gets all refunds
     * @request GET:/api/v1/refunds/all
     * @secure
     */
    refundControllerFindAll: (
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        approvalStatus?:
          | "PENDING"
          | "PROCESSING"
          | "SUCCESS"
          | "FAILED"
          | "AWAITING_INFO";
        id?: string;
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: RefundByUserResponseDto[];
        },
        any
      >({
        path: `/api/v1/refunds/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund, Admin Refunds Management - Internal
     * @name RefundControllerUpdateRefundStatus
     * @summary Update refund status
     * @request PUT:/api/v1/refunds/{id}
     * @secure
     */
    refundControllerUpdateRefundStatus: (
      id: string,
      data: UpdateRefundRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/refunds/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund, Admin Refunds Management - Internal
     * @name RefundControllerCountRefundByApprovalStatus
     * @summary Gets count refund by approval status
     * @request GET:/api/v1/refunds/approval/count
     * @secure
     */
    refundControllerCountRefundByApprovalStatus: (
      query?: {
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/refunds/approval/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name GetMyDiscounts
     * @summary Get all/my discounts
     * @request GET:/api/v1/discounts
     * @secure
     */
    getMyDiscounts: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string | null;
        status?: DiscountStatus;
        /** @format date-time */
        startDate?: string | null;
        /** @format date-time */
        endDate?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: DiscountWithProductTypesDTO[];
        },
        any
      >({
        path: `/api/v1/discounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name CreateDiscount
     * @summary Create discount
     * @request POST:/api/v1/discounts
     * @secure
     */
    createDiscount: (
      data: UpsertDiscountRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<DiscountDTO, any>({
        path: `/api/v1/discounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name GetDiscountById
     * @summary Get discount by id
     * @request GET:/api/v1/discounts/{id}
     * @secure
     */
    getDiscountById: (id: string, params: RequestParams = {}) =>
      this.request<DiscountDTO, any>({
        path: `/api/v1/discounts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name UpdateDiscount
     * @summary Update discount
     * @request PUT:/api/v1/discounts/{id}
     * @secure
     */
    updateDiscount: (
      id: string,
      data: UpsertDiscountRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<DiscountDTO, any>({
        path: `/api/v1/discounts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name PartialUpdateDiscount
     * @summary Update discount
     * @request PATCH:/api/v1/discounts/{id}
     * @secure
     */
    partialUpdateDiscount: (
      id: string,
      data: PartialDiscountRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<DiscountDTO, any>({
        path: `/api/v1/discounts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name DeleteDiscount
     * @summary Delete discount
     * @request DELETE:/api/v1/discounts/{id}
     * @secure
     */
    deleteDiscount: (id: string, params: RequestParams = {}) =>
      this.request<DiscountDTO, any>({
        path: `/api/v1/discounts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name GetDiscountProductsByDiscountId
     * @summary Get discount products by discount id
     * @request GET:/api/v1/discounts/{id}/products
     * @secure
     */
    getDiscountProductsByDiscountId: (id: string, params: RequestParams = {}) =>
      this.request<DiscountProductDTO[], any>({
        path: `/api/v1/discounts/${id}/products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Discounts, Admin Discounts Management - Internal
     * @name GetDiscountOrderItems
     * @summary Get all order items for a specific discount
     * @request GET:/api/v1/discounts/{discountId}/order-items
     * @secure
     */
    getDiscountOrderItems: (
      discountId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: DiscountOrderItemResponseDto[];
        },
        any
      >({
        path: `/api/v1/discounts/${discountId}/order-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerXenditIpn
     * @summary Webhook for Xendit callback
     * @request POST:/api/v2/payments/ipn/xendit
     * @secure
     */
    paymentV2ControllerXenditIpn: (data: Object, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/xendit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerVnpayipn
     * @summary Webhook for VNPay payment callback
     * @request GET:/api/v2/payments/ipn/vnpay
     * @secure
     */
    paymentV2ControllerVnpayipn: (data: Object, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/vnpay`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerHandleSubscriptionVnPayIpn
     * @summary Handle VNPay IPN for Subscriptions
     * @request GET:/api/v2/payments/ipn/vnpay/subscription
     * @secure
     */
    paymentV2ControllerHandleSubscriptionVnPayIpn: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/vnpay/subscription`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerGalaxyPayIpn
     * @summary Webhook for GalaxyPay payment callback
     * @request POST:/api/v2/payments/ipn/galaxypay
     * @secure
     */
    paymentV2ControllerGalaxyPayIpn: (
      data: Object,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/galaxypay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerAppleInAppIpn
     * @summary Webhook for Apple In-App payment callback
     * @request POST:/api/v2/payments/ipn/apple-in-app
     * @secure
     */
    paymentV2ControllerAppleInAppIpn: (
      data: AppleInAppCallbackDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/apple-in-app`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerHandleSubscriptionGalaxyPayIpn
     * @summary Handle GalaxyPay IPN for Subscriptions
     * @request POST:/api/v2/payments/ipn/galaxypay/subscription
     * @secure
     */
    paymentV2ControllerHandleSubscriptionGalaxyPayIpn: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/payments/ipn/galaxypay/subscription`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerRetryPayment
     * @summary Retry payment
     * @request POST:/api/v2/payments/retry
     * @secure
     */
    paymentV2ControllerRetryPayment: (
      data: RetryPaymentRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponseDto, any>({
        path: `/api/v2/payments/retry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments V2
     * @name PaymentV2ControllerGetPayoutSupportList
     * @summary Get payout support bank list
     * @request GET:/api/v2/payments/payouts-channels
     * @secure
     */
    paymentV2ControllerGetPayoutSupportList: (params: RequestParams = {}) =>
      this.request<PayoutSupportListResponseDto, any>({
        path: `/api/v2/payments/payouts-channels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartControllerFindAll
     * @summary Gets all items of cart
     * @request GET:/api/v1/carts
     * @secure
     */
    cartControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: any[];
        },
        any
      >({
        path: `/api/v1/carts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartControllerCount
     * @summary Count items of cart
     * @request GET:/api/v1/carts/count
     * @secure
     */
    cartControllerCount: (
      query?: {
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/carts/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartControllerAddToCart
     * @summary Add to cart
     * @request POST:/api/v1/carts/add
     * @secure
     */
    cartControllerAddToCart: (data: AddItemDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/carts/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart
     * @name CartControllerRemoveCartItem
     * @summary Delate a cart item
     * @request DELETE:/api/v1/carts/{id}
     * @secure
     */
    cartControllerRemoveCartItem: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/carts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart V2
     * @name GetCartItems
     * @summary Gets all items of cart
     * @request GET:/api/v2/carts
     * @secure
     */
    getCartItems: (params: RequestParams = {}) =>
      this.request<CartItemDto[], any>({
        path: `/api/v2/carts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart V2
     * @name CartV2ControllerCount
     * @summary Count items of cart
     * @request GET:/api/v2/carts/count
     * @secure
     */
    cartV2ControllerCount: (params: RequestParams = {}) =>
      this.request<CountItemDto, any>({
        path: `/api/v2/carts/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart V2
     * @name CartAddItem
     * @summary Add to cart
     * @request POST:/api/v2/carts/add
     * @secure
     */
    cartAddItem: (data: AddCartItemDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/carts/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart V2
     * @name CartV2ControllerUpdateCartItem
     * @summary Update a cart item
     * @request PATCH:/api/v2/carts/{id}
     * @secure
     */
    cartV2ControllerUpdateCartItem: (
      id: string,
      data: UpdateItemDto,
      params: RequestParams = {},
    ) =>
      this.request<CartItemDto, any>({
        path: `/api/v2/carts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cart V2
     * @name CartV2ControllerRemoveCartItem
     * @summary Remove a cart item
     * @request DELETE:/api/v2/carts/{id}
     * @secure
     */
    cartV2ControllerRemoveCartItem: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/carts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerCreateSlug
     * @summary Create slug for event
     * @request POST:/api/v1/events/create-slug
     * @secure
     */
    eventControllerCreateSlug: (
      data: CreateSlugDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/create-slug`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerCreate
     * @summary Create Event
     * @request POST:/api/v1/events
     * @secure
     */
    eventControllerCreate: (data: CreateEventDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetAllEvents
     * @summary Get all event
     * @request GET:/api/v1/events
     * @secure
     */
    getAllEvents: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v1/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerFindMineAll
     * @summary Get all events of yourself
     * @request GET:/api/v1/events/mine
     * @secure
     */
    eventControllerFindMineAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EventEntity[];
        },
        any
      >({
        path: `/api/v1/events/mine`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerFindBySlug
     * @summary Gets user data in details
     * @request GET:/api/v1/events/{slug}
     * @secure
     */
    eventControllerFindBySlug: (
      slug: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<EventEntity, any>({
        path: `/api/v1/events/${slug}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventDetailById
     * @summary Get event detail by id
     * @request GET:/api/v1/events/detail-by-id/{id}
     * @secure
     */
    getEventDetailById: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<EventEntity, any>({
        path: `/api/v1/events/detail-by-id/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerUpdate
     * @summary update event data
     * @request PATCH:/api/v1/events/{id}
     * @secure
     */
    eventControllerUpdate: (
      id: string,
      data: UpdateEventDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name EventControllerRemove
     * @request DELETE:/api/v1/events/{id}
     * @secure
     */
    eventControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name QueryEventTrendOnEventDetail
     * @summary Query trending event by categories,most booking,upcoming events
     * @request GET:/api/v1/events/trending-on-event-detail/{eventId}
     * @secure
     */
    queryEventTrendOnEventDetail: (
      eventId: string,
      params: RequestParams = {},
    ) =>
      this.request<object[], any>({
        path: `/api/v1/events/trending-on-event-detail/${eventId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name QueryEventTrendOnCart
     * @summary Query trending event by categories,most booking,upcoming events
     * @request GET:/api/v1/events/trending-on-cart
     * @secure
     */
    queryEventTrendOnCart: (params: RequestParams = {}) =>
      this.request<object[], any>({
        path: `/api/v1/events/trending-on-cart`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name CountEventsByHostId
     * @summary Count events by hostId
     * @request GET:/api/v1/events/count-events-by-hostId/{hostId}
     * @secure
     */
    countEventsByHostId: (hostId: string, params: RequestParams = {}) =>
      this.request<
        {
          all?: number;
          live?: number;
          today?: number;
          future?: number;
          past?: number;
          draft?: number;
        },
        any
      >({
        path: `/api/v1/events/count-events-by-hostId/${hostId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name CheckinQrTicket
     * @summary Validate QR code for event ticket
     * @request POST:/api/v1/events/checkin-qr-ticket
     * @secure
     */
    checkinQrTicket: (data: CheckinQrTicketDto, params: RequestParams = {}) =>
      this.request<CheckinQrTicketResponseDto, any>({
        path: `/api/v1/events/checkin-qr-ticket`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to create Event
     *
     * @tags EventsV2, Admin Events Management - Internal
     * @name CreateEventV2
     * @summary Create Event
     * @request POST:/api/v2/events
     * @secure
     */
    createEventV2: (data: CreateEventV2Input, params: RequestParams = {}) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get events
     *
     * @tags EventsV2
     * @name GetPublicEvents
     * @summary Get events
     * @request GET:/api/v2/events
     * @secure
     */
    getPublicEvents: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by duration */
        duration?: EventDuration;
        /** Filter by type */
        type?: EventTypeV2;
        /** Filter by business */
        business?: string;
        /** Filter by categories */
        categories?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v2/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to update Event
     *
     * @tags EventsV2, Admin Events Management - Internal
     * @name UpdateEventV2
     * @summary Update a Event
     * @request PATCH:/api/v2/events/{id}
     * @secure
     */
    updateEventV2: (
      id: string,
      data: CreateEventV2Input,
      params: RequestParams = {},
    ) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Event by ID
     *
     * @tags EventsV2
     * @name GetEventV2ById
     * @summary Get Event by ID
     * @request GET:/api/v2/events/{id}
     * @secure
     */
    getEventV2ById: (id: string, params: RequestParams = {}) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to draft Event
     *
     * @tags EventsV2, Admin Events Management - Internal
     * @name DraftEventV2
     * @summary Create a draft Event
     * @request POST:/api/v2/events/draft
     * @secure
     */
    draftEventV2: (data: DraftEventV2Input, params: RequestParams = {}) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to draft Event
     *
     * @tags EventsV2, Admin Events Management - Internal
     * @name UpdateDraftEventV2
     * @summary Update a draft Event
     * @request POST:/api/v2/events/{id}/draft
     * @secure
     */
    updateDraftEventV2: (
      id: string,
      data: DraftEventV2Input,
      params: RequestParams = {},
    ) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/${id}/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Event by Slug
     *
     * @tags EventsV2
     * @name GetEventBySlugV2
     * @summary Get Event by Slug
     * @request GET:/api/v2/events/slug/{slug}
     * @secure
     */
    getEventBySlugV2: (slug: string, params: RequestParams = {}) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get events and combos
     *
     * @tags EventsV2
     * @name GetPublicEventsAndCombos
     * @summary Get events and combos
     * @request GET:/api/v2/events/events-and-combos
     * @secure
     */
    getPublicEventsAndCombos: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by duration */
        duration?: EventDuration;
        /** Filter by type */
        type?: EventTypeV2;
        /** Filter by business */
        business?: string;
        /** Filter by categories */
        categories?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v2/events/events-and-combos`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get my events
     *
     * @tags EventsV2
     * @name GetMineEventsV2
     * @summary Get my events
     * @request GET:/api/v2/events/mine
     * @secure
     */
    getMineEventsV2: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Filter by status */
        statuses?: string;
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by min price */
        minPrice?: string;
        /** Filter by max price */
        maxPrice?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
        /** Filter by location type */
        location?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v2/events/mine`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get my co-host events counting
     *
     * @tags EventsV2
     * @name GetMyCoHostEventsCounting
     * @summary Get my co-host events counting
     * @request GET:/api/v2/events/co-host/count
     * @secure
     */
    getMyCoHostEventsCounting: (
      query?: {
        type?: "SINGLE" | "SESSION";
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderItemEventCount, any>({
        path: `/api/v2/events/co-host/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get my co-host events
     *
     * @tags EventsV2
     * @name GetMyCoHostEvents
     * @summary Get my co-host events
     * @request GET:/api/v2/events/co-host
     * @secure
     */
    getMyCoHostEvents: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Filter by status */
        statuses?: string;
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by min price */
        minPrice?: string;
        /** Filter by max price */
        maxPrice?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
        /** Filter by location type */
        location?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v2/events/co-host`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Event or Event Session detail by Ticket Tier ID
     *
     * @tags EventsV2
     * @name GetEventByTicketTierId
     * @summary Get Event by Ticket Tier ID
     * @request GET:/api/v2/events/ticket-tier/{ticketTierId}
     * @secure
     */
    getEventByTicketTierId: (
      ticketTierId: string,
      params: RequestParams = {},
    ) =>
      this.request<EventV2Response, any>({
        path: `/api/v2/events/ticket-tier/${ticketTierId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventCategories, Admin Event Category Management - Internal
     * @name EventCategoryControllerCreate
     * @summary Create Event Category
     * @request POST:/api/v1/event-categories
     * @secure
     */
    eventCategoryControllerCreate: (
      data: CreateEventCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/event-categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventCategories
     * @name EventCategoryControllerFindAll
     * @summary Get all event category
     * @request GET:/api/v1/event-categories
     * @secure
     */
    eventCategoryControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EventCategoryEntity[];
        },
        any
      >({
        path: `/api/v1/event-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventCategories
     * @name EventCategoryControllerFindOne
     * @summary Find event category by id
     * @request GET:/api/v1/event-categories/{id}
     * @secure
     */
    eventCategoryControllerFindOne: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<EventCategoryEntity, any>({
        path: `/api/v1/event-categories/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventCategories, Admin Event Category Management - Internal
     * @name EventCategoryControllerUpdate
     * @summary Update event category
     * @request PATCH:/api/v1/event-categories/{id}
     * @secure
     */
    eventCategoryControllerUpdate: (
      id: string,
      data: UpdateEventCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/event-categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventCategories, Admin Event Category Management - Internal
     * @name EventCategoryControllerRemove
     * @summary Delete event category
     * @request DELETE:/api/v1/event-categories/{id}
     * @secure
     */
    eventCategoryControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/event-categories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerRegister
     * @request POST:/api/v1/users
     * @secure
     */
    userControllerRegister: (data: RegisterDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsers
     * @summary Gets all users
     * @request GET:/api/v1/users
     * @secure
     */
    getUsers: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /**
         * Filter Query object
         * @example {"skip":1,"take":10,"where":{"email":{"startsWith":"condition"}},"include":{"posts":{"where":{"status":"PUBLISHED"}}}}
         */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: UserEntity[];
        },
        any
      >({
        path: `/api/v1/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerRegisterHostProfile
     * @summary Đăng ký trở thành host
     * @request POST:/api/v1/users/register-host
     * @secure
     */
    userControllerRegisterHostProfile: (
      data: RegisterHostProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/register-host`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerResubmitHostProfile
     * @summary Chỉnh sửa hồ sơ và submit lại
     * @request PATCH:/api/v1/users/resubmit-host
     * @secure
     */
    userControllerResubmitHostProfile: (
      data: ResubmitHostProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/resubmit-host`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerGetOtp
     * @summary Lấy OTP dành cho user chưa có trong hệ thống
     * @request POST:/api/v1/users/get-otp
     * @secure
     */
    userControllerGetOtp: (data: GetOtpDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users/get-otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerRankings
     * @summary Get hosts' rankings
     * @request GET:/api/v1/users/host-rankings
     * @secure
     */
    userControllerRankings: (params: RequestParams = {}) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/host-rankings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerFindByUsername
     * @summary Gets user data in details
     * @request GET:/api/v1/users/{username}
     * @secure
     */
    userControllerFindByUsername: (
      username: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/${username}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateUserData
     * @summary Update user data
     * @request PATCH:/api/v1/users/{username}
     * @secure
     */
    userControllerUpdateUserData: (
      username: string,
      data: UpdateUserDataDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/${username}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateUserWorkData
     * @summary Create or update user work data
     * @request POST:/api/v1/users/works
     * @secure
     */
    userControllerUpdateUserWorkData: (
      data: UpdateUserWorkDataDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/works`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateUserEduData
     * @summary Create or update user education data
     * @request POST:/api/v1/users/educations
     * @secure
     */
    userControllerUpdateUserEduData: (
      data: UpdateUserEduDataDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/educations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateUserEchData
     * @summary Create or update user achievement data
     * @request POST:/api/v1/users/achievements
     * @secure
     */
    userControllerUpdateUserEchData: (
      data: UpdateUserEchDataDto,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/achievements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateBankAccount
     * @summary Update user bank account
     * @request POST:/api/v1/users/update-bank-account
     * @secure
     */
    userControllerUpdateBankAccount: (
      data: UpsertUserBankAccount,
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/update-bank-account`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpsertBankAccounts
     * @summary Upsert multiple user payments
     * @request POST:/api/v1/users/payments
     * @secure
     */
    userControllerUpsertBankAccounts: (
      data: UpsertUserBankAccount[],
      params: RequestParams = {},
    ) =>
      this.request<UserEntity, any>({
        path: `/api/v1/users/payments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerCheckPaymentMethodInUse
     * @summary Check if the payment method is in use
     * @request POST:/api/v1/users/payments/check
     * @secure
     */
    userControllerCheckPaymentMethodInUse: (
      data: CheckUserPaymentMethodInUse,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/users/payments/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerDeleteUserWorkData
     * @summary Delete user work data
     * @request DELETE:/api/v1/users/works/{id}
     * @secure
     */
    userControllerDeleteUserWorkData: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/works/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerDeleteUserEduData
     * @summary Delete user edu data
     * @request DELETE:/api/v1/users/educations/{id}
     * @secure
     */
    userControllerDeleteUserEduData: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users/educations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerDeleteUserAchData
     * @summary Delete user achievement data
     * @request DELETE:/api/v1/users/achievements/{id}
     * @secure
     */
    userControllerDeleteUserAchData: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users/achievements/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserControllerUpdateUserOnCategory
     * @summary Update user on category
     * @request PATCH:/api/v1/users/user-on-category
     * @secure
     */
    userControllerUpdateUserOnCategory: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/user-on-category`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUserOnCategory
     * @summary Update user on category
     * @request PATCH:/api/v1/users/user-on-category-v2
     * @secure
     */
    updateUserOnCategory: (
      data: UpdateUserOnCategoryV2Dto,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/users/user-on-category-v2`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUserInterestOnCategory
     * @summary Update user interest on category
     * @request PATCH:/api/v1/users/user-interest-on-category-v2
     * @secure
     */
    updateUserInterestOnCategory: (
      data: UpdateUserOnCategoryV2Dto,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/users/user-interest-on-category-v2`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserGetTopHosts
     * @summary get top hosts
     * @request GET:/api/v1/users/top-hosts
     * @secure
     */
    userGetTopHosts: (
      query: {
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDto[], any>({
        path: `/api/v1/users/top-hosts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UserUpdateHostNotificationMode
     * @summary Update host notification mode
     * @request PATCH:/api/v1/users/host-notification-mode
     * @secure
     */
    userUpdateHostNotificationMode: (
      data: UpdateHostNotificationModeDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/users/host-notification-mode`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User V2
     * @name UserV2GetAll
     * @summary Gets all users v2
     * @request GET:/api/v2/users
     * @secure
     */
    userV2GetAll: (
      query?: {
        /** Filter users by their role */
        role?: UserRole;
        /**
         * Filter users by their category
         * @example "category-12345"
         */
        category?: string;
        /**
         * Filter users by their unit
         * @example "unit-12345"
         */
        unit?: string;
        /**
         * Filter users by their organization ID
         * @example "org-12345"
         */
        organizationId?: string;
        /**
         * Order users by a field
         * @example "eventCount"
         */
        orderBy?: string;
        /**
         * Order users in ascending or descending order
         * @example "ASC"
         */
        order?: string;
        /**
         * Search users by name or email
         * @example "John Doe"
         */
        q?: string;
        /**
         * The number of items to return.
         * @min 1
         * @default 10
         * @example 10
         */
        limit?: number;
        /**
         * The current page number.
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: UserDto[];
        },
        any
      >({
        path: `/api/v2/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get list users with cursor and offset pagination
     *
     * @tags User V2
     * @name UserV2GetList
     * @summary Gets list users v2
     * @request GET:/api/v2/users/list
     * @secure
     */
    userV2GetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Filter users by their role */
        role?: UserRole;
        /**
         * Filter users by their category
         * @example "category-12345"
         */
        category?: string;
        /**
         * Filter users by their unit
         * @example "unit-12345"
         */
        unit?: string;
        /**
         * Filter users by their organization ID
         * @example "org-12345"
         */
        organizationId?: string;
        /**
         * Search users by name or email
         * @example "John Doe"
         */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: UserDto[];
        },
        any
      >({
        path: `/api/v2/users/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of all available online courses.
     *
     * @tags User V2
     * @name OnlineCourseGetListPrivate
     * @summary Retrieve a list of online courses
     * @request GET:/api/v2/users/online-courses
     * @secure
     */
    onlineCourseGetListPrivate: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseDTO[];
        },
        any
      >({
        path: `/api/v2/users/online-courses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User V2
     * @name HostGetRegisterProfile
     * @summary get host register profile
     * @request GET:/api/v2/users/register-host
     * @secure
     */
    hostGetRegisterProfile: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetRegisterHostProfileResponseDto;
        },
        any
      >({
        path: `/api/v2/users/register-host`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User V2
     * @name HostRegisterV2
     * @summary Đăng ký trở thành host v2
     * @request POST:/api/v2/users/register-host
     * @secure
     */
    hostRegisterV2: (
      data: RegisterHostProfileV2Dto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: RegisterHostProfileV2ResponseDto;
        },
        any
      >({
        path: `/api/v2/users/register-host`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User V2
     * @name HostGetUserOnboardingStatus
     * @summary check user register onboarding status
     * @request GET:/api/v2/users/register-host/status
     * @secure
     */
    hostGetUserOnboardingStatus: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetUserOnboardingStatusResponseDto;
        },
        any
      >({
        path: `/api/v2/users/register-host/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Host published online course.
     *
     * @tags Online Courses, OnlineCourse Management - Internal
     * @name OnlineCourseHostPublished
     * @summary Host published online course
     * @request POST:/api/v1/online-courses/{id}/published
     * @secure
     */
    onlineCourseHostPublished: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/online-courses/${id}/published`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of all available online courses.
     *
     * @tags Online Courses
     * @name OnlineCourseGetList
     * @summary Retrieve a list of online courses
     * @request GET:/api/v1/online-courses
     * @secure
     */
    onlineCourseGetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseDTO[];
        },
        void
      >({
        path: `/api/v1/online-courses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of all available online courses and combos.
     *
     * @tags Online Courses
     * @name OnlineCourseAndComboGetList
     * @summary Retrieve a list of online courses and combos
     * @request GET:/api/v1/online-courses/online-courses-and-combos
     * @secure
     */
    onlineCourseAndComboGetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, void>({
        path: `/api/v1/online-courses/online-courses-and-combos`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve online courses created by host
     *
     * @tags Online Courses
     * @name OnlineCourseGetListByHost
     * @summary Retrieve online courses created by host
     * @request GET:/api/v1/online-courses/host
     * @secure
     */
    onlineCourseGetListByHost: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseDTO[];
        },
        void
      >({
        path: `/api/v1/online-courses/host`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve online courses that the current user has registered for
     *
     * @tags Online Courses
     * @name OnlineCourseGetRegisteredByUser
     * @summary Retrieve registered online courses for current user
     * @request GET:/api/v1/online-courses/registered/me
     * @secure
     */
    onlineCourseGetRegisteredByUser: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        isFree?: boolean;
        progressStatus?: UserProductProgressStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseWithProgressDTO[];
        },
        void
      >({
        path: `/api/v1/online-courses/registered/me`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve registered users of a online course
     *
     * @tags Online Courses
     * @name OnlineCourseGetRegisteredUsers
     * @summary Retrieve registered users of a online course
     * @request GET:/api/v1/online-courses/{id}/registered
     * @secure
     */
    onlineCourseGetRegisteredUsers: (
      id: string,
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetOnlineCourseRegisteredUsersResponseDto[];
        },
        void
      >({
        path: `/api/v1/online-courses/${id}/registered`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve registered users of a online course purchased in subscription
     *
     * @tags Online Courses
     * @name OnlineCourseGetRegisteredSubscriptionUsers
     * @summary Retrieve registered users of a online course purchased in subscription
     * @request GET:/api/v1/online-courses/{id}/registered-subscriptions
     * @secure
     */
    onlineCourseGetRegisteredSubscriptionUsers: (
      id: string,
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetOnlineCourseRegisteredUsersResponseDto[];
        },
        void
      >({
        path: `/api/v1/online-courses/${id}/registered-subscriptions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific online course by its ID.
     *
     * @tags Online Courses
     * @name OnlineCourseGetById
     * @summary Retrieve online course details
     * @request GET:/api/v1/online-courses/{id}
     * @secure
     */
    onlineCourseGetById: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetOnlineCourseWithSectionResponseDto;
        },
        void
      >({
        path: `/api/v1/online-courses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing online course by its ID
     *
     * @tags Online Courses
     * @name OnlineCourseDeleteById
     * @summary Delete an online course
     * @request DELETE:/api/v1/online-courses/{id}
     * @secure
     */
    onlineCourseDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/online-courses/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online Courses
     * @name OnlineCourseGetSectionById
     * @summary Retrieve online course details
     * @request GET:/api/v1/online-courses/{id}/section/{sectionId}
     * @secure
     */
    onlineCourseGetSectionById: (
      id: string,
      sectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: SectionDTO;
        },
        void
      >({
        path: `/api/v1/online-courses/${id}/section/${sectionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online Courses
     * @name OnlineCourseGetLessionById
     * @summary Retrieve  lession details
     * @request GET:/api/v1/online-courses/{id}/section/{sectionId}/lession/{lessionId}
     * @secure
     */
    onlineCourseGetLessionById: (
      id: string,
      sectionId: string,
      lessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: LessonDTO;
        },
        void
      >({
        path: `/api/v1/online-courses/${id}/section/${sectionId}/lession/${lessionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get preview lessons
     *
     * @tags Online Courses
     * @name OnlineCourseGetPreviewLessons
     * @summary Get preview lessons
     * @request GET:/api/v1/online-courses/{id}/preview-lessons
     * @secure
     */
    onlineCourseGetPreviewLessons: (id: string, params: RequestParams = {}) =>
      this.request<LessonDTO[], void>({
        path: `/api/v1/online-courses/${id}/preview-lessons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific online course by its slug.
     *
     * @tags Online Courses
     * @name OnlineCourseGetByProductSlug
     * @summary Retrieve online course details by product slug
     * @request GET:/api/v1/online-courses/slug/{slug}
     * @secure
     */
    onlineCourseGetByProductSlug: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetOnlineCourseWithSectionResponseDto;
        },
        void
      >({
        path: `/api/v1/online-courses/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific online course by its slug.
     *
     * @tags Online Courses
     * @name OnlineCourseGetDeepByProductSlug
     * @summary Retrieve online course details by product slug
     * @request GET:/api/v1/online-courses/user/slug/{slug}
     * @secure
     */
    onlineCourseGetDeepByProductSlug: (
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: OnlineCourseDTO;
        },
        void
      >({
        path: `/api/v1/online-courses/user/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get online course recommendations.
     *
     * @tags Online Courses
     * @name OnlineCourseGetRecommendations
     * @summary Get online course recommendations
     * @request GET:/api/v1/online-courses/recomendations
     * @secure
     */
    onlineCourseGetRecommendations: (
      query: {
        slug: string;
        isLnD?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO[], void>({
        path: `/api/v1/online-courses/recomendations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the details of an existing online course by its ID.
     *
     * @tags Online Courses
     * @name OnlineCourseUpsert
     * @summary Upsert online course details
     * @request POST:/api/v1/online-courses/upsert
     * @secure
     */
    onlineCourseUpsert: (data: UpsertCourseDto, params: RequestParams = {}) =>
      this.request<OnlineCourseDTO, void>({
        path: `/api/v1/online-courses/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the displayed of an online course by its ID.
     *
     * @tags Online Courses
     * @name OnlineCourseUpdateDisplayedById
     * @summary Update online course display
     * @request PUT:/api/v1/online-courses/{id}/displayed
     * @secure
     */
    onlineCourseUpdateDisplayedById: (
      id: string,
      data: UpdateOnlineCourseDisplayDto,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO, void>({
        path: `/api/v1/online-courses/${id}/displayed`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve online courses with status rejected and approved_with_admin
     *
     * @tags Online Courses, OnlineCourse Management - Internal
     * @name OnlineCoursesContentModeration
     * @summary Retrieve online courses with status rejected and approved_with_admin
     * @request GET:/api/v1/online-courses/content-moderation
     * @secure
     */
    onlineCoursesContentModeration: (
      query?: {
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/online-courses/content-moderation`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve online courses detail by slug
     *
     * @tags Online Courses, OnlineCourse Management - Internal
     * @name OnlineCoursesContentModerationBySlug
     * @summary Retrieve online courses detail by slug
     * @request GET:/api/v1/online-courses/content-moderation/{slug}
     * @secure
     */
    onlineCoursesContentModerationBySlug: (
      slug: string,
      query?: {
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, void>({
        path: `/api/v1/online-courses/content-moderation/${slug}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve user progress for a specific lesson
     *
     * @tags Online Courses
     * @name GetLessonProgress
     * @summary Get lesson progress
     * @request GET:/api/v1/online-courses/lessons/{lessonId}/progress
     * @secure
     */
    getLessonProgress: (lessonId: string, params: RequestParams = {}) =>
      this.request<UserLessonProgressDTO, void>({
        path: `/api/v1/online-courses/lessons/${lessonId}/progress`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Manually mark a lesson as completed
     *
     * @tags Online Courses
     * @name MarkLessonCompleted
     * @summary Mark lesson as completed
     * @request POST:/api/v1/online-courses/lessons/{lessonId}/complete
     * @secure
     */
    markLessonCompleted: (lessonId: string, params: RequestParams = {}) =>
      this.request<UserLessonProgressDTO, void>({
        path: `/api/v1/online-courses/lessons/${lessonId}/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Buffer progress update for batch processing (optimized for frequent updates)
     *
     * @tags Online Courses
     * @name BufferLessonProgress
     * @summary Buffer lesson progress update
     * @request POST:/api/v1/online-courses/lessons/{lessonId}/progress/buffer
     * @secure
     */
    bufferLessonProgress: (
      lessonId: string,
      data: UpdateLessonProgressWithPriorityDTO,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/online-courses/lessons/${lessonId}/progress/buffer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve comprehensive course details
     *
     * @tags Online Courses
     * @name GetCourseWithProgress
     * @summary Get authenticated course details
     * @request GET:/api/v1/online-courses/courses/{slug}/with-progress
     * @secure
     */
    getCourseWithProgress: (slug: string, params: RequestParams = {}) =>
      this.request<OnlineCourseWithProgressDTO, void>({
        path: `/api/v1/online-courses/courses/${slug}/with-progress`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new section or update an existing section.
     *
     * @tags Sections
     * @name SectionUpsert
     * @summary Create or update section
     * @request POST:/api/v1/sections/upsert
     * @secure
     */
    sectionUpsert: (data: UpsertSectionDto, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/sections/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete an existing section by its ID
     *
     * @tags Sections
     * @name SectionDeleteById
     * @summary Delete section by ID
     * @request DELETE:/api/v1/sections/{id}
     * @secure
     */
    sectionDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/sections/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create or update lesson
     *
     * @tags Lessons
     * @name LessonUpsert
     * @summary Create or update lesson
     * @request POST:/api/v1/lessons/upsert
     * @secure
     */
    lessonUpsert: (data: UpsertLessonDTO, params: RequestParams = {}) =>
      this.request<LessonDTO, void>({
        path: `/api/v1/lessons/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove resource from lesson by ID
     *
     * @tags Lessons
     * @name LessonRemoveResourceFromLesson
     * @summary Remove resource from lesson by lesson id
     * @request DELETE:/api/v1/lessons/{id}/resource/{resourceId}
     * @secure
     */
    lessonRemoveResourceFromLesson: (
      id: string,
      resourceId: string,
      query: {
        isMain: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/lessons/${id}/resource/${resourceId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Delete an existing lesson by its ID
     *
     * @tags Lessons
     * @name LessonDeleteById
     * @summary Delete lesson by id
     * @request DELETE:/api/v1/lessons/{id}
     * @secure
     */
    lessonDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/lessons/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new resource with the provided details.
     *
     * @tags Resources
     * @name ResourceCreate
     * @summary Create a new resource
     * @request POST:/api/v1/resources
     * @secure
     */
    resourceCreate: (data: CreateResourceDto, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetResourceResponseDto;
        },
        void
      >({
        path: `/api/v1/resources`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of resources.
     *
     * @tags Resources
     * @name ResourceGetList
     * @summary Get a list of resource
     * @request GET:/api/v1/resources
     * @secure
     */
    resourceGetList: (
      query?: {
        ids?: string[];
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetResourceResponseDto[];
        },
        void
      >({
        path: `/api/v1/resources`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of link resources.
     *
     * @tags Resources
     * @name ResourceGetLinkList
     * @summary Get a list of link resource
     * @request GET:/api/v1/resources/{id}/links
     * @secure
     */
    resourceGetLinkList: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetResourceResponseDto;
        },
        void
      >({
        path: `/api/v1/resources/${id}/links`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of link resources.
     *
     * @tags Resources
     * @name ResourceSearchLinkList
     * @summary Search a list of link resource
     * @request GET:/api/v1/resources/links/search
     * @secure
     */
    resourceSearchLinkList: (
      query: {
        keyword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetResourceResponseDto;
        },
        void
      >({
        path: `/api/v1/resources/links/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a resource by its unique ID.
     *
     * @tags Resources
     * @name ResourceGetById
     * @summary Get resource by id
     * @request GET:/api/v1/resources/{id}
     * @secure
     */
    resourceGetById: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetResourceResponseDto;
        },
        void
      >({
        path: `/api/v1/resources/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the details of an existing resource.
     *
     * @tags Resources
     * @name ResourceUpdateById
     * @summary Update resource by id
     * @request PUT:/api/v1/resources/{id}
     * @secure
     */
    resourceUpdateById: (
      id: string,
      data: UpdateResourceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/resources/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete a resource by its unique ID
     *
     * @tags Resources
     * @name ResourceDeleteById
     * @summary Delete resource by id
     * @request DELETE:/api/v1/resources/{id}
     * @secure
     */
    resourceDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/resources/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Restore a previously deleted resource by its ID
     *
     * @tags Resources
     * @name ResourceRestoreById
     * @summary Restore deleted resource
     * @request POST:/api/v1/resources/{id}/restored
     * @secure
     */
    resourceRestoreById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/resources/${id}/restored`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a lesson resource by its unique ID.
     *
     * @tags Resources
     * @name GetLessonResourceByResourceId
     * @summary Get lesson resource by id
     * @request GET:/api/v1/resources/{id}/lesson
     * @secure
     */
    getLessonResourceByResourceId: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/resources/${id}/lesson`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Get all product views
     *
     * @tags Products
     * @name GetProductViews
     * @summary Get all product views
     * @request GET:/api/v1/products
     * @secure
     */
    getProductViews: (
      query?: {
        ids?: string;
        search?: string;
        excludes?: string;
        statuses?: string;
        types?: string;
        startDate?: string;
        endDate?: string;
        ownerId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        notExpired?: boolean;
        isFree?: boolean;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ProductViewDTO[];
        },
        any
      >({
        path: `/api/v1/products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all surveys
     *
     * @tags Products
     * @name GetProductSurveys
     * @summary Get all surveys
     * @request GET:/api/v1/products/{id}/surveys
     * @secure
     */
    getProductSurveys: (id: string, params: RequestParams = {}) =>
      this.request<SurveyUserDetailsDTO[], any>({
        path: `/api/v1/products/${id}/surveys`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all eligible product views
     *
     * @tags Products, Admin Product Management - Internal
     * @name GetEligibleProductViews
     * @summary Get all eligible product views
     * @request GET:/api/v1/products/eligible
     * @secure
     */
    getEligibleProductViews: (
      query?: {
        ids?: string;
        search?: string;
        excludes?: string;
        statuses?: string;
        types?: string;
        startDate?: string;
        endDate?: string;
        ownerId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        notExpired?: boolean;
        isFree?: boolean;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ProductViewDTO[];
        },
        any
      >({
        path: `/api/v1/products/eligible`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get events and combos priority cached
     *
     * @tags Products
     * @name GetEventsAndCombosCached
     * @summary Get events and combos priority cached
     * @request GET:/api/v1/products/events-and-combos/cached
     * @secure
     */
    getEventsAndCombosCached: (
      query?: {
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by duration */
        duration?: EventDuration;
        /** Filter by content type */
        contentType?: EventTypeV2;
        /** Filter by business */
        business?: string;
        /** Filter by categories */
        categories?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
        /** Filter by price */
        price?: string;
        /** Filter by priority */
        priority?: string;
        /** Filter by created at date */
        createdAt?: string;
        /** Filter by updated at date */
        updatedAt?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EventV2Response[];
        },
        any
      >({
        path: `/api/v1/products/events-and-combos/cached`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get online courses and combos priority cached
     *
     * @tags Products
     * @name GetOnlineCoursesAndCombosCached
     * @summary Get online courses and combos priority cached
     * @request GET:/api/v1/products/online-courses-and-combos/cached
     * @secure
     */
    getOnlineCoursesAndCombosCached: (
      query?: {
        /** Filter by event state */
        state?: EventState;
        /** Filter by search */
        search?: string;
        /** Filter by duration */
        duration?: EventDuration;
        /** Filter by content type */
        contentType?: EventTypeV2;
        /** Filter by business */
        business?: string;
        /** Filter by categories */
        categories?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
        /** Filter by price */
        price?: string;
        /** Filter by priority */
        priority?: string;
        /** Filter by created at date */
        createdAt?: string;
        /** Filter by updated at date */
        updatedAt?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseDTO[];
        },
        any
      >({
        path: `/api/v1/products/online-courses-and-combos/cached`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product homepage
     *
     * @tags Products
     * @name GetProductHomePage
     * @summary Get product homepage
     * @request GET:/api/v1/products/homepage
     * @secure
     */
    getProductHomePage: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ProductHomePageDTO[];
        },
        any
      >({
        path: `/api/v1/products/homepage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get accessible product
     *
     * @tags Products
     * @name GetAccessibleProduct
     * @summary Get accessible product
     * @request GET:/api/v1/products/{id}/accessible
     * @secure
     */
    getAccessibleProduct: (id: string, params: RequestParams = {}) =>
      this.request<ProductAccessibleDTO, any>({
        path: `/api/v1/products/${id}/accessible`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description update product
     *
     * @tags Products
     * @name UpdateProduct
     * @summary update product
     * @request PATCH:/api/v1/products/{id}
     * @secure
     */
    updateProduct: (
      id: string,
      data: ProductRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/products/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get content and products profile
     *
     * @tags Products
     * @name GetContentAndProducts
     * @summary Get content and products profile
     * @request GET:/api/v1/products/profile
     * @secure
     */
    getContentAndProducts: (
      query?: {
        /** Filter by ownerId */
        ownerId?: string;
        /** Filter by ownerId */
        id?: string;
        /** Filter by type */
        types?: string;
        /** Filter by username */
        username?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetContentAndProductsDto[];
        },
        any
      >({
        path: `/api/v1/products/profile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all public memberships
     *
     * @tags Memberships
     * @name GetPublicMemberships
     * @summary Get all public memberships
     * @request GET:/api/v1/memberships
     * @secure
     */
    getPublicMemberships: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: MembershipDTO[];
        },
        any
      >({
        path: `/api/v1/memberships`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Search all memberships by name or membership price name
     *
     * @tags Memberships
     * @name SearchMembership
     * @summary Search all memberships
     * @request GET:/api/v1/memberships/search
     * @secure
     */
    searchMembership: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: MembershipWithRelationsDTO[];
        },
        any
      >({
        path: `/api/v1/memberships/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get membership by id
     *
     * @tags Memberships
     * @name GetMembershipWithRelationsById
     * @summary Get membership by id
     * @request GET:/api/v1/memberships/{id}
     * @secure
     */
    getMembershipWithRelationsById: (id: string, params: RequestParams = {}) =>
      this.request<MembershipWithRelationsDTO, any>({
        path: `/api/v1/memberships/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get main membership
     *
     * @tags Memberships
     * @name GetMainMembership
     * @summary Get main membership
     * @request GET:/api/v1/memberships/main
     * @secure
     */
    getMainMembership: (params: RequestParams = {}) =>
      this.request<MembershipWithRelationsDTO, any>({
        path: `/api/v1/memberships/main`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetCombos
     * @summary Get combos
     * @request GET:/api/v1/combos
     * @secure
     */
    comboControllerGetCombos: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        discountType?: "PERCENTAGE" | "AMOUNT";
        isActive?: boolean;
        status?: "going_on" | "coming" | "expired";
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: ComboResponseDto[];
        },
        any
      >({
        path: `/api/v1/combos`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerCreateCombo
     * @summary Create combo
     * @request POST:/api/v1/combos
     * @secure
     */
    comboControllerCreateCombo: (
      data: ComboRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/combos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetCombo
     * @summary Get combo by id
     * @request GET:/api/v1/combos/{id}/detail
     * @secure
     */
    comboControllerGetCombo: (id: string, params: RequestParams = {}) =>
      this.request<ComboResponseDto, any>({
        path: `/api/v1/combos/${id}/detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetComboBySlug
     * @summary Get combo by slug
     * @request GET:/api/v1/combos/by-slug/{slug}/detail
     * @secure
     */
    comboControllerGetComboBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<ComboResponseDto, any>({
        path: `/api/v1/combos/by-slug/${slug}/detail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetComboRecommendation
     * @summary Get combo recommendations
     * @request GET:/api/v1/combos/recommend/{slug}
     * @secure
     */
    comboControllerGetComboRecommendation: (
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<ComboResponseDto, any>({
        path: `/api/v1/combos/recommend/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetCombosForProduct
     * @summary Get combos for product
     * @request GET:/api/v1/combos/product/{productId}
     * @secure
     */
    comboControllerGetCombosForProduct: (
      productId: string,
      params: RequestParams = {},
    ) =>
      this.request<ComboResponseDto[], any>({
        path: `/api/v1/combos/product/${productId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerAvailableProduct
     * @summary Get available products for combo
     * @request GET:/api/v1/combos/available-products
     * @secure
     */
    comboControllerAvailableProduct: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        type?:
          | "CALENDAR"
          | "CALENDAR_FRAME"
          | "COMBO"
          | "ONLINE_COURSE"
          | "E_BOOK"
          | "MEMBERSHIP_PRICE"
          | "RESKILL_PRICE"
          | "TICKET_TIER"
          | "DOCUMENT";
        searchValue?: string;
        comboId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: AvailableProductComboResponse[];
        },
        any
      >({
        path: `/api/v1/combos/available-products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerGetBuyers
     * @summary Get buyer for combo
     * @request GET:/api/v1/combos/buyers
     * @secure
     */
    comboControllerGetBuyers: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        comboId: string;
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: ComboBuyerResponseDto[];
        },
        any
      >({
        path: `/api/v1/combos/buyers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name GetCombosByUserId
     * @summary Get combos by userId
     * @request GET:/api/v1/combos/userId/{userId}
     * @secure
     */
    getCombosByUserId: (
      userId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/combos/userId/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerUpdateCombo
     * @summary Update combo
     * @request PUT:/api/v1/combos/{id}
     * @secure
     */
    comboControllerUpdateCombo: (
      id: string,
      data: ComboRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/combos/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerDeleteCombo
     * @summary Delete combo
     * @request DELETE:/api/v1/combos/{id}
     * @secure
     */
    comboControllerDeleteCombo: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/combos/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ComboControllerChangeComboState
     * @summary Change combo state
     * @request PUT:/api/v1/combos/{id}/change-state
     * @secure
     */
    comboControllerChangeComboState: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/combos/${id}/change-state`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Combo
     * @name ValidateComboPurchase
     * @summary Validate combo purchase - check if user already owns products in combo
     * @request POST:/api/v1/combos/{id}/validate
     * @secure
     */
    validateComboPurchase: (id: string, params: RequestParams = {}) =>
      this.request<ProductViewDTO[], any>({
        path: `/api/v1/combos/${id}/validate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Event Session by Id
     *
     * @tags EventSession
     * @name GetEventSessionById
     * @summary Get Event Session by Id
     * @request GET:/api/v1/event-sessions/{id}
     * @secure
     */
    getEventSessionById: (id: string, params: RequestParams = {}) =>
      this.request<EventSession, any>({
        path: `/api/v1/event-sessions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get Event Session by Slug
     *
     * @tags EventSession
     * @name GetEventSessionBySlug
     * @summary Get Event Session by Slug
     * @request GET:/api/v1/event-sessions/slug/{slug}
     * @secure
     */
    getEventSessionBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<EventSessionDTO, any>({
        path: `/api/v1/event-sessions/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills, Admin Reskill Management - Internal
     * @name CreateReskill
     * @summary Create a new reskill
     * @request POST:/api/v1/reskills
     * @secure
     */
    createReskill: (
      data: UpsertReskillRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<ReskillDTO, any>({
        path: `/api/v1/reskills`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills, Admin Reskill Management - Internal
     * @name GetReskills
     * @summary Get all reskills
     * @request GET:/api/v1/reskills
     * @secure
     */
    getReskills: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** @default "RESKILL" */
        type?: "RESKILL" | "LAUNCHPAD";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ReskillWithProductCountDTO[];
        },
        any
      >({
        path: `/api/v1/reskills`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskill
     * @summary Get a reskill by id
     * @request GET:/api/v1/reskills/{id}
     * @secure
     */
    getReskill: (id: string, params: RequestParams = {}) =>
      this.request<ReskillWithRelationsDTO, any>({
        path: `/api/v1/reskills/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills, Admin Reskill Management - Internal
     * @name UpdateReskill
     * @summary Update a reskill
     * @request PUT:/api/v1/reskills/{id}
     * @secure
     */
    updateReskill: (
      id: string,
      data: UpsertReskillRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<ReskillDTO, any>({
        path: `/api/v1/reskills/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name DeleteReskill
     * @summary Delete a reskill
     * @request DELETE:/api/v1/reskills/{id}
     * @secure
     */
    deleteReskill: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/reskills/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetMainReskill
     * @summary Get main reskill
     * @request GET:/api/v1/reskills/main
     * @secure
     */
    getMainReskill: (
      query?: {
        /** @default "RESKILL" */
        type?: "RESKILL" | "LAUNCHPAD";
      },
      params: RequestParams = {},
    ) =>
      this.request<ReskillWithRelationsDTO, any>({
        path: `/api/v1/reskills/main`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskillPrices
     * @summary Get main reskill prices
     * @request GET:/api/v1/reskills/{id}/prices
     * @secure
     */
    getReskillPrices: (
      id: string,
      query?: {
        /** @default "RESKILL" */
        type?: "RESKILL" | "LAUNCHPAD";
      },
      params: RequestParams = {},
    ) =>
      this.request<ReskillPriceWithPromotionDTO[], any>({
        path: `/api/v1/reskills/${id}/prices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskillPriceProducts
     * @summary Get products of the reskill prices
     * @request GET:/api/v1/reskills/prices/{priceId}/products
     * @secure
     */
    getReskillPriceProducts: (priceId: string, params: RequestParams = {}) =>
      this.request<ReskillPriceProductViewDTO[], any>({
        path: `/api/v1/reskills/prices/${priceId}/products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskillPriceDocuments
     * @summary Get documents of the reskill price
     * @request GET:/api/v1/reskills/prices/{priceId}/documents
     * @secure
     */
    getReskillPriceDocuments: (priceId: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/reskills/prices/${priceId}/documents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetSignedReskillPriceDocument
     * @summary Get signed URL for the document of the reskill price
     * @request POST:/api/v1/reskills/prices/{priceId}/documents/{documentId}/signed
     * @secure
     */
    getSignedReskillPriceDocument: (
      priceId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/reskills/prices/${priceId}/documents/${documentId}/signed`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskillProducts
     * @summary Get products of the reskill
     * @request GET:/api/v1/reskills/{id}/products
     * @secure
     */
    getReskillProducts: (id: string, params: RequestParams = {}) =>
      this.request<ReskillPriceProductViewDTO[], any>({
        path: `/api/v1/reskills/${id}/products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name GetReskillByPriceId
     * @summary Get reskill by reskill price ID
     * @request GET:/api/v1/reskills/price/{priceId}
     * @secure
     */
    getReskillByPriceId: (priceId: string, params: RequestParams = {}) =>
      this.request<ReskillWithRelationsDTO, any>({
        path: `/api/v1/reskills/price/${priceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills, Admin Reskill Management - Internal
     * @name GetReskillOrderItems
     * @summary Get all order items for a specific reskill
     * @request GET:/api/v1/reskills/{reskillId}/order-items
     * @secure
     */
    getReskillOrderItems: (
      reskillId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
        userId?: string;
        reskillPriceId?: string;
        status?: "ACTIVATED" | "DEACTIVATED";
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ReskillOrderItemResponseDto[];
        },
        any
      >({
        path: `/api/v1/reskills/${reskillId}/order-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reskills
     * @name ExportReskillOrderItems
     * @summary Admin export order item data of reskill
     * @request GET:/api/v1/reskills/{reskillId}/order-items/export
     * @secure
     */
    exportReskillOrderItems: (
      reskillId: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
        userId?: string;
        reskillPriceId?: string;
        status?: "ACTIVATED" | "DEACTIVATED";
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reskills/${reskillId}/order-items/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveyById
     * @summary Get a survey by ID
     * @request GET:/api/v1/survey/{id}
     * @secure
     */
    getSurveyById: (id: string, params: RequestParams = {}) =>
      this.request<SurveyWithRelationsDTO, any>({
        path: `/api/v1/survey/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name UpdateSurvey
     * @summary Update a survey
     * @request PATCH:/api/v1/survey/{id}
     * @secure
     */
    updateSurvey: (
      id: string,
      data: UpdateSurveyDTO,
      params: RequestParams = {},
    ) =>
      this.request<SurveyDTO, any>({
        path: `/api/v1/survey/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name DeleteSurvey
     * @summary Delete a survey
     * @request DELETE:/api/v1/survey/{id}
     * @secure
     */
    deleteSurvey: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/survey/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveyResult
     * @summary Get survey result by ID
     * @request GET:/api/v1/survey/{id}/result
     * @secure
     */
    getSurveyResult: (id: string, params: RequestParams = {}) =>
      this.request<SurveyResultDTO, any>({
        path: `/api/v1/survey/${id}/result`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SubmitSurvey
     * @summary Submit a survey by ID
     * @request POST:/api/v1/survey/{id}/submit
     * @secure
     */
    submitSurvey: (
      id: string,
      data: SurveySubmitDTO,
      params: RequestParams = {},
    ) =>
      this.request<SurveyDTO, any>({
        path: `/api/v1/survey/${id}/submit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name CreateSurvey
     * @summary Create a new survey
     * @request POST:/api/v1/survey
     * @secure
     */
    createSurvey: (data: CreateSurveyDTO, params: RequestParams = {}) =>
      this.request<SurveyDTO, any>({
        path: `/api/v1/survey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name CreateSurveyPreview
     * @summary Create a new survey preview
     * @request POST:/api/v1/survey/preview
     * @secure
     */
    createSurveyPreview: (
      data: CreateSurveyPreviewDTO,
      params: RequestParams = {},
    ) =>
      this.request<SurveyDTO, any>({
        path: `/api/v1/survey/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveySubmissions
     * @summary Get all submissions for a survey by ID
     * @request GET:/api/v1/survey/{id}/submissions
     * @secure
     */
    getSurveySubmissions: (
      id: string,
      query?: {
        search?: string;
        productIds?: string;
        fromDate?: string;
        toDate?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: SurveySubmissionDTO[];
        },
        any
      >({
        path: `/api/v1/survey/${id}/submissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveyLinkedProducts
     * @summary Get all linked products for a survey by ID
     * @request GET:/api/v1/survey/{id}/linked-products
     * @secure
     */
    getSurveyLinkedProducts: (id: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/survey/${id}/linked-products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name DownloadSurveyMultipleSubmissions
     * @summary Download survey multiple submissions
     * @request GET:/api/v1/survey/{id}/submissions/download
     * @secure
     */
    downloadSurveyMultipleSubmissions: (
      id: string,
      query?: {
        search?: string;
        productIds?: string;
        fromDate?: string;
        toDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/survey/${id}/submissions/download`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name DownloadSurveySubmission
     * @summary Download survey submission by ID
     * @request GET:/api/v1/survey/{id}/submissions/{submissionId}/download
     * @secure
     */
    downloadSurveySubmission: (
      id: string,
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/survey/${id}/submissions/${submissionId}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SurveyControllerTest
     * @summary Temporary endpoint for testing survey answers
     * @request POST:/api/v1/survey/test
     * @secure
     */
    surveyControllerTest: (
      data: CheckboxAnswerDTO,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/survey/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarControllerFindAll
     * @summary Gets all items of calendar
     * @request GET:/api/v1/calendars
     * @secure
     */
    calendarControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: CalendarEntity[];
        },
        any
      >({
        path: `/api/v1/calendars`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarCreate
     * @summary Create calendar
     * @request POST:/api/v1/calendars
     * @secure
     */
    calendarCreate: (data: CreateDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/calendars`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarGetUserListCreate
     * @summary Gets all calendar created by user
     * @request GET:/api/v1/calendars/list-by-user
     * @secure
     */
    calendarGetUserListCreate: (
      query: {
        /**
         * @max 200
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        status?:
          | "PENDING"
          | "PENDING_APPROVAL_WITH_ADMIN"
          | "DRAFT"
          | "ARCHIVED"
          | "PUBLISHED"
          | "REJECTED"
          | "REMOVED";
        /** Filter by start date */
        startDate?: string;
        /** Filter by start date */
        endDate?: string;
        /**
         * Order by field
         * @default "createdAt"
         * @example "createdAt"
         */
        orderBy?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: CalendarByUserResponseDto[];
        },
        any
      >({
        path: `/api/v1/calendars/list-by-user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name GetCalendarDetailById
     * @summary Gets details calendar
     * @request GET:/api/v1/calendars/{id}
     * @secure
     */
    getCalendarDetailById: (
      id: string,
      query?: {
        orderItemStatus?: "CREATED" | "PAID" | "APPROVED" | "REJECTED";
        orderBy?: "ASC" | "DESC";
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<CalendarEntity, any>({
        path: `/api/v1/calendars/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name UpdateCalendarById
     * @summary update calendar
     * @request POST:/api/v1/calendars/frames/{id}
     * @secure
     */
    updateCalendarById: (
      id: string,
      data: UpdateCalendarDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/calendars/frames/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarControllerRemove
     * @summary Remove calendar frame
     * @request DELETE:/api/v1/calendars/frames/{id}
     * @secure
     */
    calendarControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/calendars/frames/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchHistory
     * @name SearchHistoryControllerCreate
     * @request POST:/api/v1/search-histories
     * @secure
     */
    searchHistoryControllerCreate: (
      data: CreateDto,
      params: RequestParams = {},
    ) =>
      this.request<SearchHistoryEntity, any>({
        path: `/api/v1/search-histories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchHistory
     * @name SearchHistoryControllerFindAll
     * @request GET:/api/v1/search-histories
     * @secure
     */
    searchHistoryControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: SearchHistoryEntity[];
        },
        any
      >({
        path: `/api/v1/search-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchHistory
     * @name SearchHistoryControllerDelete
     * @request DELETE:/api/v1/search-histories/{id}
     * @secure
     */
    searchHistoryControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/search-histories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingEvents
     * @name BookingEventControllerFindAll
     * @summary Gets all bookings
     * @request GET:/api/v1/booking-events
     * @secure
     */
    bookingEventControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: BookingEventEntity[];
        },
        any
      >({
        path: `/api/v1/booking-events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingEvents
     * @name BookingEventControllerCounter
     * @summary Get total event booking by all type
     * @request GET:/api/v1/booking-events/counter
     * @secure
     */
    bookingEventControllerCounter: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/booking-events/counter`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingEvents
     * @name BookingEventControllerFindById
     * @summary Gets booking data in details
     * @request GET:/api/v1/booking-events/{id}
     * @secure
     */
    bookingEventControllerFindById: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<BookingEventEntity, any>({
        path: `/api/v1/booking-events/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookingEvents
     * @name BookingEventControllerGetListUserBookingEvent
     * @summary Gets list user booking event
     * @request GET:/api/v1/booking-events/list-user/{eventId}
     * @secure
     */
    bookingEventControllerGetListUserBookingEvent: (
      eventId: string,
      query?: {
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/booking-events/list-user/${eventId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking Calendars
     * @name BookingCalendarControllerFindAll
     * @summary Gets all bookings
     * @request GET:/api/v1/booking-calendars
     * @secure
     */
    bookingCalendarControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: BookingCalendarEntity[];
        },
        any
      >({
        path: `/api/v1/booking-calendars`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking Calendars
     * @name BookingCalendarControllerFindById
     * @summary Gets booking data in details
     * @request GET:/api/v1/booking-calendars/{id}
     * @secure
     */
    bookingCalendarControllerFindById: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<BookingCalendarEntity, any>({
        path: `/api/v1/booking-calendars/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking Calendars
     * @name BookingCalendarControllerChangeStatus
     * @summary Change booking data in details
     * @request PATCH:/api/v1/booking-calendars/{id}
     * @secure
     */
    bookingCalendarControllerChangeStatus: (
      id: string,
      data: ChangeStatusDto,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<BookingCalendarEntity, any>({
        path: `/api/v1/booking-calendars/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name PostControllerCreate
     * @request POST:/api/v1/posts
     * @secure
     */
    postControllerCreate: (data: CreatePostDto, params: RequestParams = {}) =>
      this.request<PostEntity, any>({
        path: `/api/v1/posts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name PostControllerFindAll
     * @request GET:/api/v1/posts
     * @secure
     */
    postControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: PostEntity[];
        },
        any
      >({
        path: `/api/v1/posts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name PostControllerFindAllPostByUsername
     * @summary Get all posts by username
     * @request GET:/api/v1/posts/allByUsername/{username}
     * @secure
     */
    postControllerFindAllPostByUsername: (
      username: string,
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: PostEntity[];
        },
        any
      >({
        path: `/api/v1/posts/allByUsername/${username}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name GetPostDetailBySlug
     * @request GET:/api/v1/posts/{slug}
     * @secure
     */
    getPostDetailBySlug: (
      slug: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<PostEntity, any>({
        path: `/api/v1/posts/${slug}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name GetPostDetailById
     * @summary Get post detail by Id
     * @request GET:/api/v1/posts/detail-by-Id/{id}
     * @secure
     */
    getPostDetailById: (
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<PostEntity, any>({
        path: `/api/v1/posts/detail-by-Id/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name PostControllerUpdate
     * @request PATCH:/api/v1/posts/{id}
     * @secure
     */
    postControllerUpdate: (
      id: string,
      data: UpdatePostDto,
      params: RequestParams = {},
    ) =>
      this.request<PostEntity, any>({
        path: `/api/v1/posts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Posts
     * @name PostControllerDelete
     * @request DELETE:/api/v1/posts/{id}
     * @secure
     */
    postControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/posts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses, Admin Business Management - Internal
     * @name BusinessControllerCreate
     * @summary Create a new business
     * @request POST:/api/v1/businesses
     * @secure
     */
    businessControllerCreate: (data: CreateDto, params: RequestParams = {}) =>
      this.request<BusinessEntity, any>({
        path: `/api/v1/businesses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses
     * @name BusinessesGetAll
     * @request GET:/api/v1/businesses
     * @secure
     */
    businessesGetAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: BusinessEntity[];
        },
        any
      >({
        path: `/api/v1/businesses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses
     * @name BusinessesGetById
     * @request GET:/api/v1/businesses/get-by-id/{id}
     * @secure
     */
    businessesGetById: (
      id: string,
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: BusinessEntity[];
        },
        any
      >({
        path: `/api/v1/businesses/get-by-id/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses
     * @name BusinessControllerFindBySlug
     * @request GET:/api/v1/businesses/{slug}
     * @secure
     */
    businessControllerFindBySlug: (
      slug: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<BusinessEntity, any>({
        path: `/api/v1/businesses/${slug}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses, Admin Business Management
     * @name BusinessControllerUpdate
     * @summary Update a business by ID
     * @request PATCH:/api/v1/businesses/{id}
     * @secure
     */
    businessControllerUpdate: (
      id: string,
      data: UpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<BusinessEntity, any>({
        path: `/api/v1/businesses/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Businesses, Admin Business Management - Internal
     * @name BusinessControllerDelete
     * @summary Delete a business by ID
     * @request DELETE:/api/v1/businesses/{id}
     * @secure
     */
    businessControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/businesses/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host Categories, Admin Host Category Management - Internal
     * @name HostCategoryControllerCreate
     * @summary Create a new host category
     * @request POST:/api/v1/host-categories
     * @secure
     */
    hostCategoryControllerCreate: (
      data: CreateDto,
      params: RequestParams = {},
    ) =>
      this.request<HostCategoryEntity, any>({
        path: `/api/v1/host-categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host Categories
     * @name HostCategoryControllerFindAll
     * @request GET:/api/v1/host-categories
     * @secure
     */
    hostCategoryControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: HostCategoryEntity[];
        },
        any
      >({
        path: `/api/v1/host-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host Categories
     * @name HostCategoryControllerFindBySlug
     * @request GET:/api/v1/host-categories/{slug}
     * @secure
     */
    hostCategoryControllerFindBySlug: (
      slug: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<HostCategoryEntity, any>({
        path: `/api/v1/host-categories/${slug}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host Categories, Admin Host Category Management - Internal
     * @name HostCategoryControllerUpdate
     * @summary Update a host category by ID
     * @request PATCH:/api/v1/host-categories/{id}
     * @secure
     */
    hostCategoryControllerUpdate: (
      id: string,
      data: UpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<HostCategoryEntity, any>({
        path: `/api/v1/host-categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host Categories, Admin Host Category Management - Internal
     * @name HostCategoryControllerDelete
     * @summary Delete a host category by ID
     * @request DELETE:/api/v1/host-categories/{id}
     * @secure
     */
    hostCategoryControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/host-categories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email Collections
     * @name EmailCollectionControllerCreate
     * @request POST:/api/v1/email-collections
     * @secure
     */
    emailCollectionControllerCreate: (
      data: CreateDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailCollectionEntity, any>({
        path: `/api/v1/email-collections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email Collections
     * @name EmailCollectionControllerFindAll
     * @request GET:/api/v1/email-collections
     * @secure
     */
    emailCollectionControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EmailCollectionEntity[];
        },
        any
      >({
        path: `/api/v1/email-collections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email Collections
     * @name EmailCollectionControllerUpdate
     * @request PATCH:/api/v1/email-collections/{id}
     * @secure
     */
    emailCollectionControllerUpdate: (
      id: string,
      data: UpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailCollectionEntity, any>({
        path: `/api/v1/email-collections/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Open Graph
     * @name OpenGraphControllerGetDataGraph
     * @summary get
     * @request POST:/api/v1/open-graph
     * @secure
     */
    openGraphControllerGetDataGraph: (
      data: GetGraphDto,
      params: RequestParams = {},
    ) =>
      this.request<OpenGraphEntity, any>({
        path: `/api/v1/open-graph`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Follow
     * @name Follow
     * @summary follow
     * @request POST:/api/v1/follow
     * @secure
     */
    follow: (data: FollowDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/follow`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Follow
     * @name Unfollow
     * @summary unfollow
     * @request DELETE:/api/v1/follow
     * @secure
     */
    unfollow: (data: FollowDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/follow`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Follow
     * @name FollowControllerGetFollower
     * @summary get list follower
     * @request GET:/api/v1/follow/{username}
     * @secure
     */
    followControllerGetFollower: (
      username: string,
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: any[];
        },
        any
      >({
        path: `/api/v1/follow/${username}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarFrame
     * @name CalendarFrameControllerFindAll
     * @summary Gets all calendar frames
     * @request GET:/api/v1/calendar-frames
     * @secure
     */
    calendarFrameControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: CalendarFrame[];
        },
        any
      >({
        path: `/api/v1/calendar-frames`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalendarFrame
     * @name CalendarFrameControllerFindById
     * @summary Gets details calendar frame
     * @request GET:/api/v1/calendar-frames/{id}
     * @secure
     */
    calendarFrameControllerFindById: (
      id: string,
      query?: {
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<CalendarFrame, any>({
        path: `/api/v1/calendar-frames/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerFindAll
     * @summary Gets all violation keywords
     * @request GET:/api/v1/content-moderation/keywords
     * @secure
     */
    contentModerationControllerFindAll: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: any[];
        },
        any
      >({
        path: `/api/v1/content-moderation/keywords`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerAddKeyword
     * @summary Add a violation keyword
     * @request POST:/api/v1/content-moderation/keywords
     * @secure
     */
    contentModerationControllerAddKeyword: (
      data: AddViolationKeywordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/keywords`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerUpdateKeyword
     * @summary Update a violation keyword
     * @request PUT:/api/v1/content-moderation/keywords
     * @secure
     */
    contentModerationControllerUpdateKeyword: (
      data: UpdateViolationKeywordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/keywords`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerUploadKeywordsFile
     * @summary Uploads a single file
     * @request POST:/api/v1/content-moderation/keywords/upload
     * @secure
     */
    contentModerationControllerUploadKeywordsFile: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/keywords/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerRemoveKeyword
     * @summary Delete a violation keyword
     * @request DELETE:/api/v1/content-moderation/keywords/{id}
     * @secure
     */
    contentModerationControllerRemoveKeyword: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/keywords/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerModerate
     * @summary Test text moderation
     * @request POST:/api/v1/content-moderation/test
     * @secure
     */
    contentModerationControllerModerate: (
      data: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerRejectContent
     * @summary Reject content moderation
     * @request PATCH:/api/v1/content-moderation/{type}/{id}/reject
     * @secure
     */
    contentModerationControllerRejectContent: (
      type: string,
      id: string,
      data: RejectContentDto,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/${type}/${id}/reject`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description * Only admin can use this API
     *
     * @tags Admin Content Moderation Management - Internal
     * @name ContentModerationControllerApproveContent
     * @summary Approve content moderation
     * @request PATCH:/api/v1/content-moderation/{type}/{id}/approve
     * @secure
     */
    contentModerationControllerApproveContent: (
      type: string,
      id: string,
      params: RequestParams = {},
      query: object,
    ) =>
      this.request<void, any>({
        path: `/api/v1/content-moderation/${type}/${id}/approve`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal, Content Moderation - Internal
     * @name ContentModerationControllerFindAllContent
     * @summary Get all content moderation need to review (host need permission)
     * @request GET:/api/v1/content-moderation
     * @secure
     */
    contentModerationControllerFindAllContent: (
      query?: {
        /** @default 0 */
        skip?: number;
        /** @default 10 */
        take?: number;
        /** Filter Query object */
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: ContentModeration[];
        },
        any
      >({
        path: `/api/v1/content-moderation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Content Moderation Management - Internal
     * @name CountContentModerationByHostId
     * @summary Count content moderation by hostId
     * @request GET:/api/v1/content-moderation/count-content-moderation-by-hostId/{hostId}
     * @secure
     */
    countContentModerationByHostId: (
      hostId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          all?: number;
          pendingApprovalWithAdmin?: number;
          rejected?: number;
        },
        any
      >({
        path: `/api/v1/content-moderation/count-content-moderation-by-hostId/${hostId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This will return all reports
     *
     * @tags ReportApplication
     * @name ApplicationReportControllerGetSummary
     * @summary Get all reports
     * @request POST:/api/reports
     * @secure
     */
    applicationReportControllerGetSummary: (params: RequestParams = {}) =>
      this.request<ApplicationSummary, any>({
        path: `/api/reports`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get all category
     *
     * @tags Category
     * @name CategoryGetAll
     * @summary Get all category
     * @request GET:/api/v1/category
     * @secure
     */
    categoryGetAll: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetAllCategoryEntity[];
        },
        void
      >({
        path: `/api/v1/category`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get category by categoryId
     *
     * @tags Category
     * @name CategoryGetById
     * @summary Get category by categoryId
     * @request GET:/api/v1/category/{categoryId}
     * @secure
     */
    categoryGetById: (categoryId: string, params: RequestParams = {}) =>
      this.request<GetCategoryByIdEntity, void>({
        path: `/api/v1/category/${categoryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to get category by slug
     *
     * @tags Category
     * @name CategoryGetBySlug
     * @summary Get category by slug
     * @request GET:/api/v1/category/slug/{slug}
     * @secure
     */
    categoryGetBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<GetCategoryByIdEntity, void>({
        path: `/api/v1/category/slug/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoriesGetNested
     * @summary Get nest categories
     * @request POST:/api/v1/category/nested
     * @secure
     */
    categoriesGetNested: (params: RequestParams = {}) =>
      this.request<CategoryDto[], void>({
        path: `/api/v1/category/nested`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoriesGetNestedByRoot
     * @summary Get nest categories by root category
     * @request POST:/api/v1/category/{id}/nested
     * @secure
     */
    categoriesGetNestedByRoot: (id: string, params: RequestParams = {}) =>
      this.request<CategoryDto, void>({
        path: `/api/v1/category/${id}/nested`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoriesGetHosts
     * @summary Get hosts on categories
     * @request GET:/api/v1/category/{id}/users
     * @secure
     */
    categoriesGetHosts: (
      id: string,
      query: {
        limit: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDto[], void>({
        path: `/api/v1/category/${id}/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks Scheduler
     * @name EventReminder
     * @summary Send email event reminder
     * @request POST:/api/v1/web-hooks/scheduler/event-reminder
     * @secure
     */
    eventReminder: (data: EventReminderInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/web-hooks/scheduler/event-reminder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks Scheduler
     * @name CalendarReminder
     * @summary Send calendar reminder
     * @request POST:/api/v1/web-hooks/scheduler/calendar-reminder
     * @secure
     */
    calendarReminder: (
      data: CalendarReminderInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/web-hooks/scheduler/calendar-reminder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks Sns
     * @name SnsWebhookControllerHandleSnsMessage
     * @summary Log email status
     * @request POST:/api/v3/web-hooks/sns
     */
    snsWebhookControllerHandleSnsMessage: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v3/web-hooks/sns`,
        method: "POST",
        ...params,
      }),

    /**
     * @description API to create root category
     *
     * @tags Admin Categories Management - Internal
     * @name AdminRootCategoryCreate
     * @summary Create a new root category
     * @request POST:/api/v1/admin/category/root
     * @secure
     */
    adminRootCategoryCreate: (
      data: CreateRootCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateCategoryEntity, void>({
        path: `/api/v1/admin/category/root`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to assign root category to business
     *
     * @tags Admin Categories Management - Internal
     * @name AdminRootCategoryAssignToBusiness
     * @summary Assign a root category to business
     * @request PATCH:/api/v1/admin/category/assign-to-business/{categoryId}/{businessId}
     * @secure
     */
    adminRootCategoryAssignToBusiness: (
      categoryId: string,
      businessId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/assign-to-business/${categoryId}/${businessId}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to unassign root category to business
     *
     * @tags Admin Categories Management - Internal
     * @name AdminRootCategoryUnassignToBusiness
     * @summary Unassign a root category to business
     * @request PATCH:/api/v1/admin/category/unassign-to-business/{categoryId}/{businessId}
     * @secure
     */
    adminRootCategoryUnassignToBusiness: (
      categoryId: string,
      businessId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/unassign-to-business/${categoryId}/${businessId}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to create sub category
     *
     * @tags Admin Categories Management - Internal
     * @name AdminSubCategoryCreate
     * @summary Create a new sub category
     * @request POST:/api/v1/admin/category/sub
     * @secure
     */
    adminSubCategoryCreate: (
      data: CreateSubCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateCategoryEntity, void>({
        path: `/api/v1/admin/category/sub`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to assign category to host
     *
     * @tags Admin Categories Management - Internal
     * @name AdminCategoryAssignToHost
     * @summary Assign a category to host
     * @request PATCH:/api/v1/admin/category/assign-to-host/{categoryId}/{hostId}
     * @secure
     */
    adminCategoryAssignToHost: (
      categoryId: string,
      hostId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/assign-to-host/${categoryId}/${hostId}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to unassign category to host
     *
     * @tags Admin Categories Management - Internal
     * @name AdminCategoryUnassignToHost
     * @summary Unassign a category to host
     * @request PATCH:/api/v1/admin/category/unassign-to-host/{categoryId}/{hostId}
     * @secure
     */
    adminCategoryUnassignToHost: (
      categoryId: string,
      hostId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/unassign-to-host/${categoryId}/${hostId}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to update category
     *
     * @tags Admin Categories Management - Internal
     * @name AdminCategoryUpdate
     * @summary Update category
     * @request PATCH:/api/v1/admin/category/{categoryId}
     * @secure
     */
    adminCategoryUpdate: (
      categoryId: string,
      data: UpdateCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateCategoryEntity, void>({
        path: `/api/v1/admin/category/${categoryId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API to delete category
     *
     * @tags Admin Categories Management - Internal
     * @name AdminCategoryDelete
     * @summary Delete category
     * @request DELETE:/api/v1/admin/category/{categoryId}
     * @secure
     */
    adminCategoryDelete: (categoryId: string, params: RequestParams = {}) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/${categoryId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to toggle status category
     *
     * @tags Admin Categories Management - Internal
     * @name AdminCategoryToggleStatus
     * @summary Toggle status category
     * @request PATCH:/api/v1/admin/category/toggle-status/{categoryId}
     * @secure
     */
    adminCategoryToggleStatus: (
      categoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/api/v1/admin/category/toggle-status/${categoryId}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name OrderItemControllerGetEventOrderItemCount
     * @summary Get event order items count
     * @request GET:/api/v1/order-items/event/count
     * @secure
     */
    orderItemControllerGetEventOrderItemCount: (
      query?: {
        type?: "SINGLE" | "SESSION";
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderItemEventCount, any>({
        path: `/api/v1/order-items/event/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name OrderItemControllerGetEventOrderItem
     * @summary Get event order items
     * @request GET:/api/v1/order-items/event
     * @secure
     */
    orderItemControllerGetEventOrderItem: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        status?: "all" | "going_on" | "today" | "coming" | "happened" | "draft";
        type?: "SINGLE" | "SESSION";
        searchValue?: string;
        /** Filter by min price */
        minPrice?: string;
        /** Filter by max price */
        maxPrice?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
        /** To get One Event. */
        eventId?: string;
        /** Filter by location type */
        location?: string;
        /** Filter by event type */
        eventType?: "SINGLE" | "SESSION";
        isFree?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EventV2WithTicketsResponse[];
        },
        any
      >({
        path: `/api/v1/order-items/event`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name GetEventSessionOrderItems
     * @summary Get event session order items
     * @request GET:/api/v1/order-items/event-session
     * @secure
     */
    getEventSessionOrderItems: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        ids?: string[];
        searchValue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: EventSession[];
        },
        any
      >({
        path: `/api/v1/order-items/event-session`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name OrderItemControllerGetCalendarFrameOrderItem
     * @summary Get calendar frame order items
     * @request GET:/api/v1/order-items/calendar-frame
     * @secure
     */
    orderItemControllerGetCalendarFrameOrderItem: (
      query: {
        /**
         * @max 25
         * @default 10
         */
        take: number;
        /** @default 0 */
        skip: number;
        status?: any;
        searchValue?: string;
        /** Filter by start date */
        startDate?: string;
        /** Filter by end date */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedEntity & {
          items?: OrderItemEventResponse[];
        },
        any
      >({
        path: `/api/v1/order-items/calendar-frame`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name OrderItemControllerGetDetailCalendarFrameOrderItem
     * @summary Get calendar frame order item detail
     * @request GET:/api/v1/order-items/{orderItemId}/calendar-frame
     * @secure
     */
    orderItemControllerGetDetailCalendarFrameOrderItem: (
      orderItemId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrderItemCalendarFrameDetailResponse, any>({
        path: `/api/v1/order-items/${orderItemId}/calendar-frame`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders Item
     * @name OrderItemControllerChangeStatusCalendarFrameOrderItem
     * @summary Host confirm or reject calendar frame order item
     * @request PUT:/api/v1/order-items/{orderItemId}/calendar-frame
     * @secure
     */
    orderItemControllerChangeStatusCalendarFrameOrderItem: (
      orderItemId: string,
      data: ChangeStatusOrderItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/order-items/${orderItemId}/calendar-frame`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description API to get list of events
     *
     * @tags Admin Events Management - Internal
     * @name GetAdminEvents
     * @summary Get list of events
     * @request GET:/api/v1/admin/events
     * @secure
     */
    getAdminEvents: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
        sortField?: string;
        sortOrder?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminEventDTO[];
        },
        any
      >({
        path: `/api/v1/admin/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API to delete an event
     *
     * @tags Admin Events Management - Internal
     * @name DeleteEvent
     * @summary Delete an event
     * @request DELETE:/api/v1/admin/events/{id}
     * @secure
     */
    deleteEvent: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/events/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description API to hide an event
     *
     * @tags Admin Events Management - Internal
     * @name AdminHideEvent
     * @summary Hide an event
     * @request PATCH:/api/v1/admin/events/{id}
     * @secure
     */
    adminHideEvent: (
      id: string,
      data: {
        /** @example true */
        isHidden: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/events/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host
     * @name GetOwnProducts
     * @summary Get all products of host
     * @request GET:/api/v1/host/products
     * @secure
     */
    getOwnProducts: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OwnProductDTO[];
        },
        any
      >({
        path: `/api/v1/host/products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host
     * @name GetFollowersCount
     * @summary Get followers count of host
     * @request GET:/api/v1/host/{id}/followers-count
     * @secure
     */
    getFollowersCount: (id: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/api/v1/host/${id}/followers-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host
     * @name GetOwnProductsWithStatistics
     * @summary Get all products with statistics of host
     * @request GET:/api/v1/host/products-with-statistics
     * @secure
     */
    getOwnProductsWithStatistics: (
      query: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** @default "" */
        ages?: string;
        /** @default "" */
        genders?: string;
        /** @default "" */
        productTypes?: string;
        fromDate: string;
        toDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OwnProductWithStatisticsDTO[];
        },
        any
      >({
        path: `/api/v1/host/products-with-statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host
     * @name GetProductOverview
     * @summary Get all products of host
     * @request GET:/api/v1/host/product-overview
     * @secure
     */
    getProductOverview: (
      query: {
        products: string | null;
        fromDate: string;
        toDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HostProductOverviewDTO, any>({
        path: `/api/v1/host/product-overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Host
     * @name GetProductStatistics
     * @summary Get product statistics of host
     * @request GET:/api/v1/host/metrics/product-statistics
     * @secure
     */
    getProductStatistics: (
      query: {
        products: string | null;
        fromDate: string;
        toDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductStatisticDTO, any>({
        path: `/api/v1/host/metrics/product-statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Product Management - Internal
     * @name AdminGetAllProduct
     * @summary Admin get all product
     * @request GET:/api/v1/admin/product
     */
    adminGetAllProduct: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminProductDto[];
        },
        any
      >({
        path: `/api/v1/admin/product`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all memberships
     *
     * @tags Admin Memberships Management - Internal
     * @name GetMemberships
     * @summary Get all memberships
     * @request GET:/api/v1/admin/memberships
     * @secure
     */
    getMemberships: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: MembershipWithProductCountDTO[];
        },
        any
      >({
        path: `/api/v1/admin/memberships`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create membership
     *
     * @tags Admin Memberships Management - Internal
     * @name CreateMembership
     * @summary Create membership
     * @request POST:/api/v1/admin/memberships
     * @secure
     */
    createMembership: (
      data: UpsertMembershipRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<MembershipDTO, any>({
        path: `/api/v1/admin/memberships`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update membership
     *
     * @tags Admin Memberships Management - Internal
     * @name UpdateMembership
     * @summary Update membership
     * @request PUT:/api/v1/admin/memberships/{id}
     * @secure
     */
    updateMembership: (
      id: string,
      data: UpsertMembershipRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<MembershipDTO, any>({
        path: `/api/v1/admin/memberships/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete membership
     *
     * @tags Admin Memberships Management - Internal
     * @name DeleteMembership
     * @summary Delete membership
     * @request DELETE:/api/v1/admin/memberships/{id}
     * @secure
     */
    deleteMembership: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/admin/memberships/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Switch membership status
     *
     * @tags Admin Memberships Management - Internal
     * @name SwitchMembershipStatus
     * @summary Switch membership status
     * @request PATCH:/api/v1/admin/memberships/{id}/switch-status
     * @secure
     */
    switchMembershipStatus: (
      id: string,
      data: SwitchStatusMembershipRequestDTO,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/admin/memberships/${id}/switch-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all memberships
     *
     * @tags Admin Memberships Management - Internal
     * @name GetMembershipRegisteredSubscriptions
     * @summary Get all memberships
     * @request GET:/api/v1/admin/memberships/{id}/registered
     * @secure
     */
    getMembershipRegisteredSubscriptions: (
      id: string,
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string | null;
        cancelFrom?: string | null;
        cancelTo?: string | null;
        subscriptionFrom?: string | null;
        subscriptionTo?: string | null;
        membershipPriceId?: string | null;
        status?: "ACTIVE" | "INACTIVE";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: MembershipRegisteredSubscriptionDTO[];
        },
        any
      >({
        path: `/api/v1/admin/memberships/${id}/registered`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Export registered subscriptions
     *
     * @tags Admin Memberships Management - Internal
     * @name ExportRegisteredSubscriptions
     * @summary Export registered subscriptions
     * @request GET:/api/v1/admin/memberships/{id}/registered/export
     * @secure
     */
    exportRegisteredSubscriptions: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/v1/admin/memberships/${id}/registered/export`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Academy
     * @name GetAcademyParts
     * @summary Get academy parts by subscription
     * @request GET:/api/v1/academy/{subscriptionId}/parts
     * @secure
     */
    getAcademyParts: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<AcademyPartDTO[], any>({
        path: `/api/v1/academy/${subscriptionId}/parts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Academy
     * @name GetAcademyPart
     * @summary Get academy part products by subscription
     * @request GET:/api/v1/academy/{subscriptionId}/parts/{partId}
     * @secure
     */
    getAcademyPart: (
      subscriptionId: string,
      partId: string,
      params: RequestParams = {},
    ) =>
      this.request<AcademyPartWithRelationsDTO, any>({
        path: `/api/v1/academy/${subscriptionId}/parts/${partId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Email Management - Internal
     * @name AdminGetAllEmail
     * @summary Admin get all emails
     * @request GET:/api/v1/admin/email
     * @secure
     */
    adminGetAllEmail: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        orderBy?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: AdminEmailDto[];
        },
        any
      >({
        path: `/api/v1/admin/email`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name TrackingAffiliate
     * @summary Tracking affiliation
     * @request POST:/api/v2/affiliate/tracking
     * @secure
     */
    trackingAffiliate: (
      data: TrackingAffiliateInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/affiliate/tracking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get all online courses
     *
     * @tags Admin Online Courses Management - Internal
     * @name OnlineCourseGetListByAdmin
     * @summary Get all online courses
     * @request GET:/api/v1/admin/online-course
     * @secure
     */
    onlineCourseGetListByAdmin: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseDTO[];
        },
        any
      >({
        path: `/api/v1/admin/online-course`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the displayed of an online course by its ID.
     *
     * @tags Admin Online Courses Management - Internal
     * @name OnlineCourseUpdateDisplayedByIdByAdmin
     * @summary Update online course display by admin
     * @request PUT:/api/v1/admin/online-course/{id}/displayed
     * @secure
     */
    onlineCourseUpdateDisplayedByIdByAdmin: (
      id: string,
      data: UpdateOnlineCourseDisplayDto,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO, any>({
        path: `/api/v1/admin/online-course/${id}/displayed`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing online course by its ID
     *
     * @tags Admin Online Courses Management - Internal
     * @name OnlineCourseDeleteByIdByAdmin
     * @summary Delete an online course by admin
     * @request DELETE:/api/v1/admin/online-course/{id}
     * @secure
     */
    onlineCourseDeleteByIdByAdmin: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/online-course/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create or Update the details of an existing online course by its ID.
     *
     * @tags Admin Online Courses Management - Internal
     * @name OnlineCourseUpsertByAdmin
     * @summary Admin Upsert online course details
     * @request POST:/api/v1/admin/online-course/upsert
     * @secure
     */
    onlineCourseUpsertByAdmin: (
      data: AdminUpsertCourseDto,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO, any>({
        path: `/api/v1/admin/online-course/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create an upcoming online course and its linked product
     *
     * @tags Admin Online Courses Management - Internal
     * @name CreateUpcomingOnlineCourseByAdmin
     * @summary Create upcoming online course
     * @request POST:/api/v1/admin/online-course/create-upcoming
     * @secure
     */
    createUpcomingOnlineCourseByAdmin: (
      data: CreateUpcomingOnlineCourseDto,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO, any>({
        path: `/api/v1/admin/online-course/create-upcoming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing upcoming online course and its linked product
     *
     * @tags Admin Online Courses Management - Internal
     * @name UpdateUpcomingOnlineCourseByAdmin
     * @summary Update upcoming online course
     * @request PUT:/api/v1/admin/online-course/update-upcoming/{id}
     * @secure
     */
    updateUpcomingOnlineCourseByAdmin: (
      id: string,
      data: CreateUpcomingOnlineCourseDto,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseDTO, any>({
        path: `/api/v1/admin/online-course/update-upcoming/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses Management - Internal
     * @name AdminExportOnlineCourses
     * @summary Admin export online courses
     * @request GET:/api/v1/admin/online-course/export
     * @secure
     */
    adminExportOnlineCourses: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/online-course/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses Management - Internal
     * @name AdminExportOnlineCourseProgress
     * @summary Admin export online course progress
     * @request GET:/api/v1/admin/online-course/progress/export
     * @secure
     */
    adminExportOnlineCourseProgress: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        category?: string;
        orderBy?: string;
        status?:
          | "DRAFT"
          | "UNPUBLISHED"
          | "REVIEWED"
          | "PUBLISHED"
          | "REJECTED"
          | "DELETED"
          | "PENDING_APPROVAL_WITH_ADMIN";
        fromDate?: string;
        toDate?: string;
        userId?: string;
        isAcademy?: boolean;
        isReskill?: boolean;
        isLaunchpad?: boolean;
        isOnair?: boolean;
        isLnD?: boolean;
        belongsToUpcoming?: boolean;
        withUpcoming?: boolean;
        ignorePublishedUpcoming?: boolean;
        isFree?: boolean;
        kind?: ProductKind;
        careerType?: CareerType;
        releaseDate?: string;
        planId?: string;
        organization?: UserOrganization;
        /** Include courses created by hosts outside the organization (default: false) */
        includeExternalHosts?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/online-course/progress/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2GetListByAdmin
     * @summary Get all online courses v2 with filtering
     * @request GET:/api/v2/admin/online-course
     * @secure
     */
    onlineCourseV2GetListByAdmin: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
        isLnD?: boolean;
        isOnair?: boolean;
        displayed?: boolean;
        status?: OnlineCourseStatus;
        /** @format date-time */
        createdFrom?: string;
        /** @format date-time */
        createdTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseV2SimplifiedDTO[];
        },
        any
      >({
        path: `/api/v2/admin/online-course`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2CreateByAdmin
     * @summary Create online course v2
     * @request POST:/api/v2/admin/online-course
     * @secure
     */
    onlineCourseV2CreateByAdmin: (
      data: CreateOnlineCourseV2DTO,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseV2DTO, any>({
        path: `/api/v2/admin/online-course`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2GetByIdByAdmin
     * @summary Get online course v2 by ID
     * @request GET:/api/v2/admin/online-course/{id}
     * @secure
     */
    onlineCourseV2GetByIdByAdmin: (id: string, params: RequestParams = {}) =>
      this.request<OnlineCourseV2DTO, any>({
        path: `/api/v2/admin/online-course/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2UpdateByIdByAdmin
     * @summary Update online course v2
     * @request PUT:/api/v2/admin/online-course/{id}
     * @secure
     */
    onlineCourseV2UpdateByIdByAdmin: (
      id: string,
      data: UpdateOnlineCourseV2DTO,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseV2DTO, any>({
        path: `/api/v2/admin/online-course/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2DeleteByIdByAdmin
     * @summary Delete online course v2
     * @request DELETE:/api/v2/admin/online-course/{id}
     * @secure
     */
    onlineCourseV2DeleteByIdByAdmin: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/admin/online-course/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2GetDetailedByIdByAdmin
     * @summary Get comprehensive online course v2 data for edit form
     * @request GET:/api/v2/admin/online-course/{id}/detailed
     * @secure
     */
    onlineCourseV2GetDetailedByIdByAdmin: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseV2DetailedDTO, any>({
        path: `/api/v2/admin/online-course/${id}/detailed`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Online Courses V2 Management - Internal
     * @name OnlineCourseV2SaveDraftByAdmin
     * @summary Save online course draft
     * @request POST:/api/v2/admin/online-course/draft
     * @secure
     */
    onlineCourseV2SaveDraftByAdmin: (
      data: SaveDraftOnlineCourseDTO,
      params: RequestParams = {},
    ) =>
      this.request<OnlineCourseV2SimplifiedDTO, any>({
        path: `/api/v2/admin/online-course/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or update lesson
     *
     * @tags Admin - Lessons Management - Internal
     * @name AdminUpsertLesson
     * @summary Create or update lesson
     * @request POST:/api/v1/admin/lessons/upsert
     * @secure
     */
    adminUpsertLesson: (data: UpsertLessonDTO, params: RequestParams = {}) =>
      this.request<LessonDTO, void>({
        path: `/api/v1/admin/lessons/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove resource from lesson by ID
     *
     * @tags Admin - Lessons Management - Internal
     * @name AdminRemoveResourceFromLessonByLessonId
     * @summary Remove resource from lesson by lesson id
     * @request DELETE:/api/v1/admin/lessons/{id}/resource/{resourceId}
     * @secure
     */
    adminRemoveResourceFromLessonByLessonId: (
      id: string,
      resourceId: string,
      query: {
        isMain: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/admin/lessons/${id}/resource/${resourceId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Delete an existing lesson by its ID
     *
     * @tags Admin - Lessons Management - Internal
     * @name AdminDeleteLesson
     * @summary Delete lesson by id
     * @request DELETE:/api/v1/admin/lessons/{id}
     * @secure
     */
    adminDeleteLesson: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/admin/lessons/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new section or update an existing section.
     *
     * @tags Admin Sections Management - Internal
     * @name AdminUpsertSection
     * @summary Create or update section
     * @request POST:/api/v1/admin/sections/upsert
     * @secure
     */
    adminUpsertSection: (data: UpsertSectionDto, params: RequestParams = {}) =>
      this.request<SectionDTO, void>({
        path: `/api/v1/admin/sections/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing section by its ID
     *
     * @tags Admin Sections Management - Internal
     * @name AdminDeleteSectionById
     * @summary Delete section by ID
     * @request DELETE:/api/v1/admin/sections/{id}
     * @secure
     */
    adminDeleteSectionById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/admin/sections/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Layoff Discount Requests - Internal
     * @name AdminGetAllLayoffDiscountRequests
     * @summary Get all layoff discount requests
     * @request GET:/api/v1/admin/layoff-discount-requests
     * @secure
     */
    adminGetAllLayoffDiscountRequests: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /**
         * @max 200
         * @default 10
         */
        take?: number;
        /** @default 0 */
        skip?: number;
        status?: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
        search?: string;
        userId?: string;
        companyName?: string;
        layoffDateFrom?: number;
        layoffDateTo?: number;
        createdAtFrom?: number;
        createdAtTo?: number;
        processedAtFrom?: number;
        processedAtTo?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: LayoffDiscountRequestDto[];
        },
        any
      >({
        path: `/api/v1/admin/layoff-discount-requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Layoff Discount Requests - Internal
     * @name AdminGetLayoffDiscountRequestById
     * @summary Get layoff discount request by ID
     * @request GET:/api/v1/admin/layoff-discount-requests/{id}
     * @secure
     */
    adminGetLayoffDiscountRequestById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<LayoffDiscountRequestDto, any>({
        path: `/api/v1/admin/layoff-discount-requests/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the status of a layoff discount request (approve, reject, or cancel)
     *
     * @tags Admin Layoff Discount Requests - Internal
     * @name AdminUpdateLayoffDiscountRequestStatus
     * @summary Update layoff discount request status
     * @request PATCH:/api/v1/admin/layoff-discount-requests/{id}/status
     * @secure
     */
    adminUpdateLayoffDiscountRequestStatus: (
      id: string,
      data: UpdateLayoffDiscountRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<LayoffDiscountRequestDto, any>({
        path: `/api/v1/admin/layoff-discount-requests/${id}/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the latest rejected layoff discount request including timeline of all related requests
     *
     * @tags Layoff Discount Requests
     * @name GetLatestRejectedLayoffDiscountRequestWithTimeline
     * @summary Get latest rejected layoff discount request with timeline
     * @request GET:/api/v1/layoff-discount-requests/latest-rejected
     * @secure
     */
    getLatestRejectedLayoffDiscountRequestWithTimeline: (
      params: RequestParams = {},
    ) =>
      this.request<LayoffDiscountRequestWithTimelineDto, any>({
        path: `/api/v1/layoff-discount-requests/latest-rejected`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Layoff Discount Requests
     * @name UserRequestLayoffDiscount
     * @summary Request layoff discount
     * @request POST:/api/v1/layoff-discount-requests
     * @secure
     */
    userRequestLayoffDiscount: (
      data: CreateLayoffDiscountRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateLayoffDiscountRequestResponseDto, any>({
        path: `/api/v1/layoff-discount-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Layoff Discount Requests
     * @name UserGetLayoffDiscountRequest
     * @summary Get lastest layoff discount request
     * @request GET:/api/v1/layoff-discount-requests/latest
     * @secure
     */
    userGetLayoffDiscountRequest: (params: RequestParams = {}) =>
      this.request<GetLatestLayoffRequestResponseDto, any>({
        path: `/api/v1/layoff-discount-requests/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint creates a new sub-library under an existing library.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryCreateSub
     * @summary Create a new sub-library
     * @request POST:/api/v1/admin/libraries/{id}/sub
     * @secure
     */
    adminLibraryCreateSub: (
      id: string,
      data: AdminCreateLibraryDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/admin/libraries/${id}/sub`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a sub-library and its direct child libraries.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryGetByIdWithDirectChild
     * @summary Retrieve a sub-library by ID with direct children
     * @request GET:/api/v1/admin/libraries/{id}/sub
     * @secure
     */
    adminLibraryGetByIdWithDirectChild: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<GetLibraryResponseDto[], void>({
        path: `/api/v1/admin/libraries/${id}/sub`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a root library.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryGetRoot
     * @summary Retrieve a root library
     * @request GET:/api/v1/admin/libraries/root/{userId}
     * @secure
     */
    adminLibraryGetRoot: (userId: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/admin/libraries/root/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a paginated list of libraries.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryGetList
     * @summary Retrieve a list of libraries
     * @request GET:/api/v1/admin/libraries
     * @secure
     */
    adminLibraryGetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetLibraryResponseDto[];
        },
        void
      >({
        path: `/api/v1/admin/libraries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves a root library and its direct child libraries.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryGetRootWithDirectChildById
     * @summary Retrieve a root library by ID with direct children
     * @request GET:/api/v1/admin/libraries/{id}
     * @secure
     */
    adminLibraryGetRootWithDirectChildById: (
      id: string,
      query: {
        /**
         * @min 1
         * @max 5
         * @default 1
         */
        level: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryResponseDto;
        },
        void
      >({
        path: `/api/v1/admin/libraries/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint retrieves sub-libraries and resources content
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryGetLibraryAndResourceByLibraryId
     * @summary Retrieve libraries and resources by ID
     * @request GET:/api/v1/admin/libraries/{id}/resources
     * @secure
     */
    adminLibraryGetLibraryAndResourceByLibraryId: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryAndResourceDto;
        },
        void
      >({
        path: `/api/v1/admin/libraries/${id}/resources`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Search resource by keyword.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminResourceSearchLibraryAndResourceByKeyword
     * @summary Search libraries and resource by keyword
     * @request GET:/api/v1/admin/libraries/search/resources/{userId}
     * @secure
     */
    adminResourceSearchLibraryAndResourceByKeyword: (
      userId: string,
      query: {
        keyword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: GetLibraryAndResourceDto;
        },
        void
      >({
        path: `/api/v1/admin/libraries/search/resources/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Checks if any resources in the library are used in online courses.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryCheckUsageInCourses
     * @summary Check if a library is being used in any online course
     * @request GET:/api/v1/admin/libraries/{id}/usage/{userId}
     * @secure
     */
    adminLibraryCheckUsageInCourses: (
      id: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/admin/libraries/${id}/usage/${userId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint updates a library with the specified ID.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryUpdateById
     * @summary Update a library by ID
     * @request PUT:/api/v1/admin/libraries/{id}/{userId}
     * @secure
     */
    adminLibraryUpdateById: (
      id: string,
      userId: string,
      data: UpdateLibraryDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/admin/libraries/${id}/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint deletes a library with the specified ID.
     *
     * @tags Admin Libraries Management - Internal
     * @name AdminLibraryDeleteById
     * @summary Delete a library by ID
     * @request DELETE:/api/v1/admin/libraries/{id}/{userId}
     * @secure
     */
    adminLibraryDeleteById: (
      id: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/admin/libraries/${id}/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Item Management - Internal
     * @name AdminGetAllOrderItem
     * @summary Admin get all order item data
     * @request GET:/api/v1/admin/order-item
     */
    adminGetAllOrderItem: (
      query?: {
        itemType?:
          | "CALENDAR"
          | "CALENDAR_FRAME"
          | "COMBO"
          | "ONLINE_COURSE"
          | "E_BOOK"
          | "MEMBERSHIP_PRICE"
          | "RESKILL_PRICE"
          | "TICKET_TIER"
          | "DOCUMENT"
          | "ONLINE"
          | "OFFLINE";
        fromDate?: string;
        toDate?: string;
        affiliateSource?: string;
        userId?: string;
        hostId?: string;
        createdBy?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: RevenueItemDto[];
        },
        any
      >({
        path: `/api/v1/admin/order-item`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Order Item Management - Internal
     * @name AdminExportOrderItems
     * @summary Admin export order item data
     * @request GET:/api/v1/admin/order-item/export
     */
    adminExportOrderItems: (
      query?: {
        itemType?:
          | "CALENDAR"
          | "CALENDAR_FRAME"
          | "COMBO"
          | "ONLINE_COURSE"
          | "E_BOOK"
          | "MEMBERSHIP_PRICE"
          | "RESKILL_PRICE"
          | "TICKET_TIER"
          | "DOCUMENT"
          | "ONLINE"
          | "OFFLINE";
        fromDate?: string;
        toDate?: string;
        affiliateSource?: string;
        userId?: string;
        hostId?: string;
        createdBy?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/order-item/export`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Fetches permissions for a specific user role.
     *
     * @tags Admin Permission Management
     * @name GetPermissionsByRole
     * @summary Get permissions by role
     * @request GET:/api/v1/admin/permission
     */
    getPermissionsByRole: (
      query?: {
        /** Role of the user to fetch permissions for. */
        role?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PermissionDto[], any>({
        path: `/api/v1/admin/permission`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Adds a new permission for a specific role.
     *
     * @tags Admin Permission Management
     * @name AddPermission
     * @summary Add a new permission
     * @request POST:/api/v1/admin/permission
     */
    addPermission: (data: CreatePermissionDto[], params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/admin/permission`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a specific permission by its ID.
     *
     * @tags Admin Permission Management
     * @name DeletePermissionById
     * @summary Delete a permission by ID
     * @request POST:/api/v1/admin/permission/delete
     */
    deletePermissionById: (data: string[], params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/admin/permission/delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new mentor consultation request
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestCreate
     * @summary Create a new mentor consultation request
     * @request POST:/api/v1/lms-requests/mentor-consultation
     * @secure
     */
    mentorRequestCreate: (
      data: CreateMentorRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: MentorRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/mentor-consultation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a paginated list of mentor consultation requests with filtering and search
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestList
     * @summary Get all mentor consultation requests
     * @request GET:/api/v1/lms-requests/mentor-consultation
     * @secure
     */
    mentorRequestList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: MentorRequestResponseDto[];
        },
        void
      >({
        path: `/api/v1/lms-requests/mentor-consultation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Export filtered mentor consultation requests to Excel file
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestExport
     * @summary Export mentor consultation requests to Excel
     * @request GET:/api/v1/lms-requests/mentor-consultation/export
     * @secure
     */
    mentorRequestExport: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/mentor-consultation/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get detailed information about a specific mentor consultation request
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestGetById
     * @summary Get mentor consultation request by ID
     * @request GET:/api/v1/lms-requests/mentor-consultation/{id}
     * @secure
     */
    mentorRequestGetById: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: MentorRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/mentor-consultation/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a mentor consultation request
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestUpdate
     * @summary Update mentor consultation request
     * @request PUT:/api/v1/lms-requests/mentor-consultation/{id}
     * @secure
     */
    mentorRequestUpdate: (
      id: string,
      data: UpdateMentorRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: MentorRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/mentor-consultation/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a mentor consultation request
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestDelete
     * @summary Delete mentor consultation request
     * @request DELETE:/api/v1/lms-requests/mentor-consultation/{id}
     * @secure
     */
    mentorRequestDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/mentor-consultation/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Update the status of a mentor consultation request
     *
     * @tags LMS Requests - Mentor Consultation
     * @name MentorRequestUpdateStatus
     * @summary Update mentor consultation request status
     * @request PUT:/api/v1/lms-requests/mentor-consultation/{id}/status
     * @secure
     */
    mentorRequestUpdateStatus: (
      id: string,
      data: UpdateStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: MentorRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/mentor-consultation/${id}/status`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestCreate
     * @summary Create a new inhouse training request
     * @request POST:/api/v1/lms-requests/inhouse-training
     * @secure
     */
    inhouseTrainingRequestCreate: (
      data: CreateInhouseTrainingRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: InhouseTrainingRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/inhouse-training`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestList
     * @summary Get all inhouse training requests
     * @request GET:/api/v1/lms-requests/inhouse-training
     * @secure
     */
    inhouseTrainingRequestList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: InhouseTrainingRequestResponseDto[];
        },
        void
      >({
        path: `/api/v1/lms-requests/inhouse-training`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestExport
     * @summary Export inhouse training requests to Excel
     * @request GET:/api/v1/lms-requests/inhouse-training/export
     * @secure
     */
    inhouseTrainingRequestExport: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/inhouse-training/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestGetById
     * @summary Get inhouse training request by ID
     * @request GET:/api/v1/lms-requests/inhouse-training/{id}
     * @secure
     */
    inhouseTrainingRequestGetById: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: InhouseTrainingRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/inhouse-training/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestUpdate
     * @summary Update inhouse training request
     * @request PUT:/api/v1/lms-requests/inhouse-training/{id}
     * @secure
     */
    inhouseTrainingRequestUpdate: (
      id: string,
      data: UpdateInhouseTrainingRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: InhouseTrainingRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/inhouse-training/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestDelete
     * @summary Delete inhouse training request
     * @request DELETE:/api/v1/lms-requests/inhouse-training/{id}
     * @secure
     */
    inhouseTrainingRequestDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/inhouse-training/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Inhouse Training
     * @name InhouseTrainingRequestUpdateStatus
     * @summary Update inhouse training request status
     * @request PUT:/api/v1/lms-requests/inhouse-training/{id}/status
     * @secure
     */
    inhouseTrainingRequestUpdateStatus: (
      id: string,
      data: UpdateStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: InhouseTrainingRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/inhouse-training/${id}/status`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestCreate
     * @summary Create a new program consultation request
     * @request POST:/api/v1/lms-requests/program-consultation
     * @secure
     */
    programConsultationRequestCreate: (
      data: CreateProgramConsultationRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ProgramConsultationRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/program-consultation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestList
     * @summary Get all program consultation requests
     * @request GET:/api/v1/lms-requests/program-consultation
     * @secure
     */
    programConsultationRequestList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: ProgramConsultationRequestResponseDto[];
        },
        void
      >({
        path: `/api/v1/lms-requests/program-consultation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestExport
     * @summary Export program consultation requests to Excel
     * @request GET:/api/v1/lms-requests/program-consultation/export
     * @secure
     */
    programConsultationRequestExport: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /** Search by representative name, email, or phone number */
        search?: string;
        /** Filter by status */
        status?: string;
        /** Filter by assignee ID */
        assigneeId?: string;
        /** Start date for filtering requests (YYYY-MM-DD) */
        startDate?: string;
        /** End date for filtering requests (YYYY-MM-DD) */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/program-consultation/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestGetById
     * @summary Get program consultation request by ID
     * @request GET:/api/v1/lms-requests/program-consultation/{id}
     * @secure
     */
    programConsultationRequestGetById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ProgramConsultationRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/program-consultation/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestUpdate
     * @summary Update program consultation request
     * @request PUT:/api/v1/lms-requests/program-consultation/{id}
     * @secure
     */
    programConsultationRequestUpdate: (
      id: string,
      data: UpdateProgramConsultationRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ProgramConsultationRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/program-consultation/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestDelete
     * @summary Delete program consultation request
     * @request DELETE:/api/v1/lms-requests/program-consultation/{id}
     * @secure
     */
    programConsultationRequestDelete: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/lms-requests/program-consultation/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LMS Requests - Program Consultation
     * @name ProgramConsultationRequestUpdateStatus
     * @summary Update program consultation request status
     * @request PUT:/api/v1/lms-requests/program-consultation/{id}/status
     * @secure
     */
    programConsultationRequestUpdateStatus: (
      id: string,
      data: UpdateStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ProgramConsultationRequestResponseDto;
        },
        void
      >({
        path: `/api/v1/lms-requests/program-consultation/${id}/status`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LnD Courses
     * @name LndCoursesGetList
     * @summary Get all LnD courses
     * @request GET:/api/v1/lnd/courses
     */
    lndCoursesGetList: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        search?: string;
        isLnD?: boolean;
        isOnair?: boolean;
        displayed?: boolean;
        status?: OnlineCourseStatus;
        /** @format date-time */
        createdFrom?: string;
        /** @format date-time */
        createdTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: OnlineCourseV2SimplifiedDTO[];
        },
        any
      >({
        path: `/api/v1/lnd/courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin LnD Management - Internal
     * @name AdminLnDEnableCourse
     * @summary Enable LnD for online course
     * @request PATCH:/api/v1/admin/lnd/courses/{courseId}/enable
     */
    adminLnDEnableCourse: (courseId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
        },
        any
      >({
        path: `/api/v1/admin/lnd/courses/${courseId}/enable`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows a user to create a subscription email
     *
     * @tags Subscription Email
     * @name CreateSubscriptionEmail
     * @summary User creates a subscription email
     * @request POST:/api/v1/subscription-emails
     * @secure
     */
    createSubscriptionEmail: (
      data: SubscriptionEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/subscription-emails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows a user to create a subscription email specifically for Edoc
     *
     * @tags Subscription Email
     * @name CreateEdocSubscriptionEmail
     * @summary User creates a subscription email for Edoc
     * @request POST:/api/v1/subscription-emails/edoc
     * @secure
     */
    createEdocSubscriptionEmail: (
      data: EDocSubscriptionEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/subscription-emails/edoc`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of edocs with optional filters and sorting.
     *
     * @tags Edocs
     * @name GetEdocs
     * @summary Get a list of edocs
     * @request GET:/api/v1/edocs
     * @secure
     */
    getEdocs: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetEdocsDto[];
        },
        any
      >({
        path: `/api/v1/edocs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocGetList
     * @summary List Edocs with filters
     * @request GET:/api/v1/admin/edocs
     * @secure
     */
    adminEdocGetList: (
      query?: {
        /** Search by title or short description */
        search?: string;
        status?: "DRAFT" | "PUBLISHED";
        /** Published from date */
        fromDate?: string;
        /** Published to date */
        toDate?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocCreate
     * @summary Create Edoc (Draft or Publish)
     * @request POST:/api/v1/admin/edocs
     * @secure
     */
    adminEdocCreate: (data: CreateEdocDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocGetById
     * @summary Get Edoc detail
     * @request GET:/api/v1/admin/edocs/{id}
     * @secure
     */
    adminEdocGetById: (id: string, params: RequestParams = {}) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/edocs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocUpdate
     * @summary Update Edoc
     * @request PUT:/api/v1/admin/edocs/{id}
     * @secure
     */
    adminEdocUpdate: (
      id: string,
      data: UpdateEdocDto,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/edocs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocDelete
     * @summary Delete Edoc
     * @request DELETE:/api/v1/admin/edocs/{id}
     * @secure
     */
    adminEdocDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocPublish
     * @summary Publish Edoc
     * @request PATCH:/api/v1/admin/edocs/{id}/publish
     * @secure
     */
    adminEdocPublish: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs/${id}/publish`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocUnpublish
     * @summary Unpublish Edoc
     * @request PATCH:/api/v1/admin/edocs/{id}/unpublish
     * @secure
     */
    adminEdocUnpublish: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs/${id}/unpublish`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Edocs - Internal
     * @name AdminEdocToggleHidden
     * @summary Toggle hidden
     * @request PATCH:/api/v1/admin/edocs/{id}/hidden
     * @secure
     */
    adminEdocToggleHidden: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/edocs/${id}/hidden`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of subscription emails with optional filters.
     *
     * @tags Admin Subscription Email Management - Internal
     * @name AdminGetSubscriptionEmails
     * @summary Get all subscription emails
     * @request GET:/api/v1/admin/subscription-emails
     * @secure
     */
    adminGetSubscriptionEmails: (
      query?: {
        /**
         * Filter by from date
         * @format date-time
         */
        from?: string;
        /**
         * Filter by to date
         * @format date-time
         */
        to?: string;
        status?: SubscriptionEmailStatus;
        /** The assignee ID for the subscription email */
        assigneeId?: string;
        type?: SubscriptionEmailType;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetSubscriptionEmailsDto[];
        },
        any
      >({
        path: `/api/v1/admin/subscription-emails`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send an edoc subscription email to a user.
     *
     * @tags Admin Subscription Email Management - Internal
     * @name AdminSendEdocSubscriptionEmail
     * @summary Send edoc subscription email
     * @request POST:/api/v1/admin/subscription-emails/send-edoc
     * @secure
     */
    adminSendEdocSubscriptionEmail: (
      data: SendEdocDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/subscription-emails/send-edoc`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update the status of a specific subscription email.
     *
     * @tags Admin Subscription Email Management - Internal
     * @name AdminUpdateSubscriptionEmailStatus
     * @summary Update subscription email status
     * @request PATCH:/api/v1/admin/subscription-emails/{id}/update-status
     * @secure
     */
    adminUpdateSubscriptionEmailStatus: (
      id: string,
      data: UpdateSubscriptionEmailStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/subscription-emails/${id}/update-status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Export the list of subscription emails to an Excel file.
     *
     * @tags Admin Subscription Email Management - Internal
     * @name AdminExportSubscriptionEmails
     * @summary Export subscription emails to Excel
     * @request GET:/api/v1/admin/subscription-emails/export
     * @secure
     */
    adminExportSubscriptionEmails: (
      query?: {
        /**
         * Filter by from date
         * @format date-time
         */
        from?: string;
        /**
         * Filter by to date
         * @format date-time
         */
        to?: string;
        /** The status of the subscription email */
        status?: SubscriptionEmailStatus;
        /** The assignee ID for the subscription email */
        assigneeId?: string;
        /** The type of subscription email */
        type?: SubscriptionEmailType;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/subscription-emails/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Admin can retrieve surveys for any user
     *
     * @tags Admin Survey Management - Internal
     * @name AdminGetAllSurveys
     * @summary Admin get all surveys for any user
     * @request GET:/api/v1/admin/surveys/{userId}
     * @secure
     */
    adminGetAllSurveys: (
      userId: string,
      query?: {
        /** @format date-time */
        createdAt?: string;
        search?: string;
        ids?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: SurveyDetailsDTO[];
        },
        any
      >({
        path: `/api/v1/admin/surveys/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Business Challenges Management - Internal
     * @name GetBusinessChallenges
     * @summary Get a list of business challenges with optional filters and pagination
     * @request GET:/api/v1/admin/business-challenges
     * @secure
     */
    getBusinessChallenges: (
      query?: {
        /** Filter by status of the business challenge */
        status?: BusinessChallengeStatus;
        /**
         * Start date for filtering business challenges (ISO 8601 format)
         * @format date-time
         */
        from?: string;
        /**
         * End date for filtering business challenges (ISO 8601 format)
         * @format date-time
         */
        to?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetBizChallengesDto[];
        },
        any
      >({
        path: `/api/v1/admin/business-challenges`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Business Challenges Management - Internal
     * @name GetBusinessChallengesStatusCount
     * @summary Get counts of business challenges by their status
     * @request GET:/api/v1/admin/business-challenges/status-count
     * @secure
     */
    getBusinessChallengesStatusCount: (params: RequestParams = {}) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/business-challenges/status-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Business Challenges Management - Internal
     * @name ExportBusinessChallenges
     * @summary Export business challenges to an Excel file
     * @request GET:/api/v1/admin/business-challenges/export
     * @secure
     */
    exportBusinessChallenges: (
      query?: {
        /** Filter by status of the business challenge */
        status?: BusinessChallengeStatus;
        /**
         * Start date for filtering business challenges (ISO 8601 format)
         * @format date-time
         */
        from?: string;
        /**
         * End date for filtering business challenges (ISO 8601 format)
         * @format date-time
         */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/business-challenges/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Business Challenges Management - Internal
     * @name GetBusinessChallengeDetails
     * @summary Get details of a specific business challenge by ID
     * @request GET:/api/v1/admin/business-challenges/{id}
     * @secure
     */
    getBusinessChallengeDetails: (id: string, params: RequestParams = {}) =>
      this.request<GetBizChallengeDetailsDto, any>({
        path: `/api/v1/admin/business-challenges/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Business Challenges Management - Internal
     * @name UpdateBusinessChallenge
     * @summary Update details of a specific business challenge by ID
     * @request PATCH:/api/v1/admin/business-challenges/{id}
     * @secure
     */
    updateBusinessChallenge: (
      id: string,
      data: UpdateBizChallengeDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
        },
        any
      >({
        path: `/api/v1/admin/business-challenges/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name GetExpertRequests
     * @summary Get a list of expert requests with optional filters and pagination
     * @request GET:/api/v1/admin/expert-requests
     * @secure
     */
    getExpertRequests: (
      query?: {
        /** Filter by status of the expert request */
        status?: ExpertRequestStatus;
        /**
         * Start date for filtering expert requests (ISO 8601 format)
         * @format date-time
         */
        from?: string;
        /**
         * End date for filtering expert requests (ISO 8601 format)
         * @format date-time
         */
        to?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetExpertRequestsDto[];
        },
        any
      >({
        path: `/api/v1/admin/expert-requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name GetExpertRequestsStatusCount
     * @summary Get counts of expert requests by their status
     * @request GET:/api/v1/admin/expert-requests/status-count
     * @secure
     */
    getExpertRequestsStatusCount: (params: RequestParams = {}) =>
      this.request<ChangePasswordDto, any>({
        path: `/api/v1/admin/expert-requests/status-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name ExportExpertRequests
     * @summary Export expert requests to an Excel file
     * @request GET:/api/v1/admin/expert-requests/export
     * @secure
     */
    exportExpertRequests: (
      query?: {
        /** Filter by status of the expert request */
        status?: ExpertRequestStatus;
        /**
         * Start date for filtering expert requests (ISO 8601 format)
         * @format date-time
         */
        from?: string;
        /**
         * End date for filtering expert requests (ISO 8601 format)
         * @format date-time
         */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/expert-requests/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name GetExpertRequestDetails
     * @summary Get details of a specific expert request by ID
     * @request GET:/api/v1/admin/expert-requests/{id}
     * @secure
     */
    getExpertRequestDetails: (id: string, params: RequestParams = {}) =>
      this.request<GetExpertRequestDetailDto, any>({
        path: `/api/v1/admin/expert-requests/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name UpdateExpertRequest
     * @summary Update details of a specific expert request by ID
     * @request PATCH:/api/v1/admin/expert-requests/{id}
     * @secure
     */
    updateExpertRequest: (
      id: string,
      data: UpdateExpertRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
        },
        any
      >({
        path: `/api/v1/admin/expert-requests/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name ApproveExpertRequest
     * @summary Approve a specific expert request by ID
     * @request PUT:/api/v1/admin/expert-requests/{id}/approved
     * @secure
     */
    approveExpertRequest: (
      id: string,
      data: UpdateExpertRequestStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
        },
        any
      >({
        path: `/api/v1/admin/expert-requests/${id}/approved`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Expert Requests Management - Internal
     * @name RejectExpertRequest
     * @summary Reject a specific expert request by ID
     * @request PUT:/api/v1/admin/expert-requests/{id}/rejected
     * @secure
     */
    rejectExpertRequest: (
      id: string,
      data: UpdateExpertRequestStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
        },
        any
      >({
        path: `/api/v1/admin/expert-requests/${id}/rejected`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert Requests
     * @name CreateExpertRequest
     * @summary Create expert request
     * @request POST:/api/v1/expert-request
     */
    createExpertRequest: (
      data: CreateExpertRequestInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/expert-request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Business Challenges
     * @name CreateBusinessChallenges
     * @summary Create business challenges
     * @request POST:/api/v1/business-challenges
     * @secure
     */
    createBusinessChallenges: (
      data: CreateBusinessChallengeInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/business-challenges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name CreateEnterprisePlan
     * @summary Tạo gói doanh nghiệp mới
     * @request POST:/api/v1/admin/enterprise-plans
     * @secure
     */
    createEnterprisePlan: (
      data: CreateEnterprisePlanDto,
      params: RequestParams = {},
    ) =>
      this.request<GetEnterprisePlanDto, any>({
        path: `/api/v1/admin/enterprise-plans`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name GetEnterprisePlans
     * @summary Lấy danh sách các gói doanh nghiệp
     * @request GET:/api/v1/admin/enterprise-plans
     * @secure
     */
    getEnterprisePlans: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetEnterprisePlanDto[];
        },
        any
      >({
        path: `/api/v1/admin/enterprise-plans`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name GetAvailableEnterprisePlans
     * @summary Lấy danh sách các gói doanh nghiệp đang hoạt động
     * @request GET:/api/v1/admin/enterprise-plans/available
     * @secure
     */
    getAvailableEnterprisePlans: (params: RequestParams = {}) =>
      this.request<GetEnterprisePlanDto[], any>({
        path: `/api/v1/admin/enterprise-plans/available`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name GetEnterprisePlanById
     * @summary Lấy chi tiết một gói doanh nghiệp
     * @request GET:/api/v1/admin/enterprise-plans/{id}
     * @secure
     */
    getEnterprisePlanById: (id: string, params: RequestParams = {}) =>
      this.request<GetEnterprisePlanDto, any>({
        path: `/api/v1/admin/enterprise-plans/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name UpdateEnterprisePlan
     * @summary Cập nhật gói doanh nghiệp
     * @request PATCH:/api/v1/admin/enterprise-plans/{id}
     * @secure
     */
    updateEnterprisePlan: (
      id: string,
      data: UpdateEnterprisePlanDto,
      params: RequestParams = {},
    ) =>
      this.request<GetEnterprisePlanDto, any>({
        path: `/api/v1/admin/enterprise-plans/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Chỉ có thể xóa gói khi không có doanh nghiệp nào đang sử dụng
     *
     * @tags Admin Enterprise Plan Management - Internal
     * @name DeleteEnterprisePlan
     * @summary Xóa gói doanh nghiệp
     * @request DELETE:/api/v1/admin/enterprise-plans/{id}
     * @secure
     */
    deleteEnterprisePlan: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success?: boolean;
          /** @example "Xóa gói thành công" */
          message?: string;
        },
        any
      >({
        path: `/api/v1/admin/enterprise-plans/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Payment Management - Internal
     * @name GetEnterprisePayments
     * @summary get enterprise payments
     * @request GET:/api/v1/admin/enterprise-payments
     * @secure
     */
    getEnterprisePayments: (
      query?: {
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
        /**
         * Lọc theo tên doanh nghiệp
         * @example "FPT"
         */
        companyName?: string;
        /**
         * Lọc theo tên gói
         * @example "Gói Tháng"
         */
        planName?: string;
        /** Lọc theo ID gói đăng ký */
        planId?: string;
        /** Lọc theo trạng thái thanh toán */
        paymentStatus?: "PAID" | "PENDING" | "OVERDUE" | "PARTIALLY_PAID";
        /** Lọc theo trạng thái chu kỳ */
        cycleStatus?: "CURRENT" | "NEXT" | "EXPIRED";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: EnterprisePaymentListItemDto[];
        },
        any
      >({
        path: `/api/v1/admin/enterprise-payments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Payment Management - Internal
     * @name GetEnterprisePaymentDetail
     * @summary get enterprise payment
     * @request GET:/api/v1/admin/enterprise-payments/{id}
     * @secure
     */
    getEnterprisePaymentDetail: (id: string, params: RequestParams = {}) =>
      this.request<EnterprisePaymentDetailDto, any>({
        path: `/api/v1/admin/enterprise-payments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Payment Management - Internal
     * @name UpdateEnterprisePayment
     * @summary update enterprise payments
     * @request PATCH:/api/v1/admin/enterprise-payments/{id}
     * @secure
     */
    updateEnterprisePayment: (
      id: string,
      data: UpdateEnterprisePaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<EnterprisePaymentDetailDto, any>({
        path: `/api/v1/admin/enterprise-payments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Management - Internal
     * @name CreateEnterprise
     * @summary Create a new enterprise
     * @request POST:/api/v1/admin/enterprises
     * @secure
     */
    createEnterprise: (data: CreateEnterpriseDto, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/admin/enterprises`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Management - Internal
     * @name GetEnterprises
     * @summary Get list of enterprises
     * @request GET:/api/v1/admin/enterprises
     * @secure
     */
    getEnterprises: (
      query?: {
        /**
         * Filter by active status
         * @example true
         */
        isActive?: boolean;
        /** Filter by payment status */
        paymentStatus?: EnterprisePaymentStatus;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: GetEnterpriseResponse[];
        },
        any
      >({
        path: `/api/v1/admin/enterprises`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Management - Internal
     * @name GetEnterpriseById
     * @summary Get enterprise details by ID
     * @request GET:/api/v1/admin/enterprises/{id}
     * @secure
     */
    getEnterpriseById: (id: string, params: RequestParams = {}) =>
      this.request<GetEnterpriseResponse, any>({
        path: `/api/v1/admin/enterprises/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Management - Internal
     * @name UpdateEnterpriseById
     * @summary Update enterprise details by ID
     * @request PATCH:/api/v1/admin/enterprises/{id}
     * @secure
     */
    updateEnterpriseById: (
      id: string,
      data: UpdateEnterpriseDto,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/admin/enterprises/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Enterprise Management - Internal
     * @name DeleteEnterpriseById
     * @summary Delete enterprise by ID
     * @request DELETE:/api/v1/admin/enterprises/{id}
     * @secure
     */
    deleteEnterpriseById: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/admin/enterprises/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Records
     * @name CreatePaymentRecord
     * @request POST:/api/v1/payment-records
     * @secure
     */
    createPaymentRecord: (
      data: CreatePaymentRecordDTO,
      params: RequestParams = {},
    ) =>
      this.request<PaymentRecordDTO, any>({
        path: `/api/v1/payment-records`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Records
     * @name GetPaymentRecordCount
     * @request GET:/api/v1/payment-records/count
     * @secure
     */
    getPaymentRecordCount: (params: RequestParams = {}) =>
      this.request<PaymentRecordCountDTO, any>({
        path: `/api/v1/payment-records/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Records
     * @name GetPaymentRecordsByEventSlug
     * @request GET:/api/v1/payment-records/{slug}/items
     * @secure
     */
    getPaymentRecordsByEventSlug: (
      slug: string,
      query?: {
        search?: string | null;
        createdAtFrom?: string;
        createdAtTo?: string;
        filter?: string;
        cursor?: string;
        order?: OrderByEnum;
        orderField?: string;
        /**
         * @min 1
         * @default 1
         */
        offset?: number;
        /**
         * @min 1
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageDto & {
          items?: PaymentRecordWithEventSessionsDTO[];
        },
        any
      >({
        path: `/api/v1/payment-records/${slug}/items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Records
     * @name ExportPaymentRecordsByEventSlug
     * @request GET:/api/v1/payment-records/{slug}/export
     * @secure
     */
    exportPaymentRecordsByEventSlug: (
      slug: string,
      query?: {
        search?: string | null;
        createdAtFrom?: string;
        createdAtTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/payment-records/${slug}/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags HealthCheck
     * @name HealthCheck
     * @summary Health Check
     * @request GET:/v1/health
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/health`,
        method: "GET",
        ...params,
      }),
  };
}
